/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  GatsbyImageData: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type AvifOptions = {
  lossless?: InputMaybe<Scalars['Boolean']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  speed?: InputMaybe<Scalars['Int']['input']>;
};

export type BlurredOptions = {
  /** Force the output format for the low-res preview. Default is to use the same format as the input. You should rarely need to change this */
  toFormat?: InputMaybe<ImageFormat>;
  /** Width of the generated low-res preview. Default is 20px */
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type BooleanQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
};

export type DateQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  ne?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
};

export type Directory = Node & {
  __typename?: 'Directory';
  absolutePath: Scalars['String']['output'];
  accessTime: Scalars['Date']['output'];
  atime: Scalars['Date']['output'];
  atimeMs: Scalars['Float']['output'];
  base: Scalars['String']['output'];
  birthTime: Scalars['Date']['output'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']['output']>;
  changeTime: Scalars['Date']['output'];
  children: Array<Node>;
  ctime: Scalars['Date']['output'];
  ctimeMs: Scalars['Float']['output'];
  dev: Scalars['Int']['output'];
  dir: Scalars['String']['output'];
  ext: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  gid: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ino: Scalars['Float']['output'];
  internal: Internal;
  mode: Scalars['Int']['output'];
  modifiedTime: Scalars['Date']['output'];
  mtime: Scalars['Date']['output'];
  mtimeMs: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nlink: Scalars['Int']['output'];
  parent?: Maybe<Node>;
  prettySize: Scalars['String']['output'];
  rdev: Scalars['Int']['output'];
  relativeDirectory: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  root: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  sourceInstanceName: Scalars['String']['output'];
  uid: Scalars['Int']['output'];
};


export type DirectoryAccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryAtimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryBirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryChangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryCtimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryModifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type DirectoryMtimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type DirectoryConnection = {
  __typename?: 'DirectoryConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<DirectoryEdge>;
  group: Array<DirectoryGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type DirectoryConnectionDistinctArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionGroupArgs = {
  field: DirectoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectoryConnectionMaxArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionMinArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryConnectionSumArgs = {
  field: DirectoryFieldSelector;
};

export type DirectoryEdge = {
  __typename?: 'DirectoryEdge';
  next?: Maybe<Directory>;
  node: Directory;
  previous?: Maybe<Directory>;
};

export type DirectoryFieldSelector = {
  absolutePath?: InputMaybe<FieldSelectorEnum>;
  accessTime?: InputMaybe<FieldSelectorEnum>;
  atime?: InputMaybe<FieldSelectorEnum>;
  atimeMs?: InputMaybe<FieldSelectorEnum>;
  base?: InputMaybe<FieldSelectorEnum>;
  birthTime?: InputMaybe<FieldSelectorEnum>;
  birthtime?: InputMaybe<FieldSelectorEnum>;
  birthtimeMs?: InputMaybe<FieldSelectorEnum>;
  changeTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  ctime?: InputMaybe<FieldSelectorEnum>;
  ctimeMs?: InputMaybe<FieldSelectorEnum>;
  dev?: InputMaybe<FieldSelectorEnum>;
  dir?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  gid?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  ino?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mode?: InputMaybe<FieldSelectorEnum>;
  modifiedTime?: InputMaybe<FieldSelectorEnum>;
  mtime?: InputMaybe<FieldSelectorEnum>;
  mtimeMs?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  nlink?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  prettySize?: InputMaybe<FieldSelectorEnum>;
  rdev?: InputMaybe<FieldSelectorEnum>;
  relativeDirectory?: InputMaybe<FieldSelectorEnum>;
  relativePath?: InputMaybe<FieldSelectorEnum>;
  root?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  sourceInstanceName?: InputMaybe<FieldSelectorEnum>;
  uid?: InputMaybe<FieldSelectorEnum>;
};

export type DirectoryFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};

export type DirectoryGroupConnection = {
  __typename?: 'DirectoryGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<DirectoryEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<DirectoryGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<Directory>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type DirectoryGroupConnectionDistinctArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionGroupArgs = {
  field: DirectoryFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type DirectoryGroupConnectionMaxArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionMinArgs = {
  field: DirectoryFieldSelector;
};


export type DirectoryGroupConnectionSumArgs = {
  field: DirectoryFieldSelector;
};

export type DirectorySortInput = {
  absolutePath?: InputMaybe<SortOrderEnum>;
  accessTime?: InputMaybe<SortOrderEnum>;
  atime?: InputMaybe<SortOrderEnum>;
  atimeMs?: InputMaybe<SortOrderEnum>;
  base?: InputMaybe<SortOrderEnum>;
  birthTime?: InputMaybe<SortOrderEnum>;
  birthtime?: InputMaybe<SortOrderEnum>;
  birthtimeMs?: InputMaybe<SortOrderEnum>;
  changeTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  ctime?: InputMaybe<SortOrderEnum>;
  ctimeMs?: InputMaybe<SortOrderEnum>;
  dev?: InputMaybe<SortOrderEnum>;
  dir?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  gid?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  ino?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mode?: InputMaybe<SortOrderEnum>;
  modifiedTime?: InputMaybe<SortOrderEnum>;
  mtime?: InputMaybe<SortOrderEnum>;
  mtimeMs?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  nlink?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  prettySize?: InputMaybe<SortOrderEnum>;
  rdev?: InputMaybe<SortOrderEnum>;
  relativeDirectory?: InputMaybe<SortOrderEnum>;
  relativePath?: InputMaybe<SortOrderEnum>;
  root?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  sourceInstanceName?: InputMaybe<SortOrderEnum>;
  uid?: InputMaybe<SortOrderEnum>;
};

export type DuotoneGradient = {
  highlight: Scalars['String']['input'];
  opacity?: InputMaybe<Scalars['Int']['input']>;
  shadow: Scalars['String']['input'];
};

export enum FieldSelectorEnum {
  Select = 'SELECT'
}

export type File = Node & {
  __typename?: 'File';
  absolutePath: Scalars['String']['output'];
  accessTime: Scalars['Date']['output'];
  atime: Scalars['Date']['output'];
  atimeMs: Scalars['Float']['output'];
  base: Scalars['String']['output'];
  birthTime: Scalars['Date']['output'];
  /** @deprecated Use `birthTime` instead */
  birthtime?: Maybe<Scalars['Date']['output']>;
  /** @deprecated Use `birthTime` instead */
  birthtimeMs?: Maybe<Scalars['Float']['output']>;
  blksize?: Maybe<Scalars['Int']['output']>;
  blocks?: Maybe<Scalars['Int']['output']>;
  changeTime: Scalars['Date']['output'];
  /** Returns the first child node of type ImageSharp or null if there are no children of given type on this node */
  childImageSharp?: Maybe<ImageSharp>;
  children: Array<Node>;
  /** Returns all children nodes filtered by type ImageSharp */
  childrenImageSharp?: Maybe<Array<Maybe<ImageSharp>>>;
  ctime: Scalars['Date']['output'];
  ctimeMs: Scalars['Float']['output'];
  dev: Scalars['Int']['output'];
  dir: Scalars['String']['output'];
  ext: Scalars['String']['output'];
  extension: Scalars['String']['output'];
  gid: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  ino: Scalars['Float']['output'];
  internal: Internal;
  mode: Scalars['Int']['output'];
  modifiedTime: Scalars['Date']['output'];
  mtime: Scalars['Date']['output'];
  mtimeMs: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  nlink: Scalars['Int']['output'];
  parent?: Maybe<Node>;
  prettySize: Scalars['String']['output'];
  /** Copy file to static directory and return public url to it */
  publicURL?: Maybe<Scalars['String']['output']>;
  rdev: Scalars['Int']['output'];
  relativeDirectory: Scalars['String']['output'];
  relativePath: Scalars['String']['output'];
  root: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  sourceInstanceName: Scalars['String']['output'];
  uid: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type FileAccessTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FileAtimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FileBirthTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FileChangeTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FileCtimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FileModifiedTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};


export type FileMtimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type FileConnection = {
  __typename?: 'FileConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<FileEdge>;
  group: Array<FileGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type FileConnectionDistinctArgs = {
  field: FileFieldSelector;
};


export type FileConnectionGroupArgs = {
  field: FileFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FileConnectionMaxArgs = {
  field: FileFieldSelector;
};


export type FileConnectionMinArgs = {
  field: FileFieldSelector;
};


export type FileConnectionSumArgs = {
  field: FileFieldSelector;
};

export type FileEdge = {
  __typename?: 'FileEdge';
  next?: Maybe<File>;
  node: File;
  previous?: Maybe<File>;
};

export type FileFieldSelector = {
  absolutePath?: InputMaybe<FieldSelectorEnum>;
  accessTime?: InputMaybe<FieldSelectorEnum>;
  atime?: InputMaybe<FieldSelectorEnum>;
  atimeMs?: InputMaybe<FieldSelectorEnum>;
  base?: InputMaybe<FieldSelectorEnum>;
  birthTime?: InputMaybe<FieldSelectorEnum>;
  birthtime?: InputMaybe<FieldSelectorEnum>;
  birthtimeMs?: InputMaybe<FieldSelectorEnum>;
  blksize?: InputMaybe<FieldSelectorEnum>;
  blocks?: InputMaybe<FieldSelectorEnum>;
  changeTime?: InputMaybe<FieldSelectorEnum>;
  childImageSharp?: InputMaybe<ImageSharpFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  childrenImageSharp?: InputMaybe<ImageSharpFieldSelector>;
  ctime?: InputMaybe<FieldSelectorEnum>;
  ctimeMs?: InputMaybe<FieldSelectorEnum>;
  dev?: InputMaybe<FieldSelectorEnum>;
  dir?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  extension?: InputMaybe<FieldSelectorEnum>;
  gid?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  ino?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mode?: InputMaybe<FieldSelectorEnum>;
  modifiedTime?: InputMaybe<FieldSelectorEnum>;
  mtime?: InputMaybe<FieldSelectorEnum>;
  mtimeMs?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  nlink?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  prettySize?: InputMaybe<FieldSelectorEnum>;
  publicURL?: InputMaybe<FieldSelectorEnum>;
  rdev?: InputMaybe<FieldSelectorEnum>;
  relativeDirectory?: InputMaybe<FieldSelectorEnum>;
  relativePath?: InputMaybe<FieldSelectorEnum>;
  root?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  sourceInstanceName?: InputMaybe<FieldSelectorEnum>;
  uid?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
};

export type FileFilterInput = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  blksize?: InputMaybe<IntQueryOperatorInput>;
  blocks?: InputMaybe<IntQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  childImageSharp?: InputMaybe<ImageSharpFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  childrenImageSharp?: InputMaybe<ImageSharpFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  publicURL?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

export type FileGroupConnection = {
  __typename?: 'FileGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<FileEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<FileGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<File>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type FileGroupConnectionDistinctArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionGroupArgs = {
  field: FileFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type FileGroupConnectionMaxArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionMinArgs = {
  field: FileFieldSelector;
};


export type FileGroupConnectionSumArgs = {
  field: FileFieldSelector;
};

export type FileSortInput = {
  absolutePath?: InputMaybe<SortOrderEnum>;
  accessTime?: InputMaybe<SortOrderEnum>;
  atime?: InputMaybe<SortOrderEnum>;
  atimeMs?: InputMaybe<SortOrderEnum>;
  base?: InputMaybe<SortOrderEnum>;
  birthTime?: InputMaybe<SortOrderEnum>;
  birthtime?: InputMaybe<SortOrderEnum>;
  birthtimeMs?: InputMaybe<SortOrderEnum>;
  blksize?: InputMaybe<SortOrderEnum>;
  blocks?: InputMaybe<SortOrderEnum>;
  changeTime?: InputMaybe<SortOrderEnum>;
  childImageSharp?: InputMaybe<ImageSharpSortInput>;
  children?: InputMaybe<NodeSortInput>;
  childrenImageSharp?: InputMaybe<ImageSharpSortInput>;
  ctime?: InputMaybe<SortOrderEnum>;
  ctimeMs?: InputMaybe<SortOrderEnum>;
  dev?: InputMaybe<SortOrderEnum>;
  dir?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  extension?: InputMaybe<SortOrderEnum>;
  gid?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  ino?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mode?: InputMaybe<SortOrderEnum>;
  modifiedTime?: InputMaybe<SortOrderEnum>;
  mtime?: InputMaybe<SortOrderEnum>;
  mtimeMs?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  nlink?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  prettySize?: InputMaybe<SortOrderEnum>;
  publicURL?: InputMaybe<SortOrderEnum>;
  rdev?: InputMaybe<SortOrderEnum>;
  relativeDirectory?: InputMaybe<SortOrderEnum>;
  relativePath?: InputMaybe<SortOrderEnum>;
  root?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  sourceInstanceName?: InputMaybe<SortOrderEnum>;
  uid?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
};

export type FloatQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type GatsbyImageDataQueryOperatorInput = {
  eq?: InputMaybe<Scalars['GatsbyImageData']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['GatsbyImageData']['input']>>>;
  ne?: InputMaybe<Scalars['GatsbyImageData']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['GatsbyImageData']['input']>>>;
};

export enum GatsbyImageFormat {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Jpg = 'JPG',
  NoChange = 'NO_CHANGE',
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum GatsbyImageLayout {
  Constrained = 'CONSTRAINED',
  Fixed = 'FIXED',
  FullWidth = 'FULL_WIDTH'
}

export enum GatsbyImagePlaceholder {
  Blurred = 'BLURRED',
  DominantColor = 'DOMINANT_COLOR',
  None = 'NONE',
  TracedSvg = 'TRACED_SVG'
}

export type IdQueryOperatorInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum ImageCropFocus {
  Attention = 'ATTENTION',
  Center = 'CENTER',
  East = 'EAST',
  Entropy = 'ENTROPY',
  North = 'NORTH',
  Northeast = 'NORTHEAST',
  Northwest = 'NORTHWEST',
  South = 'SOUTH',
  Southeast = 'SOUTHEAST',
  Southwest = 'SOUTHWEST',
  West = 'WEST'
}

export enum ImageFit {
  Contain = 'CONTAIN',
  Cover = 'COVER',
  Fill = 'FILL',
  Inside = 'INSIDE',
  Outside = 'OUTSIDE'
}

export enum ImageFormat {
  Auto = 'AUTO',
  Avif = 'AVIF',
  Jpg = 'JPG',
  NoChange = 'NO_CHANGE',
  Png = 'PNG',
  Webp = 'WEBP'
}

export enum ImageLayout {
  Constrained = 'CONSTRAINED',
  Fixed = 'FIXED',
  FullWidth = 'FULL_WIDTH'
}

export enum ImagePlaceholder {
  Blurred = 'BLURRED',
  DominantColor = 'DOMINANT_COLOR',
  None = 'NONE',
  TracedSvg = 'TRACED_SVG'
}

export type ImageSharp = Node & {
  __typename?: 'ImageSharp';
  children: Array<Node>;
  fixed?: Maybe<ImageSharpFixed>;
  fluid?: Maybe<ImageSharpFluid>;
  gatsbyImageData: Scalars['GatsbyImageData']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  original?: Maybe<ImageSharpOriginal>;
  parent?: Maybe<Node>;
  resize?: Maybe<ImageSharpResize>;
};


export type ImageSharpFixedArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  base64Width?: InputMaybe<Scalars['Int']['input']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']['input']>;
  jpegQuality?: InputMaybe<Scalars['Int']['input']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']['input']>;
  pngQuality?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  rotate?: InputMaybe<Scalars['Int']['input']>;
  toFormat?: InputMaybe<ImageFormat>;
  toFormatBase64?: InputMaybe<ImageFormat>;
  traceSVG?: InputMaybe<Potrace>;
  trim?: InputMaybe<Scalars['Float']['input']>;
  webpQuality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageSharpFluidArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  base64Width?: InputMaybe<Scalars['Int']['input']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']['input']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']['input']>;
  jpegQuality?: InputMaybe<Scalars['Int']['input']>;
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']['input']>;
  pngQuality?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  rotate?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  srcSetBreakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  toFormat?: InputMaybe<ImageFormat>;
  toFormatBase64?: InputMaybe<ImageFormat>;
  traceSVG?: InputMaybe<Potrace>;
  trim?: InputMaybe<Scalars['Float']['input']>;
  webpQuality?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageSharpGatsbyImageDataArgs = {
  aspectRatio?: InputMaybe<Scalars['Float']['input']>;
  avifOptions?: InputMaybe<AvifOptions>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  blurredOptions?: InputMaybe<BlurredOptions>;
  breakpoints?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  formats?: InputMaybe<Array<InputMaybe<ImageFormat>>>;
  height?: InputMaybe<Scalars['Int']['input']>;
  jpgOptions?: InputMaybe<JpgOptions>;
  layout?: InputMaybe<ImageLayout>;
  outputPixelDensities?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  placeholder?: InputMaybe<ImagePlaceholder>;
  pngOptions?: InputMaybe<PngOptions>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Scalars['String']['input']>;
  tracedSVGOptions?: InputMaybe<Potrace>;
  transformOptions?: InputMaybe<TransformOptions>;
  webpOptions?: InputMaybe<WebPOptions>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageSharpResizeArgs = {
  background?: InputMaybe<Scalars['String']['input']>;
  base64?: InputMaybe<Scalars['Boolean']['input']>;
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  jpegProgressive?: InputMaybe<Scalars['Boolean']['input']>;
  jpegQuality?: InputMaybe<Scalars['Int']['input']>;
  pngCompressionLevel?: InputMaybe<Scalars['Int']['input']>;
  pngCompressionSpeed?: InputMaybe<Scalars['Int']['input']>;
  pngQuality?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  rotate?: InputMaybe<Scalars['Int']['input']>;
  toFormat?: InputMaybe<ImageFormat>;
  traceSVG?: InputMaybe<Potrace>;
  trim?: InputMaybe<Scalars['Float']['input']>;
  webpQuality?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type ImageSharpConnection = {
  __typename?: 'ImageSharpConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<ImageSharpEdge>;
  group: Array<ImageSharpGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type ImageSharpConnectionDistinctArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpConnectionGroupArgs = {
  field: ImageSharpFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageSharpConnectionMaxArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpConnectionMinArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpConnectionSumArgs = {
  field: ImageSharpFieldSelector;
};

export type ImageSharpEdge = {
  __typename?: 'ImageSharpEdge';
  next?: Maybe<ImageSharp>;
  node: ImageSharp;
  previous?: Maybe<ImageSharp>;
};

export type ImageSharpFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  fixed?: InputMaybe<ImageSharpFixedFieldSelector>;
  fluid?: InputMaybe<ImageSharpFluidFieldSelector>;
  gatsbyImageData?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  original?: InputMaybe<ImageSharpOriginalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  resize?: InputMaybe<ImageSharpResizeFieldSelector>;
};

export type ImageSharpFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  fixed?: InputMaybe<ImageSharpFixedFilterInput>;
  fluid?: InputMaybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  original?: InputMaybe<ImageSharpOriginalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  resize?: InputMaybe<ImageSharpResizeFilterInput>;
};

export type ImageSharpFilterListInput = {
  elemMatch?: InputMaybe<ImageSharpFilterInput>;
};

export type ImageSharpFixed = {
  __typename?: 'ImageSharpFixed';
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  base64?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  originalName?: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
  srcSet: Scalars['String']['output'];
  srcSetWebp?: Maybe<Scalars['String']['output']>;
  srcWebp?: Maybe<Scalars['String']['output']>;
  tracedSVG?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
};

export type ImageSharpFixedFieldSelector = {
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  base64?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  originalName?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  srcSet?: InputMaybe<FieldSelectorEnum>;
  srcSetWebp?: InputMaybe<FieldSelectorEnum>;
  srcWebp?: InputMaybe<FieldSelectorEnum>;
  tracedSVG?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpFixedFilterInput = {
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  base64?: InputMaybe<StringQueryOperatorInput>;
  height?: InputMaybe<FloatQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
};

export type ImageSharpFixedSortInput = {
  aspectRatio?: InputMaybe<SortOrderEnum>;
  base64?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  originalName?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  srcSet?: InputMaybe<SortOrderEnum>;
  srcSetWebp?: InputMaybe<SortOrderEnum>;
  srcWebp?: InputMaybe<SortOrderEnum>;
  tracedSVG?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpFluid = {
  __typename?: 'ImageSharpFluid';
  aspectRatio: Scalars['Float']['output'];
  base64?: Maybe<Scalars['String']['output']>;
  originalImg?: Maybe<Scalars['String']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  presentationHeight: Scalars['Int']['output'];
  presentationWidth: Scalars['Int']['output'];
  sizes: Scalars['String']['output'];
  src: Scalars['String']['output'];
  srcSet: Scalars['String']['output'];
  srcSetWebp?: Maybe<Scalars['String']['output']>;
  srcWebp?: Maybe<Scalars['String']['output']>;
  tracedSVG?: Maybe<Scalars['String']['output']>;
};

export type ImageSharpFluidFieldSelector = {
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  base64?: InputMaybe<FieldSelectorEnum>;
  originalImg?: InputMaybe<FieldSelectorEnum>;
  originalName?: InputMaybe<FieldSelectorEnum>;
  presentationHeight?: InputMaybe<FieldSelectorEnum>;
  presentationWidth?: InputMaybe<FieldSelectorEnum>;
  sizes?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  srcSet?: InputMaybe<FieldSelectorEnum>;
  srcSetWebp?: InputMaybe<FieldSelectorEnum>;
  srcWebp?: InputMaybe<FieldSelectorEnum>;
  tracedSVG?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpFluidFilterInput = {
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  base64?: InputMaybe<StringQueryOperatorInput>;
  originalImg?: InputMaybe<StringQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  presentationHeight?: InputMaybe<IntQueryOperatorInput>;
  presentationWidth?: InputMaybe<IntQueryOperatorInput>;
  sizes?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  srcSet?: InputMaybe<StringQueryOperatorInput>;
  srcSetWebp?: InputMaybe<StringQueryOperatorInput>;
  srcWebp?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
};

export type ImageSharpFluidSortInput = {
  aspectRatio?: InputMaybe<SortOrderEnum>;
  base64?: InputMaybe<SortOrderEnum>;
  originalImg?: InputMaybe<SortOrderEnum>;
  originalName?: InputMaybe<SortOrderEnum>;
  presentationHeight?: InputMaybe<SortOrderEnum>;
  presentationWidth?: InputMaybe<SortOrderEnum>;
  sizes?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  srcSet?: InputMaybe<SortOrderEnum>;
  srcSetWebp?: InputMaybe<SortOrderEnum>;
  srcWebp?: InputMaybe<SortOrderEnum>;
  tracedSVG?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpGroupConnection = {
  __typename?: 'ImageSharpGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<ImageSharpEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<ImageSharpGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<ImageSharp>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type ImageSharpGroupConnectionDistinctArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpGroupConnectionGroupArgs = {
  field: ImageSharpFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type ImageSharpGroupConnectionMaxArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpGroupConnectionMinArgs = {
  field: ImageSharpFieldSelector;
};


export type ImageSharpGroupConnectionSumArgs = {
  field: ImageSharpFieldSelector;
};

export type ImageSharpOriginal = {
  __typename?: 'ImageSharpOriginal';
  height?: Maybe<Scalars['Float']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Float']['output']>;
};

export type ImageSharpOriginalFieldSelector = {
  height?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpOriginalFilterInput = {
  height?: InputMaybe<FloatQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<FloatQueryOperatorInput>;
};

export type ImageSharpOriginalSortInput = {
  height?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpResize = {
  __typename?: 'ImageSharpResize';
  aspectRatio?: Maybe<Scalars['Float']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  originalName?: Maybe<Scalars['String']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  tracedSVG?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ImageSharpResizeFieldSelector = {
  aspectRatio?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  originalName?: InputMaybe<FieldSelectorEnum>;
  src?: InputMaybe<FieldSelectorEnum>;
  tracedSVG?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type ImageSharpResizeFilterInput = {
  aspectRatio?: InputMaybe<FloatQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  originalName?: InputMaybe<StringQueryOperatorInput>;
  src?: InputMaybe<StringQueryOperatorInput>;
  tracedSVG?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};

export type ImageSharpResizeSortInput = {
  aspectRatio?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  originalName?: InputMaybe<SortOrderEnum>;
  src?: InputMaybe<SortOrderEnum>;
  tracedSVG?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type ImageSharpSortInput = {
  children?: InputMaybe<NodeSortInput>;
  fixed?: InputMaybe<ImageSharpFixedSortInput>;
  fluid?: InputMaybe<ImageSharpFluidSortInput>;
  gatsbyImageData?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  original?: InputMaybe<ImageSharpOriginalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  resize?: InputMaybe<ImageSharpResizeSortInput>;
};

export type IntQueryOperatorInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type Internal = {
  __typename?: 'Internal';
  content?: Maybe<Scalars['String']['output']>;
  contentDigest: Scalars['String']['output'];
  contentFilePath?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldOwners?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ignoreType?: Maybe<Scalars['Boolean']['output']>;
  mediaType?: Maybe<Scalars['String']['output']>;
  owner: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type InternalFieldSelector = {
  content?: InputMaybe<FieldSelectorEnum>;
  contentDigest?: InputMaybe<FieldSelectorEnum>;
  contentFilePath?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  fieldOwners?: InputMaybe<FieldSelectorEnum>;
  ignoreType?: InputMaybe<FieldSelectorEnum>;
  mediaType?: InputMaybe<FieldSelectorEnum>;
  owner?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
};

export type InternalFilterInput = {
  content?: InputMaybe<StringQueryOperatorInput>;
  contentDigest?: InputMaybe<StringQueryOperatorInput>;
  contentFilePath?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  fieldOwners?: InputMaybe<StringQueryOperatorInput>;
  ignoreType?: InputMaybe<BooleanQueryOperatorInput>;
  mediaType?: InputMaybe<StringQueryOperatorInput>;
  owner?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
};

export type InternalSortInput = {
  content?: InputMaybe<SortOrderEnum>;
  contentDigest?: InputMaybe<SortOrderEnum>;
  contentFilePath?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  fieldOwners?: InputMaybe<SortOrderEnum>;
  ignoreType?: InputMaybe<SortOrderEnum>;
  mediaType?: InputMaybe<SortOrderEnum>;
  owner?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
};

export type JpgOptions = {
  progressive?: InputMaybe<Scalars['Boolean']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonQueryOperatorInput = {
  eq?: InputMaybe<Scalars['JSON']['input']>;
  glob?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  regex?: InputMaybe<Scalars['JSON']['input']>;
};

/** Node Interface */
export type Node = {
  children: Array<Node>;
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
};

export type NodeFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type NodeFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type NodeFilterListInput = {
  elemMatch?: InputMaybe<NodeFilterInput>;
};

export type NodeSortInput = {
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type PngOptions = {
  compressionSpeed?: InputMaybe<Scalars['Int']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  currentPage: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  perPage?: Maybe<Scalars['Int']['output']>;
  totalCount: Scalars['Int']['output'];
};

export type Potrace = {
  alphaMax?: InputMaybe<Scalars['Float']['input']>;
  background?: InputMaybe<Scalars['String']['input']>;
  blackOnWhite?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  optCurve?: InputMaybe<Scalars['Boolean']['input']>;
  optTolerance?: InputMaybe<Scalars['Float']['input']>;
  threshold?: InputMaybe<Scalars['Int']['input']>;
  turdSize?: InputMaybe<Scalars['Float']['input']>;
  turnPolicy?: InputMaybe<PotraceTurnPolicy>;
};

export enum PotraceTurnPolicy {
  TurnpolicyBlack = 'TURNPOLICY_BLACK',
  TurnpolicyLeft = 'TURNPOLICY_LEFT',
  TurnpolicyMajority = 'TURNPOLICY_MAJORITY',
  TurnpolicyMinority = 'TURNPOLICY_MINORITY',
  TurnpolicyRight = 'TURNPOLICY_RIGHT',
  TurnpolicyWhite = 'TURNPOLICY_WHITE'
}

export type Query = {
  __typename?: 'Query';
  allDirectory: DirectoryConnection;
  allFile: FileConnection;
  allImageSharp: ImageSharpConnection;
  allSensaiActivate: SensaiActivateConnection;
  allSensaiAppPage: SensaiAppPageConnection;
  allSensaiArticle: SensaiArticleConnection;
  allSensaiArticleTags: SensaiArticleTagsConnection;
  allSensaiEmailConfirmation: SensaiEmailConfirmationConnection;
  allSensaiFooter: SensaiFooterConnection;
  allSensaiFreshChatWidget: SensaiFreshChatWidgetConnection;
  allSensaiFreshDeskWidget: SensaiFreshDeskWidgetConnection;
  allSensaiGifts: SensaiGiftsConnection;
  allSensaiLandingPages: SensaiLandingPagesConnection;
  allSensaiMemberships: SensaiMembershipsConnection;
  allSensaiNavigation: SensaiNavigationConnection;
  allSensaiNotFound: SensaiNotFoundConnection;
  allSensaiPage: SensaiPageConnection;
  allSensaiPaymentSuccess: SensaiPaymentSuccessConnection;
  allSensaiPrivacyAndTerms: SensaiPrivacyAndTermsConnection;
  allSensaiProduct: SensaiProductConnection;
  allSensaiSiteConfig: SensaiSiteConfigConnection;
  allSensaiSubscriptionSuccess: SensaiSubscriptionSuccessConnection;
  allSensaiTables: SensaiTablesConnection;
  allSensaiTestimonials: SensaiTestimonialsConnection;
  allSensaiUploadFile: SensaiUploadFileConnection;
  allSite: SiteConnection;
  allSiteBuildMetadata: SiteBuildMetadataConnection;
  allSiteFunction: SiteFunctionConnection;
  allSitePage: SitePageConnection;
  allSitePlugin: SitePluginConnection;
  allStripePrice: StripePriceConnection;
  allStripePriceProductMetadata: StripePriceProductMetadataConnection;
  allStripeProduct: StripeProductConnection;
  directory?: Maybe<Directory>;
  file?: Maybe<File>;
  imageSharp?: Maybe<ImageSharp>;
  sensaiActivate?: Maybe<SensaiActivate>;
  sensaiAppPage?: Maybe<SensaiAppPage>;
  sensaiArticle?: Maybe<SensaiArticle>;
  sensaiArticleTags?: Maybe<SensaiArticleTags>;
  sensaiEmailConfirmation?: Maybe<SensaiEmailConfirmation>;
  sensaiFooter?: Maybe<SensaiFooter>;
  sensaiFreshChatWidget?: Maybe<SensaiFreshChatWidget>;
  sensaiFreshDeskWidget?: Maybe<SensaiFreshDeskWidget>;
  sensaiGifts?: Maybe<SensaiGifts>;
  sensaiLandingPages?: Maybe<SensaiLandingPages>;
  sensaiMemberships?: Maybe<SensaiMemberships>;
  sensaiNavigation?: Maybe<SensaiNavigation>;
  sensaiNotFound?: Maybe<SensaiNotFound>;
  sensaiPage?: Maybe<SensaiPage>;
  sensaiPaymentSuccess?: Maybe<SensaiPaymentSuccess>;
  sensaiPrivacyAndTerms?: Maybe<SensaiPrivacyAndTerms>;
  sensaiProduct?: Maybe<SensaiProduct>;
  sensaiSiteConfig?: Maybe<SensaiSiteConfig>;
  sensaiSubscriptionSuccess?: Maybe<SensaiSubscriptionSuccess>;
  sensaiTables?: Maybe<SensaiTables>;
  sensaiTestimonials?: Maybe<SensaiTestimonials>;
  sensaiUploadFile?: Maybe<SensaiUploadFile>;
  site?: Maybe<Site>;
  siteBuildMetadata?: Maybe<SiteBuildMetadata>;
  siteFunction?: Maybe<SiteFunction>;
  sitePage?: Maybe<SitePage>;
  sitePlugin?: Maybe<SitePlugin>;
  stripePrice?: Maybe<StripePrice>;
  stripePriceProductMetadata?: Maybe<StripePriceProductMetadata>;
  stripeProduct?: Maybe<StripeProduct>;
};


export type QueryAllDirectoryArgs = {
  filter?: InputMaybe<DirectoryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<DirectorySortInput>>>;
};


export type QueryAllFileArgs = {
  filter?: InputMaybe<FileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<FileSortInput>>>;
};


export type QueryAllImageSharpArgs = {
  filter?: InputMaybe<ImageSharpFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ImageSharpSortInput>>>;
};


export type QueryAllSensaiActivateArgs = {
  filter?: InputMaybe<SensaiActivateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiActivateSortInput>>>;
};


export type QueryAllSensaiAppPageArgs = {
  filter?: InputMaybe<SensaiAppPageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiAppPageSortInput>>>;
};


export type QueryAllSensaiArticleArgs = {
  filter?: InputMaybe<SensaiArticleFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiArticleSortInput>>>;
};


export type QueryAllSensaiArticleTagsArgs = {
  filter?: InputMaybe<SensaiArticleTagsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiArticleTagsSortInput>>>;
};


export type QueryAllSensaiEmailConfirmationArgs = {
  filter?: InputMaybe<SensaiEmailConfirmationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiEmailConfirmationSortInput>>>;
};


export type QueryAllSensaiFooterArgs = {
  filter?: InputMaybe<SensaiFooterFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiFooterSortInput>>>;
};


export type QueryAllSensaiFreshChatWidgetArgs = {
  filter?: InputMaybe<SensaiFreshChatWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiFreshChatWidgetSortInput>>>;
};


export type QueryAllSensaiFreshDeskWidgetArgs = {
  filter?: InputMaybe<SensaiFreshDeskWidgetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiFreshDeskWidgetSortInput>>>;
};


export type QueryAllSensaiGiftsArgs = {
  filter?: InputMaybe<SensaiGiftsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiGiftsSortInput>>>;
};


export type QueryAllSensaiLandingPagesArgs = {
  filter?: InputMaybe<SensaiLandingPagesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiLandingPagesSortInput>>>;
};


export type QueryAllSensaiMembershipsArgs = {
  filter?: InputMaybe<SensaiMembershipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiMembershipsSortInput>>>;
};


export type QueryAllSensaiNavigationArgs = {
  filter?: InputMaybe<SensaiNavigationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiNavigationSortInput>>>;
};


export type QueryAllSensaiNotFoundArgs = {
  filter?: InputMaybe<SensaiNotFoundFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiNotFoundSortInput>>>;
};


export type QueryAllSensaiPageArgs = {
  filter?: InputMaybe<SensaiPageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiPageSortInput>>>;
};


export type QueryAllSensaiPaymentSuccessArgs = {
  filter?: InputMaybe<SensaiPaymentSuccessFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiPaymentSuccessSortInput>>>;
};


export type QueryAllSensaiPrivacyAndTermsArgs = {
  filter?: InputMaybe<SensaiPrivacyAndTermsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiPrivacyAndTermsSortInput>>>;
};


export type QueryAllSensaiProductArgs = {
  filter?: InputMaybe<SensaiProductFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiProductSortInput>>>;
};


export type QueryAllSensaiSiteConfigArgs = {
  filter?: InputMaybe<SensaiSiteConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiSiteConfigSortInput>>>;
};


export type QueryAllSensaiSubscriptionSuccessArgs = {
  filter?: InputMaybe<SensaiSubscriptionSuccessFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiSubscriptionSuccessSortInput>>>;
};


export type QueryAllSensaiTablesArgs = {
  filter?: InputMaybe<SensaiTablesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiTablesSortInput>>>;
};


export type QueryAllSensaiTestimonialsArgs = {
  filter?: InputMaybe<SensaiTestimonialsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiTestimonialsSortInput>>>;
};


export type QueryAllSensaiUploadFileArgs = {
  filter?: InputMaybe<SensaiUploadFileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SensaiUploadFileSortInput>>>;
};


export type QueryAllSiteArgs = {
  filter?: InputMaybe<SiteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SiteSortInput>>>;
};


export type QueryAllSiteBuildMetadataArgs = {
  filter?: InputMaybe<SiteBuildMetadataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SiteBuildMetadataSortInput>>>;
};


export type QueryAllSiteFunctionArgs = {
  filter?: InputMaybe<SiteFunctionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SiteFunctionSortInput>>>;
};


export type QueryAllSitePageArgs = {
  filter?: InputMaybe<SitePageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SitePageSortInput>>>;
};


export type QueryAllSitePluginArgs = {
  filter?: InputMaybe<SitePluginFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SitePluginSortInput>>>;
};


export type QueryAllStripePriceArgs = {
  filter?: InputMaybe<StripePriceFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StripePriceSortInput>>>;
};


export type QueryAllStripePriceProductMetadataArgs = {
  filter?: InputMaybe<StripePriceProductMetadataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StripePriceProductMetadataSortInput>>>;
};


export type QueryAllStripeProductArgs = {
  filter?: InputMaybe<StripeProductFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<StripeProductSortInput>>>;
};


export type QueryDirectoryArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
};


export type QueryFileArgs = {
  absolutePath?: InputMaybe<StringQueryOperatorInput>;
  accessTime?: InputMaybe<DateQueryOperatorInput>;
  atime?: InputMaybe<DateQueryOperatorInput>;
  atimeMs?: InputMaybe<FloatQueryOperatorInput>;
  base?: InputMaybe<StringQueryOperatorInput>;
  birthTime?: InputMaybe<DateQueryOperatorInput>;
  birthtime?: InputMaybe<DateQueryOperatorInput>;
  birthtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  blksize?: InputMaybe<IntQueryOperatorInput>;
  blocks?: InputMaybe<IntQueryOperatorInput>;
  changeTime?: InputMaybe<DateQueryOperatorInput>;
  childImageSharp?: InputMaybe<ImageSharpFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  childrenImageSharp?: InputMaybe<ImageSharpFilterListInput>;
  ctime?: InputMaybe<DateQueryOperatorInput>;
  ctimeMs?: InputMaybe<FloatQueryOperatorInput>;
  dev?: InputMaybe<IntQueryOperatorInput>;
  dir?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  extension?: InputMaybe<StringQueryOperatorInput>;
  gid?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  ino?: InputMaybe<FloatQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mode?: InputMaybe<IntQueryOperatorInput>;
  modifiedTime?: InputMaybe<DateQueryOperatorInput>;
  mtime?: InputMaybe<DateQueryOperatorInput>;
  mtimeMs?: InputMaybe<FloatQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nlink?: InputMaybe<IntQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  prettySize?: InputMaybe<StringQueryOperatorInput>;
  publicURL?: InputMaybe<StringQueryOperatorInput>;
  rdev?: InputMaybe<IntQueryOperatorInput>;
  relativeDirectory?: InputMaybe<StringQueryOperatorInput>;
  relativePath?: InputMaybe<StringQueryOperatorInput>;
  root?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<IntQueryOperatorInput>;
  sourceInstanceName?: InputMaybe<StringQueryOperatorInput>;
  uid?: InputMaybe<IntQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};


export type QueryImageSharpArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  fixed?: InputMaybe<ImageSharpFixedFilterInput>;
  fluid?: InputMaybe<ImageSharpFluidFilterInput>;
  gatsbyImageData?: InputMaybe<GatsbyImageDataQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  original?: InputMaybe<ImageSharpOriginalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  resize?: InputMaybe<ImageSharpResizeFilterInput>;
};


export type QuerySensaiActivateArgs = {
  activePage?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  landingNotLoggedIn?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  media?: InputMaybe<SensaiUploadFileFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  products?: InputMaybe<SensaiProductFilterListInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  trialMember?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiAppPageArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiArticleArgs = {
  articleDisclaimer?: InputMaybe<SensaiDisclaimerFilterInput>;
  articleTag?: InputMaybe<SensaiArticleTagsFilterInput>;
  author?: InputMaybe<SensaiAuthorsFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SensaiUploadFileFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  previewOnly?: InputMaybe<BooleanQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiArticleTagsArgs = {
  article?: InputMaybe<SensaiArticleFilterListInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  tagName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiEmailConfirmationArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  confirmationLandingPage?: InputMaybe<SensaiLandingPagesFilterInput>;
  confirmationPage?: InputMaybe<SensaiPageFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiFooterArgs = {
  activeCampaignListId?: InputMaybe<StringQueryOperatorInput>;
  activeCampaignTagId?: InputMaybe<StringQueryOperatorInput>;
  backgroundColor?: InputMaybe<Sensaienum_Footer_BackgroundcolorQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  contactList?: InputMaybe<SensaiComponentIndividualIconListFilterListInput>;
  contactTitle?: InputMaybe<StringQueryOperatorInput>;
  copyrightText?: InputMaybe<StringQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  footerForm?: InputMaybe<SensaiComponentZonesFormZoneFilterInput>;
  formSnippet?: InputMaybe<StringQueryOperatorInput>;
  freshDeskId?: InputMaybe<StringQueryOperatorInput>;
  freshDeskTestId?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  navTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  socialLinks?: InputMaybe<SensaiComponentIndividualIconLinkFilterListInput>;
  textLinks?: InputMaybe<SensaiComponentIndividualLinkFilterListInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiFreshChatWidgetArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  freshChatToken?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  openOnLoad?: InputMaybe<BooleanQueryOperatorInput>;
  pages?: InputMaybe<SensaiPageFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiFreshDeskWidgetArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  freshDeskId?: InputMaybe<StringQueryOperatorInput>;
  freshDeskTestId?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  openOnLoad?: InputMaybe<BooleanQueryOperatorInput>;
  pages?: InputMaybe<SensaiPageFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiGiftsArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  giftCartFormDescription?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  redeemContentBottom?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  redeemContentTop?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiLandingPagesArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  couponCode?: InputMaybe<StringQueryOperatorInput>;
  couponExpiryDays?: InputMaybe<IntQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  hero?: InputMaybe<SensaiComponentZonesHeroZoneFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  landingPageSectionPosition?: InputMaybe<IntQueryOperatorInput>;
  landing_page?: InputMaybe<SensaiLandingPagesFilterInput>;
  layout?: InputMaybe<Sensaienum_Landingpages_LayoutQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  persona?: InputMaybe<Sensaienum_Landingpages_PersonaQueryOperatorInput>;
  previewOnly?: InputMaybe<BooleanQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiMembershipsArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  hideProContractPriceSlider?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mandatoryMembershipCartDescription?: InputMaybe<StringQueryOperatorInput>;
  memberships?: InputMaybe<SensaiComponentZonesMembershipZoneFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  proContractAcceptText?: InputMaybe<StringQueryOperatorInput>;
  proContractDetailedTerms?: InputMaybe<StringQueryOperatorInput>;
  proContractSubtitle?: InputMaybe<StringQueryOperatorInput>;
  proContractTitle?: InputMaybe<StringQueryOperatorInput>;
  promoDetailsText?: InputMaybe<StringQueryOperatorInput>;
  promoDetailsTitle?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiNavigationArgs = {
  button?: InputMaybe<SensaiButtonFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  location?: InputMaybe<Sensaienum_Navigation_LocationQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiNotFoundArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  notFoundContent?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  subtext?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiPageArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  duplicateUrls?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  pages?: InputMaybe<SensaiPageFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  previewOnly?: InputMaybe<BooleanQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteParent?: InputMaybe<SensaiPageFilterInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  trackProductView?: InputMaybe<SensaiProductFilterInput>;
  updateSlug?: InputMaybe<BooleanQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiPaymentSuccessArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiPrivacyAndTermsArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  privacyPolicy?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  termsOfService?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiProductArgs = {
  CAD_Discount?: InputMaybe<IntQueryOperatorInput>;
  USD_Discount?: InputMaybe<IntQueryOperatorInput>;
  canUsOnly?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  featuredImage?: InputMaybe<SensaiUploadFileFilterInput>;
  gallery?: InputMaybe<SensaiUploadFileFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  indexStorePage?: InputMaybe<BooleanQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  isPro?: InputMaybe<BooleanQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  noCoupons?: InputMaybe<BooleanQueryOperatorInput>;
  outOfStock?: InputMaybe<BooleanQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  postPurchaseContent?: InputMaybe<SensaiPostPurchaseContentFilterInput>;
  productBundles?: InputMaybe<SensaiComponentIndividualRelatedProductFilterListInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  relatedProductPriceLink?: InputMaybe<StringQueryOperatorInput>;
  relatedProducts?: InputMaybe<SensaiProductFilterListInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  shortDescription?: InputMaybe<StringQueryOperatorInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  stripeId?: InputMaybe<StringQueryOperatorInput>;
  stripeTestId?: InputMaybe<StringQueryOperatorInput>;
  subHeading?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiSiteConfigArgs = {
  checkoutCreateAccountMessage?: InputMaybe<StringQueryOperatorInput>;
  checkoutNewsletterMessage?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  cookieBanner?: InputMaybe<StringQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  enableAffirmCanada?: InputMaybe<BooleanQueryOperatorInput>;
  enableAffirmMessaging?: InputMaybe<BooleanQueryOperatorInput>;
  enableAffirmUS?: InputMaybe<BooleanQueryOperatorInput>;
  enableBilling?: InputMaybe<BooleanQueryOperatorInput>;
  enableCoupons?: InputMaybe<BooleanQueryOperatorInput>;
  enableFrontRow?: InputMaybe<BooleanQueryOperatorInput>;
  enableGifts?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  logo?: InputMaybe<SensaiUploadFileFilterInput>;
  logoOnDark?: InputMaybe<SensaiUploadFileFilterInput>;
  noMarketingMessage?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  payWithAffirmButtonText?: InputMaybe<StringQueryOperatorInput>;
  payWithAffirmMessage?: InputMaybe<StringQueryOperatorInput>;
  proAffiliateLinkedMsg?: InputMaybe<StringQueryOperatorInput>;
  proAffiliateMsg?: InputMaybe<StringQueryOperatorInput>;
  proAffiliateTitle?: InputMaybe<StringQueryOperatorInput>;
  proContinueCheckoutButton?: InputMaybe<SensaiButtonFilterInput>;
  proContinueCheckoutMsg?: InputMaybe<StringQueryOperatorInput>;
  proContinueCheckoutTitle?: InputMaybe<StringQueryOperatorInput>;
  proSignupAccountMsg?: InputMaybe<StringQueryOperatorInput>;
  proSignupAccountTitle?: InputMaybe<StringQueryOperatorInput>;
  proSignupImg?: InputMaybe<SensaiUploadFileFilterInput>;
  proSignupLoginTitle?: InputMaybe<StringQueryOperatorInput>;
  proSignupOrgMsg?: InputMaybe<StringQueryOperatorInput>;
  proSignupOrgTitle?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  toggleCheckoutAffirmText?: InputMaybe<StringQueryOperatorInput>;
  toggleCheckoutCardText?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiSubscriptionSuccessArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiTablesArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  columns?: InputMaybe<SensaiComponentIndividualTableColumnFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  rows?: InputMaybe<SensaiComponentIndividualTableRowFilterListInput>;
  showTitle?: InputMaybe<BooleanQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiTestimonialsArgs = {
  children?: InputMaybe<NodeFilterListInput>;
  columns?: InputMaybe<SensaiComponentIndividualTestimonialFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};


export type QuerySensaiUploadFileArgs = {
  alternativeText?: InputMaybe<StringQueryOperatorInput>;
  caption?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  created_by?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  formats?: InputMaybe<JsonQueryOperatorInput>;
  hash?: InputMaybe<StringQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  imageFile?: InputMaybe<FileFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mime?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  previewUrl?: InputMaybe<StringQueryOperatorInput>;
  provider?: InputMaybe<StringQueryOperatorInput>;
  provider_metadata?: InputMaybe<JsonQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<FloatQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
  updated_by?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};


export type QuerySiteArgs = {
  adapter?: InputMaybe<SiteAdapterFilterInput>;
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  graphqlTypegen?: InputMaybe<BooleanQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySiteBuildMetadataArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};


export type QuerySiteFunctionArgs = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};


export type QuerySitePageArgs = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  context?: InputMaybe<SitePageContextFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};


export type QuerySitePluginArgs = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JsonQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};


export type QueryStripePriceArgs = {
  active?: InputMaybe<BooleanQueryOperatorInput>;
  billing_scheme?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created?: InputMaybe<IntQueryOperatorInput>;
  currency?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  livemode?: InputMaybe<BooleanQueryOperatorInput>;
  nickname?: InputMaybe<StringQueryOperatorInput>;
  object?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  product?: InputMaybe<StripePriceProductFilterInput>;
  recurring?: InputMaybe<StripePriceRecurringFilterInput>;
  tax_behavior?: InputMaybe<StringQueryOperatorInput>;
  tiers?: InputMaybe<StripePriceTiersFilterListInput>;
  tiers_mode?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  unit_amount?: InputMaybe<IntQueryOperatorInput>;
  unit_amount_decimal?: InputMaybe<StringQueryOperatorInput>;
};


export type QueryStripePriceProductMetadataArgs = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<StringQueryOperatorInput>;
  NUM_PERIOD_UPFRONT?: InputMaybe<StringQueryOperatorInput>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<StringQueryOperatorInput>;
  SKU?: InputMaybe<StringQueryOperatorInput>;
  accountRequired?: InputMaybe<StringQueryOperatorInput>;
  avataxCode?: InputMaybe<StringQueryOperatorInput>;
  bladeSKU?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  shippingPercent?: InputMaybe<StringQueryOperatorInput>;
  shippingRequired?: InputMaybe<StringQueryOperatorInput>;
  trial_days?: InputMaybe<StringQueryOperatorInput>;
};


export type QueryStripeProductArgs = {
  active?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created?: InputMaybe<IntQueryOperatorInput>;
  default_price?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  images?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  livemode?: InputMaybe<BooleanQueryOperatorInput>;
  metadata?: InputMaybe<StripeProductMetadataFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  object?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  updated?: InputMaybe<IntQueryOperatorInput>;
};

export type SensaiActivate = Node & {
  __typename?: 'SENSAIActivate';
  activePage?: Maybe<Scalars['Boolean']['output']>;
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  landingNotLoggedIn?: Maybe<SensaiComponentZonesSimpleContentZone>;
  media?: Maybe<SensaiUploadFile>;
  parent?: Maybe<Node>;
  products?: Maybe<Array<Maybe<SensaiProduct>>>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  trialMember?: Maybe<SensaiComponentZonesSimpleContentZone>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiActivateConnection = {
  __typename?: 'SENSAIActivateConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiActivateEdge>;
  group: Array<SensaiActivateGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiActivate>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiActivateConnectionDistinctArgs = {
  field: SensaiActivateFieldSelector;
};


export type SensaiActivateConnectionGroupArgs = {
  field: SensaiActivateFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiActivateConnectionMaxArgs = {
  field: SensaiActivateFieldSelector;
};


export type SensaiActivateConnectionMinArgs = {
  field: SensaiActivateFieldSelector;
};


export type SensaiActivateConnectionSumArgs = {
  field: SensaiActivateFieldSelector;
};

export type SensaiActivateEdge = {
  __typename?: 'SENSAIActivateEdge';
  next?: Maybe<SensaiActivate>;
  node: SensaiActivate;
  previous?: Maybe<SensaiActivate>;
};

export type SensaiActivateFieldSelector = {
  activePage?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  landingNotLoggedIn?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  media?: InputMaybe<SensaiUploadFileFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  products?: InputMaybe<SensaiProductFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  trialMember?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiActivateFilterInput = {
  activePage?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  landingNotLoggedIn?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  media?: InputMaybe<SensaiUploadFileFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  products?: InputMaybe<SensaiProductFilterListInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  trialMember?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiActivateGroupConnection = {
  __typename?: 'SENSAIActivateGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiActivateEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiActivateGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiActivate>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiActivateGroupConnectionDistinctArgs = {
  field: SensaiActivateFieldSelector;
};


export type SensaiActivateGroupConnectionGroupArgs = {
  field: SensaiActivateFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiActivateGroupConnectionMaxArgs = {
  field: SensaiActivateFieldSelector;
};


export type SensaiActivateGroupConnectionMinArgs = {
  field: SensaiActivateFieldSelector;
};


export type SensaiActivateGroupConnectionSumArgs = {
  field: SensaiActivateFieldSelector;
};

export type SensaiActivateSortInput = {
  activePage?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  landingNotLoggedIn?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  media?: InputMaybe<SensaiUploadFileSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  products?: InputMaybe<SensaiProductSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  trialMember?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiAppPage = Node & {
  __typename?: 'SENSAIAppPage';
  children: Array<Node>;
  content?: Maybe<SensaiComponentZonesSimpleContentZone>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiAppPageConnection = {
  __typename?: 'SENSAIAppPageConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiAppPageEdge>;
  group: Array<SensaiAppPageGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiAppPage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiAppPageConnectionDistinctArgs = {
  field: SensaiAppPageFieldSelector;
};


export type SensaiAppPageConnectionGroupArgs = {
  field: SensaiAppPageFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiAppPageConnectionMaxArgs = {
  field: SensaiAppPageFieldSelector;
};


export type SensaiAppPageConnectionMinArgs = {
  field: SensaiAppPageFieldSelector;
};


export type SensaiAppPageConnectionSumArgs = {
  field: SensaiAppPageFieldSelector;
};

export type SensaiAppPageEdge = {
  __typename?: 'SENSAIAppPageEdge';
  next?: Maybe<SensaiAppPage>;
  node: SensaiAppPage;
  previous?: Maybe<SensaiAppPage>;
};

export type SensaiAppPageFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiAppPageFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiAppPageGroupConnection = {
  __typename?: 'SENSAIAppPageGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiAppPageEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiAppPageGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiAppPage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiAppPageGroupConnectionDistinctArgs = {
  field: SensaiAppPageFieldSelector;
};


export type SensaiAppPageGroupConnectionGroupArgs = {
  field: SensaiAppPageFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiAppPageGroupConnectionMaxArgs = {
  field: SensaiAppPageFieldSelector;
};


export type SensaiAppPageGroupConnectionMinArgs = {
  field: SensaiAppPageFieldSelector;
};


export type SensaiAppPageGroupConnectionSumArgs = {
  field: SensaiAppPageFieldSelector;
};

export type SensaiAppPageSortInput = {
  children?: InputMaybe<NodeSortInput>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiArticle = Node & {
  __typename?: 'SENSAIArticle';
  articleDisclaimer?: Maybe<SensaiDisclaimer>;
  articleTag?: Maybe<SensaiArticleTags>;
  author?: Maybe<SensaiAuthors>;
  children: Array<Node>;
  content?: Maybe<SensaiComponentZonesSimpleContentZone>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  internal: Internal;
  parent?: Maybe<Node>;
  previewOnly: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  seo?: Maybe<SensaiComponentOtherSeo>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiArticleConnection = {
  __typename?: 'SENSAIArticleConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiArticleEdge>;
  group: Array<SensaiArticleGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiArticle>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiArticleConnectionDistinctArgs = {
  field: SensaiArticleFieldSelector;
};


export type SensaiArticleConnectionGroupArgs = {
  field: SensaiArticleFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiArticleConnectionMaxArgs = {
  field: SensaiArticleFieldSelector;
};


export type SensaiArticleConnectionMinArgs = {
  field: SensaiArticleFieldSelector;
};


export type SensaiArticleConnectionSumArgs = {
  field: SensaiArticleFieldSelector;
};

export type SensaiArticleEdge = {
  __typename?: 'SENSAIArticleEdge';
  next?: Maybe<SensaiArticle>;
  node: SensaiArticle;
  previous?: Maybe<SensaiArticle>;
};

export type SensaiArticleFieldSelector = {
  articleDisclaimer?: InputMaybe<SensaiDisclaimerFieldSelector>;
  articleTag?: InputMaybe<SensaiArticleTagsFieldSelector>;
  author?: InputMaybe<SensaiAuthorsFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SensaiUploadFileFieldSelector>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  previewOnly?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoFieldSelector>;
  slug?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiArticleFilterInput = {
  articleDisclaimer?: InputMaybe<SensaiDisclaimerFilterInput>;
  articleTag?: InputMaybe<SensaiArticleTagsFilterInput>;
  author?: InputMaybe<SensaiAuthorsFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<SensaiUploadFileFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  previewOnly?: InputMaybe<BooleanQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiArticleFilterListInput = {
  elemMatch?: InputMaybe<SensaiArticleFilterInput>;
};

export type SensaiArticleGroupConnection = {
  __typename?: 'SENSAIArticleGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiArticleEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiArticleGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiArticle>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiArticleGroupConnectionDistinctArgs = {
  field: SensaiArticleFieldSelector;
};


export type SensaiArticleGroupConnectionGroupArgs = {
  field: SensaiArticleFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiArticleGroupConnectionMaxArgs = {
  field: SensaiArticleFieldSelector;
};


export type SensaiArticleGroupConnectionMinArgs = {
  field: SensaiArticleFieldSelector;
};


export type SensaiArticleGroupConnectionSumArgs = {
  field: SensaiArticleFieldSelector;
};

export type SensaiArticleSortInput = {
  articleDisclaimer?: InputMaybe<SensaiDisclaimerSortInput>;
  articleTag?: InputMaybe<SensaiArticleTagsSortInput>;
  author?: InputMaybe<SensaiAuthorsSortInput>;
  children?: InputMaybe<NodeSortInput>;
  content?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SensaiUploadFileSortInput>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  previewOnly?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoSortInput>;
  slug?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiArticleTags = Node & {
  __typename?: 'SENSAIArticleTags';
  article?: Maybe<Array<Maybe<SensaiArticle>>>;
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  tagName?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiArticleTagsConnection = {
  __typename?: 'SENSAIArticleTagsConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiArticleTagsEdge>;
  group: Array<SensaiArticleTagsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiArticleTags>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiArticleTagsConnectionDistinctArgs = {
  field: SensaiArticleTagsFieldSelector;
};


export type SensaiArticleTagsConnectionGroupArgs = {
  field: SensaiArticleTagsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiArticleTagsConnectionMaxArgs = {
  field: SensaiArticleTagsFieldSelector;
};


export type SensaiArticleTagsConnectionMinArgs = {
  field: SensaiArticleTagsFieldSelector;
};


export type SensaiArticleTagsConnectionSumArgs = {
  field: SensaiArticleTagsFieldSelector;
};

export type SensaiArticleTagsEdge = {
  __typename?: 'SENSAIArticleTagsEdge';
  next?: Maybe<SensaiArticleTags>;
  node: SensaiArticleTags;
  previous?: Maybe<SensaiArticleTags>;
};

export type SensaiArticleTagsFieldSelector = {
  article?: InputMaybe<SensaiArticleFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  tagName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiArticleTagsFilterInput = {
  article?: InputMaybe<SensaiArticleFilterListInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  tagName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiArticleTagsGroupConnection = {
  __typename?: 'SENSAIArticleTagsGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiArticleTagsEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiArticleTagsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiArticleTags>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiArticleTagsGroupConnectionDistinctArgs = {
  field: SensaiArticleTagsFieldSelector;
};


export type SensaiArticleTagsGroupConnectionGroupArgs = {
  field: SensaiArticleTagsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiArticleTagsGroupConnectionMaxArgs = {
  field: SensaiArticleTagsFieldSelector;
};


export type SensaiArticleTagsGroupConnectionMinArgs = {
  field: SensaiArticleTagsFieldSelector;
};


export type SensaiArticleTagsGroupConnectionSumArgs = {
  field: SensaiArticleTagsFieldSelector;
};

export type SensaiArticleTagsSortInput = {
  article?: InputMaybe<SensaiArticleSortInput>;
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  tagName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiAuthors = {
  __typename?: 'SENSAIAuthors';
  articles?: Maybe<Array<Maybe<SensaiArticle>>>;
  avatar?: Maybe<SensaiUploadFile>;
  created_at: Scalars['JSON']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiAuthorsFieldSelector = {
  articles?: InputMaybe<SensaiArticleFieldSelector>;
  avatar?: InputMaybe<SensaiUploadFileFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  firstName?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  lastName?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiAuthorsFilterInput = {
  articles?: InputMaybe<SensaiArticleFilterListInput>;
  avatar?: InputMaybe<SensaiUploadFileFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  firstName?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  lastName?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiAuthorsSortInput = {
  articles?: InputMaybe<SensaiArticleSortInput>;
  avatar?: InputMaybe<SensaiUploadFileSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  firstName?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  lastName?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiButton = {
  __typename?: 'SENSAIButton';
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  link: Array<Maybe<SensaiButtonLinkDynamicZone>>;
  remoteTypeName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Sensaienum_Button_Type;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiButtonFieldSelector = {
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiButtonFilterInput = {
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<Sensaienum_Button_TypeQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiButtonLinkDynamicZone = SensaiComponentNavigationHyperlink | SensaiComponentNavigationMainNav | SensaiComponentNavigationProduct;

export type SensaiButtonSortInput = {
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentCardsBoxedText = {
  __typename?: 'SENSAIComponentCardsBoxedText';
  backgroundImage?: Maybe<SensaiUploadFile>;
  cardStyle?: Maybe<SensaiComponentCardsCardStyle>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentCardsCallout = {
  __typename?: 'SENSAIComponentCardsCallout';
  backgroundImage?: Maybe<SensaiUploadFile>;
  cardStyle?: Maybe<SensaiComponentCardsCardStyle>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentCardsCardStyle = {
  __typename?: 'SENSAIComponentCardsCardStyle';
  columnSpan?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  style?: Maybe<Sensaienum_Componentcardscardstyle_Style>;
};

export type SensaiComponentCardsImage = {
  __typename?: 'SENSAIComponentCardsImage';
  cardStyle?: Maybe<SensaiComponentCardsCardStyle>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentCardsImageContained = {
  __typename?: 'SENSAIComponentCardsImageContained';
  caption?: Maybe<Scalars['String']['output']>;
  cardStyle?: Maybe<SensaiComponentCardsCardStyle>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  minHeight?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentCardsLinkout = {
  __typename?: 'SENSAIComponentCardsLinkout';
  backgroundImage?: Maybe<SensaiUploadFile>;
  cardStyle?: Maybe<SensaiComponentCardsCardStyle>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  imageLocation?: Maybe<Sensaienum_Componentcardslinkout_Imagelocation>;
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentCardsPrice = {
  __typename?: 'SENSAIComponentCardsPrice';
  bulletPoints?: Maybe<Array<Maybe<SensaiComponentIndividualBullet>>>;
  bundledProduct?: Maybe<SensaiProduct>;
  buttonText?: Maybe<Scalars['String']['output']>;
  cardStyle?: Maybe<SensaiComponentCardsCardStyle>;
  couponCode?: Maybe<Scalars['String']['output']>;
  featuredText?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  priceSubTextOverride?: Maybe<Scalars['String']['output']>;
  product?: Maybe<SensaiProduct>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentCardsSpacer = {
  __typename?: 'SENSAIComponentCardsSpacer';
  columnSpan?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
};

export type SensaiComponentFeatureAccordion = {
  __typename?: 'SENSAIComponentFeatureAccordion';
  entries?: Maybe<Array<Maybe<SensaiComponentIndividualAccordionImagetext>>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentFeatureBasic = {
  __typename?: 'SENSAIComponentFeatureBasic';
  body?: Maybe<Scalars['String']['output']>;
  featureStyle?: Maybe<SensaiComponentFeatureFeatureStyle>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  linkTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  video?: Maybe<SensaiComponentIndividualVideo>;
};

export type SensaiComponentFeatureFeatureStyle = {
  __typename?: 'SENSAIComponentFeatureFeatureStyle';
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  style?: Maybe<Sensaienum_Componentfeaturefeaturestyle_Style>;
};

export type SensaiComponentFeatureImpact = {
  __typename?: 'SENSAIComponentFeatureImpact';
  body?: Maybe<Scalars['String']['output']>;
  featureStyle?: Maybe<SensaiComponentFeatureFeatureStyle>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  imageLocation?: Maybe<Sensaienum_Componentfeatureimpact_Imagelocation>;
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentFeatureQuote = {
  __typename?: 'SENSAIComponentFeatureQuote';
  authorDescription?: Maybe<Scalars['String']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  featureStyle?: Maybe<SensaiComponentFeatureFeatureStyle>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  quote: Scalars['String']['output'];
  video?: Maybe<SensaiComponentIndividualVideo>;
};

export type SensaiComponentIndividualAccordionImagetext = {
  __typename?: 'SENSAIComponentIndividualAccordionImagetext';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  remoteTypeName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SensaiComponentIndividualAccordionText = {
  __typename?: 'SENSAIComponentIndividualAccordionText';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SensaiComponentIndividualBullet = {
  __typename?: 'SENSAIComponentIndividualBullet';
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualBulletFieldSelector = {
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  text?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualBulletFilterInput = {
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualBulletFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualBulletFilterInput>;
};

export type SensaiComponentIndividualBulletSortInput = {
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  text?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualButton = {
  __typename?: 'SENSAIComponentIndividualButton';
  button?: Maybe<SensaiButton>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentIndividualButtonDef = {
  __typename?: 'SENSAIComponentIndividualButtonDef';
  addToCart: Scalars['Boolean']['output'];
  anchor?: Maybe<Scalars['String']['output']>;
  blog?: Maybe<SensaiArticle>;
  id: Scalars['ID']['output'];
  landingPage?: Maybe<SensaiLandingPages>;
  page?: Maybe<SensaiPage>;
  product?: Maybe<SensaiProduct>;
  remoteTypeName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Sensaienum_Componentindividualbuttondef_Type;
  urlLink?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualButtonFieldSelector = {
  button?: InputMaybe<SensaiButtonFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualButtonFilterInput = {
  button?: InputMaybe<SensaiButtonFilterInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualButtonFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualButtonFilterInput>;
};

export type SensaiComponentIndividualButtonSortInput = {
  button?: InputMaybe<SensaiButtonSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualCard = {
  __typename?: 'SENSAIComponentIndividualCard';
  align?: Maybe<Sensaienum_Componentindividualcard_Align>;
  button?: Maybe<SensaiButton>;
  description?: Maybe<Scalars['String']['output']>;
  hideRelatedProducts?: Maybe<Scalars['Boolean']['output']>;
  iconName?: Maybe<Sensaienum_Componentindividualcard_Iconname>;
  iconType?: Maybe<Sensaienum_Componentindividualcard_Icontype>;
  id: Scalars['ID']['output'];
  media?: Maybe<SensaiUploadFile>;
  productPriceDisplay?: Maybe<SensaiProduct>;
  remoteTypeName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualHeading = {
  __typename?: 'SENSAIComponentIndividualHeading';
  align?: Maybe<Sensaienum_Componentindividualheading_Align>;
  colour?: Maybe<Sensaienum_Componentindividualheading_Colour>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualHeadingFieldSelector = {
  align?: InputMaybe<FieldSelectorEnum>;
  colour?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  text?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualHeadingFilterInput = {
  align?: InputMaybe<Sensaienum_Componentindividualheading_AlignQueryOperatorInput>;
  colour?: InputMaybe<Sensaienum_Componentindividualheading_ColourQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualHeadingSortInput = {
  align?: InputMaybe<SortOrderEnum>;
  colour?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  text?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualIconLink = {
  __typename?: 'SENSAIComponentIndividualIconLink';
  iconName?: Maybe<Sensaienum_Componentindividualiconlink_Iconname>;
  iconType?: Maybe<Sensaienum_Componentindividualiconlink_Icontype>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualIconLinkFieldSelector = {
  iconName?: InputMaybe<FieldSelectorEnum>;
  iconType?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualIconLinkFilterInput = {
  iconName?: InputMaybe<Sensaienum_Componentindividualiconlink_IconnameQueryOperatorInput>;
  iconType?: InputMaybe<Sensaienum_Componentindividualiconlink_IcontypeQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualIconLinkFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualIconLinkFilterInput>;
};

export type SensaiComponentIndividualIconLinkSortInput = {
  iconName?: InputMaybe<SortOrderEnum>;
  iconType?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualIconList = {
  __typename?: 'SENSAIComponentIndividualIconList';
  iconName?: Maybe<Sensaienum_Componentindividualiconlist_Iconname>;
  iconType?: Maybe<Sensaienum_Componentindividualiconlist_Icontype>;
  id: Scalars['ID']['output'];
  listItemText?: Maybe<Scalars['String']['output']>;
  pageLink?: Maybe<SensaiPage>;
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentIndividualIconListFieldSelector = {
  iconName?: InputMaybe<FieldSelectorEnum>;
  iconType?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  listItemText?: InputMaybe<FieldSelectorEnum>;
  pageLink?: InputMaybe<SensaiPageFieldSelector>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualIconListFilterInput = {
  iconName?: InputMaybe<Sensaienum_Componentindividualiconlist_IconnameQueryOperatorInput>;
  iconType?: InputMaybe<Sensaienum_Componentindividualiconlist_IcontypeQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  listItemText?: InputMaybe<StringQueryOperatorInput>;
  pageLink?: InputMaybe<SensaiPageFilterInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualIconListFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualIconListFilterInput>;
};

export type SensaiComponentIndividualIconListSortInput = {
  iconName?: InputMaybe<SortOrderEnum>;
  iconType?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  listItemText?: InputMaybe<SortOrderEnum>;
  pageLink?: InputMaybe<SensaiPageSortInput>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualInlineMedia = {
  __typename?: 'SENSAIComponentIndividualInlineMedia';
  align: Sensaienum_Componentindividualinlinemedia_Align;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  mobileImage?: Maybe<SensaiUploadFile>;
  referenceName: Scalars['String']['output'];
  remoteTypeName: Scalars['String']['output'];
  rounded?: Maybe<Scalars['Boolean']['output']>;
  width: Sensaienum_Componentindividualinlinemedia_Width;
  youtubeId?: Maybe<Scalars['String']['output']>;
  youtubeMobileId?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualInlineMediaFieldSelector = {
  align?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SensaiUploadFileFieldSelector>;
  mobileImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  referenceName?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  rounded?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
  youtubeId?: InputMaybe<FieldSelectorEnum>;
  youtubeMobileId?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualInlineMediaFilterInput = {
  align?: InputMaybe<Sensaienum_Componentindividualinlinemedia_AlignQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  image?: InputMaybe<SensaiUploadFileFilterInput>;
  mobileImage?: InputMaybe<SensaiUploadFileFilterInput>;
  referenceName?: InputMaybe<StringQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  rounded?: InputMaybe<BooleanQueryOperatorInput>;
  width?: InputMaybe<Sensaienum_Componentindividualinlinemedia_WidthQueryOperatorInput>;
  youtubeId?: InputMaybe<StringQueryOperatorInput>;
  youtubeMobileId?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualInlineMediaFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualInlineMediaFilterInput>;
};

export type SensaiComponentIndividualInlineMediaSortInput = {
  align?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SensaiUploadFileSortInput>;
  mobileImage?: InputMaybe<SensaiUploadFileSortInput>;
  referenceName?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  rounded?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
  youtubeId?: InputMaybe<SortOrderEnum>;
  youtubeMobileId?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualLink = {
  __typename?: 'SENSAIComponentIndividualLink';
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  text?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualLinkFieldSelector = {
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  text?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualLinkFilterInput = {
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  text?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualLinkFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualLinkFilterInput>;
};

export type SensaiComponentIndividualLinkSortInput = {
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  text?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualMembership = {
  __typename?: 'SENSAIComponentIndividualMembership';
  additionalProduct?: Maybe<SensaiProduct>;
  bulletPoints?: Maybe<Array<Maybe<SensaiComponentIndividualBullet>>>;
  buttonText?: Maybe<Scalars['String']['output']>;
  couponCode?: Maybe<Scalars['String']['output']>;
  featuredText?: Maybe<Scalars['String']['output']>;
  footerText?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  linkFooterToHeadset?: Maybe<Scalars['Boolean']['output']>;
  priceSubTextOverride?: Maybe<Scalars['String']['output']>;
  product?: Maybe<SensaiProduct>;
  remoteTypeName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Sensaienum_Componentindividualmembership_Type;
};

export type SensaiComponentIndividualMembershipFieldSelector = {
  additionalProduct?: InputMaybe<SensaiProductFieldSelector>;
  bulletPoints?: InputMaybe<SensaiComponentIndividualBulletFieldSelector>;
  buttonText?: InputMaybe<FieldSelectorEnum>;
  couponCode?: InputMaybe<FieldSelectorEnum>;
  featuredText?: InputMaybe<FieldSelectorEnum>;
  footerText?: InputMaybe<FieldSelectorEnum>;
  highlight?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  linkFooterToHeadset?: InputMaybe<FieldSelectorEnum>;
  priceSubTextOverride?: InputMaybe<FieldSelectorEnum>;
  product?: InputMaybe<SensaiProductFieldSelector>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualMembershipFilterInput = {
  additionalProduct?: InputMaybe<SensaiProductFilterInput>;
  bulletPoints?: InputMaybe<SensaiComponentIndividualBulletFilterListInput>;
  buttonText?: InputMaybe<StringQueryOperatorInput>;
  couponCode?: InputMaybe<StringQueryOperatorInput>;
  featuredText?: InputMaybe<StringQueryOperatorInput>;
  footerText?: InputMaybe<StringQueryOperatorInput>;
  highlight?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  linkFooterToHeadset?: InputMaybe<BooleanQueryOperatorInput>;
  priceSubTextOverride?: InputMaybe<StringQueryOperatorInput>;
  product?: InputMaybe<SensaiProductFilterInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<Sensaienum_Componentindividualmembership_TypeQueryOperatorInput>;
};

export type SensaiComponentIndividualMembershipFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualMembershipFilterInput>;
};

export type SensaiComponentIndividualMembershipSortInput = {
  additionalProduct?: InputMaybe<SensaiProductSortInput>;
  bulletPoints?: InputMaybe<SensaiComponentIndividualBulletSortInput>;
  buttonText?: InputMaybe<SortOrderEnum>;
  couponCode?: InputMaybe<SortOrderEnum>;
  featuredText?: InputMaybe<SortOrderEnum>;
  footerText?: InputMaybe<SortOrderEnum>;
  highlight?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  linkFooterToHeadset?: InputMaybe<SortOrderEnum>;
  priceSubTextOverride?: InputMaybe<SortOrderEnum>;
  product?: InputMaybe<SensaiProductSortInput>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualRelatedProduct = {
  __typename?: 'SENSAIComponentIndividualRelatedProduct';
  description?: Maybe<Scalars['String']['output']>;
  forced?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  product?: Maybe<SensaiProduct>;
  remoteTypeName: Scalars['String']['output'];
  skipText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualRelatedProductFieldSelector = {
  description?: InputMaybe<FieldSelectorEnum>;
  forced?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  product?: InputMaybe<SensaiProductFieldSelector>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  skipText?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualRelatedProductFilterInput = {
  description?: InputMaybe<StringQueryOperatorInput>;
  forced?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  product?: InputMaybe<SensaiProductFilterInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  skipText?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualRelatedProductFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualRelatedProductFilterInput>;
};

export type SensaiComponentIndividualRelatedProductSortInput = {
  description?: InputMaybe<SortOrderEnum>;
  forced?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  product?: InputMaybe<SensaiProductSortInput>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  skipText?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualSpecCard = {
  __typename?: 'SENSAIComponentIndividualSpecCard';
  countLabel?: Maybe<Scalars['String']['output']>;
  countPrefix?: Maybe<Scalars['String']['output']>;
  countSuffix?: Maybe<Scalars['String']['output']>;
  countTo?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  strikethrough?: Maybe<Sensaienum_Componentindividualspeccard_Strikethrough>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualTableCell = {
  __typename?: 'SENSAIComponentIndividualTableCell';
  content?: Maybe<Sensaienum_Componentindividualtablecell_Content>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentIndividualTableCellFieldSelector = {
  content?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualTableCellFilterInput = {
  content?: InputMaybe<Sensaienum_Componentindividualtablecell_ContentQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualTableCellFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualTableCellFilterInput>;
};

export type SensaiComponentIndividualTableCellSortInput = {
  content?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualTableColumn = {
  __typename?: 'SENSAIComponentIndividualTableColumn';
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<SensaiUploadFile>;
  remoteTypeName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualTableColumnFieldSelector = {
  highlighted?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<SensaiUploadFileFieldSelector>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualTableColumnFilterInput = {
  highlighted?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  image?: InputMaybe<SensaiUploadFileFilterInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualTableColumnFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualTableColumnFilterInput>;
};

export type SensaiComponentIndividualTableColumnSortInput = {
  highlighted?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SensaiUploadFileSortInput>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualTableRow = {
  __typename?: 'SENSAIComponentIndividualTableRow';
  cells?: Maybe<Array<Maybe<SensaiComponentIndividualTableCell>>>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualTableRowFieldSelector = {
  cells?: InputMaybe<SensaiComponentIndividualTableCellFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualTableRowFilterInput = {
  cells?: InputMaybe<SensaiComponentIndividualTableCellFilterListInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualTableRowFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualTableRowFilterInput>;
};

export type SensaiComponentIndividualTableRowSortInput = {
  cells?: InputMaybe<SensaiComponentIndividualTableCellSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualTestimonial = {
  __typename?: 'SENSAIComponentIndividualTestimonial';
  author?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<SensaiUploadFile>;
  company?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quote?: Maybe<Scalars['String']['output']>;
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentIndividualTestimonialFieldSelector = {
  author?: InputMaybe<FieldSelectorEnum>;
  avatar?: InputMaybe<SensaiUploadFileFieldSelector>;
  company?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  quote?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualTestimonialFilterInput = {
  author?: InputMaybe<StringQueryOperatorInput>;
  avatar?: InputMaybe<SensaiUploadFileFilterInput>;
  company?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  quote?: InputMaybe<StringQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualTestimonialFilterListInput = {
  elemMatch?: InputMaybe<SensaiComponentIndividualTestimonialFilterInput>;
};

export type SensaiComponentIndividualTestimonialSortInput = {
  author?: InputMaybe<SortOrderEnum>;
  avatar?: InputMaybe<SensaiUploadFileSortInput>;
  company?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  quote?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentIndividualVideo = {
  __typename?: 'SENSAIComponentIndividualVideo';
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  youtubeId?: Maybe<Scalars['String']['output']>;
  youtubeMobileId?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentIndividualVideoFieldSelector = {
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  youtubeId?: InputMaybe<FieldSelectorEnum>;
  youtubeMobileId?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentIndividualVideoFilterInput = {
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  youtubeId?: InputMaybe<StringQueryOperatorInput>;
  youtubeMobileId?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentIndividualVideoSortInput = {
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  youtubeId?: InputMaybe<SortOrderEnum>;
  youtubeMobileId?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentNavigationHyperlink = {
  __typename?: 'SENSAIComponentNavigationHyperlink';
  id: Scalars['ID']['output'];
  navItemName?: Maybe<Scalars['String']['output']>;
  sectionGroup?: Maybe<Scalars['Int']['output']>;
  url: Scalars['String']['output'];
};

export type SensaiComponentNavigationMainNav = {
  __typename?: 'SENSAIComponentNavigationMainNav';
  anchor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  navItemLandingPage?: Maybe<SensaiLandingPages>;
  navItemName?: Maybe<Scalars['String']['output']>;
  navItemPage?: Maybe<SensaiPage>;
  sectionGroup?: Maybe<Scalars['Int']['output']>;
};

export type SensaiComponentNavigationProduct = {
  __typename?: 'SENSAIComponentNavigationProduct';
  addToCart: Scalars['Boolean']['output'];
  additionalProduct?: Maybe<SensaiProduct>;
  id: Scalars['ID']['output'];
  linkText?: Maybe<Scalars['String']['output']>;
  product?: Maybe<SensaiProduct>;
};

export type SensaiComponentOtherSectionInfo = {
  __typename?: 'SENSAIComponentOtherSectionInfo';
  anchorTag?: Maybe<Scalars['String']['output']>;
  animate?: Maybe<Scalars['Boolean']['output']>;
  backgroundColor?: Maybe<Sensaienum_Componentothersectioninfo_Backgroundcolor>;
  backgroundImage?: Maybe<SensaiUploadFile>;
  divider?: Maybe<Sensaienum_Componentothersectioninfo_Divider>;
  id: Scalars['ID']['output'];
  marginBottom?: Maybe<Scalars['Int']['output']>;
  marginTop?: Maybe<Scalars['Int']['output']>;
  remoteTypeName: Scalars['String']['output'];
  smallSubTitle?: Maybe<Scalars['Boolean']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitleColor?: Maybe<Sensaienum_Componentothersectioninfo_Subtitlecolor>;
  title?: Maybe<Scalars['String']['output']>;
  titleAlign?: Maybe<Sensaienum_Componentothersectioninfo_Titlealign>;
  titleColor?: Maybe<Sensaienum_Componentothersectioninfo_Titlecolor>;
  underlineTitle?: Maybe<Scalars['Boolean']['output']>;
};

export type SensaiComponentOtherSectionInfoFieldSelector = {
  anchorTag?: InputMaybe<FieldSelectorEnum>;
  animate?: InputMaybe<FieldSelectorEnum>;
  backgroundColor?: InputMaybe<FieldSelectorEnum>;
  backgroundImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  divider?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  marginBottom?: InputMaybe<FieldSelectorEnum>;
  marginTop?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  smallSubTitle?: InputMaybe<FieldSelectorEnum>;
  subtitle?: InputMaybe<FieldSelectorEnum>;
  subtitleColor?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  titleAlign?: InputMaybe<FieldSelectorEnum>;
  titleColor?: InputMaybe<FieldSelectorEnum>;
  underlineTitle?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentOtherSectionInfoFilterInput = {
  anchorTag?: InputMaybe<StringQueryOperatorInput>;
  animate?: InputMaybe<BooleanQueryOperatorInput>;
  backgroundColor?: InputMaybe<Sensaienum_Componentothersectioninfo_BackgroundcolorQueryOperatorInput>;
  backgroundImage?: InputMaybe<SensaiUploadFileFilterInput>;
  divider?: InputMaybe<Sensaienum_Componentothersectioninfo_DividerQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  marginBottom?: InputMaybe<IntQueryOperatorInput>;
  marginTop?: InputMaybe<IntQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  smallSubTitle?: InputMaybe<BooleanQueryOperatorInput>;
  subtitle?: InputMaybe<StringQueryOperatorInput>;
  subtitleColor?: InputMaybe<Sensaienum_Componentothersectioninfo_SubtitlecolorQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  titleAlign?: InputMaybe<Sensaienum_Componentothersectioninfo_TitlealignQueryOperatorInput>;
  titleColor?: InputMaybe<Sensaienum_Componentothersectioninfo_TitlecolorQueryOperatorInput>;
  underlineTitle?: InputMaybe<BooleanQueryOperatorInput>;
};

export type SensaiComponentOtherSectionInfoSortInput = {
  anchorTag?: InputMaybe<SortOrderEnum>;
  animate?: InputMaybe<SortOrderEnum>;
  backgroundColor?: InputMaybe<SortOrderEnum>;
  backgroundImage?: InputMaybe<SensaiUploadFileSortInput>;
  divider?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  marginBottom?: InputMaybe<SortOrderEnum>;
  marginTop?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  smallSubTitle?: InputMaybe<SortOrderEnum>;
  subtitle?: InputMaybe<SortOrderEnum>;
  subtitleColor?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  titleAlign?: InputMaybe<SortOrderEnum>;
  titleColor?: InputMaybe<SortOrderEnum>;
  underlineTitle?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentOtherSeo = {
  __typename?: 'SENSAIComponentOtherSeo';
  id: Scalars['ID']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaImage?: Maybe<SensaiUploadFile>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentOtherSeoFieldSelector = {
  id?: InputMaybe<FieldSelectorEnum>;
  metaDescription?: InputMaybe<FieldSelectorEnum>;
  metaImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  metaTitle?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentOtherSeoFilterInput = {
  id?: InputMaybe<IdQueryOperatorInput>;
  metaDescription?: InputMaybe<StringQueryOperatorInput>;
  metaImage?: InputMaybe<SensaiUploadFileFilterInput>;
  metaTitle?: InputMaybe<StringQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentOtherSeoSortInput = {
  id?: InputMaybe<SortOrderEnum>;
  metaDescription?: InputMaybe<SortOrderEnum>;
  metaImage?: InputMaybe<SensaiUploadFileSortInput>;
  metaTitle?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentTextAccordion = {
  __typename?: 'SENSAIComponentTextAccordion';
  columnSpan?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<Maybe<SensaiComponentIndividualAccordionText>>>;
  id: Scalars['ID']['output'];
  textStyle?: Maybe<SensaiComponentTextTextStyle>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentTextPrice = {
  __typename?: 'SENSAIComponentTextPrice';
  columnSpan?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  product?: Maybe<SensaiProduct>;
  showPaymentOptions: Scalars['Boolean']['output'];
  showRelatedProduct: Scalars['Boolean']['output'];
  textStyle?: Maybe<SensaiComponentTextTextStyle>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentTextSimpleText = {
  __typename?: 'SENSAIComponentTextSimpleText';
  columnSpan?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  link?: Maybe<SensaiComponentIndividualButtonDef>;
  textStyle?: Maybe<SensaiComponentTextTextStyle>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentTextTextStyle = {
  __typename?: 'SENSAIComponentTextTextStyle';
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  textAlign: Sensaienum_Componenttexttextstyle_Textalign;
  titleLevel: Sensaienum_Componenttexttextstyle_Titlelevel;
};

export type SensaiComponentZonesCardZone = {
  __typename?: 'SENSAIComponentZonesCardZone';
  card?: Maybe<Array<Maybe<SensaiComponentIndividualCard>>>;
  columns?: Maybe<Scalars['Int']['output']>;
  core?: Maybe<SensaiComponentOtherSectionInfo>;
  id: Scalars['ID']['output'];
  maxWidth?: Maybe<Scalars['Int']['output']>;
};

export type SensaiComponentZonesCarouselZone = {
  __typename?: 'SENSAIComponentZonesCarouselZone';
  backgroundColor?: Maybe<Sensaienum_Componentzonescarouselzone_Backgroundcolor>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<SensaiUploadFile>>>;
  marginBottom?: Maybe<Scalars['Int']['output']>;
  marginTop?: Maybe<Scalars['Int']['output']>;
  paddingBottom?: Maybe<Scalars['Int']['output']>;
  paddingTop?: Maybe<Scalars['Int']['output']>;
};

export type SensaiComponentZonesContentZone = {
  __typename?: 'SENSAIComponentZonesContentZone';
  id: Scalars['ID']['output'];
  section?: Maybe<SensaiContentSections>;
};

export type SensaiComponentZonesEmailConfirmZone = {
  __typename?: 'SENSAIComponentZonesEmailConfirmZone';
  buttonText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instructionParagraph?: Maybe<Scalars['String']['output']>;
  redirectLandingPage?: Maybe<SensaiLandingPages>;
  redirectPage?: Maybe<SensaiPage>;
  resendTokenText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type SensaiComponentZonesFeatureZone = {
  __typename?: 'SENSAIComponentZonesFeatureZone';
  feature?: Maybe<SensaiFeatureSections>;
  id: Scalars['ID']['output'];
};

export type SensaiComponentZonesFormZone = {
  __typename?: 'SENSAIComponentZonesFormZone';
  formId: Scalars['String']['output'];
  formSubTitle?: Maybe<Scalars['String']['output']>;
  formTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentZonesFormZoneFieldSelector = {
  formId?: InputMaybe<FieldSelectorEnum>;
  formSubTitle?: InputMaybe<FieldSelectorEnum>;
  formTitle?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentZonesFormZoneFilterInput = {
  formId?: InputMaybe<StringQueryOperatorInput>;
  formSubTitle?: InputMaybe<StringQueryOperatorInput>;
  formTitle?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentZonesFormZoneSortInput = {
  formId?: InputMaybe<SortOrderEnum>;
  formSubTitle?: InputMaybe<SortOrderEnum>;
  formTitle?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentZonesHeaderZone = {
  __typename?: 'SENSAIComponentZonesHeaderZone';
  alignHeader?: Maybe<Sensaienum_Componentzonesheaderzone_Alignheader>;
  id: Scalars['ID']['output'];
  maxWidth?: Maybe<Scalars['Int']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleColor?: Maybe<Sensaienum_Componentzonesheaderzone_Titlecolor>;
};

export type SensaiComponentZonesHeroZone = {
  __typename?: 'SENSAIComponentZonesHeroZone';
  backgroundImage?: Maybe<SensaiUploadFile>;
  button?: Maybe<Array<Maybe<SensaiComponentIndividualButton>>>;
  contentAlign?: Maybe<Sensaienum_Componentzonesherozone_Contentalign>;
  displayType?: Maybe<Sensaienum_Componentzonesherozone_Displaytype>;
  eyebrowHeading?: Maybe<SensaiComponentIndividualHeading>;
  featuredVideo?: Maybe<SensaiComponentIndividualVideo>;
  heading?: Maybe<SensaiComponentIndividualHeading>;
  id: Scalars['ID']['output'];
  mobileBackgroundImage?: Maybe<SensaiUploadFile>;
  more?: Maybe<Scalars['String']['output']>;
  remoteTypeName: Scalars['String']['output'];
  subheading?: Maybe<SensaiComponentIndividualHeading>;
};

export type SensaiComponentZonesHeroZoneFieldSelector = {
  backgroundImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  button?: InputMaybe<SensaiComponentIndividualButtonFieldSelector>;
  contentAlign?: InputMaybe<FieldSelectorEnum>;
  displayType?: InputMaybe<FieldSelectorEnum>;
  eyebrowHeading?: InputMaybe<SensaiComponentIndividualHeadingFieldSelector>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoFieldSelector>;
  heading?: InputMaybe<SensaiComponentIndividualHeadingFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  mobileBackgroundImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  more?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  subheading?: InputMaybe<SensaiComponentIndividualHeadingFieldSelector>;
};

export type SensaiComponentZonesHeroZoneFilterInput = {
  backgroundImage?: InputMaybe<SensaiUploadFileFilterInput>;
  button?: InputMaybe<SensaiComponentIndividualButtonFilterListInput>;
  contentAlign?: InputMaybe<Sensaienum_Componentzonesherozone_ContentalignQueryOperatorInput>;
  displayType?: InputMaybe<Sensaienum_Componentzonesherozone_DisplaytypeQueryOperatorInput>;
  eyebrowHeading?: InputMaybe<SensaiComponentIndividualHeadingFilterInput>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoFilterInput>;
  heading?: InputMaybe<SensaiComponentIndividualHeadingFilterInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  mobileBackgroundImage?: InputMaybe<SensaiUploadFileFilterInput>;
  more?: InputMaybe<StringQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  subheading?: InputMaybe<SensaiComponentIndividualHeadingFilterInput>;
};

export type SensaiComponentZonesHeroZoneSortInput = {
  backgroundImage?: InputMaybe<SensaiUploadFileSortInput>;
  button?: InputMaybe<SensaiComponentIndividualButtonSortInput>;
  contentAlign?: InputMaybe<SortOrderEnum>;
  displayType?: InputMaybe<SortOrderEnum>;
  eyebrowHeading?: InputMaybe<SensaiComponentIndividualHeadingSortInput>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoSortInput>;
  heading?: InputMaybe<SensaiComponentIndividualHeadingSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  mobileBackgroundImage?: InputMaybe<SensaiUploadFileSortInput>;
  more?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  subheading?: InputMaybe<SensaiComponentIndividualHeadingSortInput>;
};

export type SensaiComponentZonesInteractiveFeaturesZone = {
  __typename?: 'SENSAIComponentZonesInteractiveFeaturesZone';
  cards?: Maybe<Array<Maybe<SensaiComponentIndividualCard>>>;
  core?: Maybe<SensaiComponentOtherSectionInfo>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type SensaiComponentZonesMembershipZone = {
  __typename?: 'SENSAIComponentZonesMembershipZone';
  id: Scalars['ID']['output'];
  membership?: Maybe<Array<Maybe<SensaiComponentIndividualMembership>>>;
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentZonesMembershipZoneFieldSelector = {
  id?: InputMaybe<FieldSelectorEnum>;
  membership?: InputMaybe<SensaiComponentIndividualMembershipFieldSelector>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentZonesMembershipZoneFilterInput = {
  id?: InputMaybe<IdQueryOperatorInput>;
  membership?: InputMaybe<SensaiComponentIndividualMembershipFilterListInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentZonesMembershipZoneSortInput = {
  id?: InputMaybe<SortOrderEnum>;
  membership?: InputMaybe<SensaiComponentIndividualMembershipSortInput>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentZonesPrivacyAndTermsZone = {
  __typename?: 'SENSAIComponentZonesPrivacyAndTermsZone';
  id: Scalars['ID']['output'];
  policyType?: Maybe<Sensaienum_Componentzonesprivacyandtermszone_Policytype>;
};

export type SensaiComponentZonesSimpleContentZone = {
  __typename?: 'SENSAIComponentZonesSimpleContentZone';
  align: Sensaienum_Componentzonessimplecontentzone_Align;
  alignButtons?: Maybe<Sensaienum_Componentzonessimplecontentzone_Alignbuttons>;
  buttons?: Maybe<Array<Maybe<SensaiComponentIndividualButton>>>;
  content: Scalars['String']['output'];
  core?: Maybe<SensaiComponentOtherSectionInfo>;
  featuredImage?: Maybe<SensaiUploadFile>;
  featuredVideo?: Maybe<SensaiComponentIndividualVideo>;
  id: Scalars['ID']['output'];
  inlineMedia?: Maybe<Array<Maybe<SensaiComponentIndividualInlineMedia>>>;
  largeFormat?: Maybe<Scalars['Boolean']['output']>;
  maxWidth?: Maybe<Scalars['Int']['output']>;
  remoteTypeName: Scalars['String']['output'];
};

export type SensaiComponentZonesSimpleContentZoneFieldSelector = {
  align?: InputMaybe<FieldSelectorEnum>;
  alignButtons?: InputMaybe<FieldSelectorEnum>;
  buttons?: InputMaybe<SensaiComponentIndividualButtonFieldSelector>;
  content?: InputMaybe<FieldSelectorEnum>;
  core?: InputMaybe<SensaiComponentOtherSectionInfoFieldSelector>;
  featuredImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  inlineMedia?: InputMaybe<SensaiComponentIndividualInlineMediaFieldSelector>;
  largeFormat?: InputMaybe<FieldSelectorEnum>;
  maxWidth?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiComponentZonesSimpleContentZoneFilterInput = {
  align?: InputMaybe<Sensaienum_Componentzonessimplecontentzone_AlignQueryOperatorInput>;
  alignButtons?: InputMaybe<Sensaienum_Componentzonessimplecontentzone_AlignbuttonsQueryOperatorInput>;
  buttons?: InputMaybe<SensaiComponentIndividualButtonFilterListInput>;
  content?: InputMaybe<StringQueryOperatorInput>;
  core?: InputMaybe<SensaiComponentOtherSectionInfoFilterInput>;
  featuredImage?: InputMaybe<SensaiUploadFileFilterInput>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoFilterInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  inlineMedia?: InputMaybe<SensaiComponentIndividualInlineMediaFilterListInput>;
  largeFormat?: InputMaybe<BooleanQueryOperatorInput>;
  maxWidth?: InputMaybe<IntQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
};

export type SensaiComponentZonesSimpleContentZoneSortInput = {
  align?: InputMaybe<SortOrderEnum>;
  alignButtons?: InputMaybe<SortOrderEnum>;
  buttons?: InputMaybe<SensaiComponentIndividualButtonSortInput>;
  content?: InputMaybe<SortOrderEnum>;
  core?: InputMaybe<SensaiComponentOtherSectionInfoSortInput>;
  featuredImage?: InputMaybe<SensaiUploadFileSortInput>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  inlineMedia?: InputMaybe<SensaiComponentIndividualInlineMediaSortInput>;
  largeFormat?: InputMaybe<SortOrderEnum>;
  maxWidth?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
};

export type SensaiComponentZonesSpecZone = {
  __typename?: 'SENSAIComponentZonesSpecZone';
  core?: Maybe<SensaiComponentOtherSectionInfo>;
  id: Scalars['ID']['output'];
  specCard?: Maybe<Array<Maybe<SensaiComponentIndividualSpecCard>>>;
};

export type SensaiComponentZonesTableZone = {
  __typename?: 'SENSAIComponentZonesTableZone';
  id: Scalars['ID']['output'];
  table?: Maybe<SensaiTables>;
};

export type SensaiComponentZonesTestimonialZone = {
  __typename?: 'SENSAIComponentZonesTestimonialZone';
  id: Scalars['ID']['output'];
  testimonial?: Maybe<SensaiTestimonials>;
};

export type SensaiContentSections = {
  __typename?: 'SENSAIContentSections';
  backgroundColor?: Maybe<Sensaienum_Contentsections_Backgroundcolor>;
  columns?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteTypeName: Scalars['String']['output'];
  sectionHeading?: Maybe<Scalars['String']['output']>;
  sectionID?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<Maybe<SensaiContentSectionsSectionsDynamicZone>>>;
  updated_at: Scalars['JSON']['output'];
  verticalAlignment?: Maybe<Sensaienum_Contentsections_Verticalalignment>;
};

export type SensaiContentSectionsSectionsDynamicZone = SensaiComponentCardsBoxedText | SensaiComponentCardsCallout | SensaiComponentCardsImage | SensaiComponentCardsImageContained | SensaiComponentCardsLinkout | SensaiComponentCardsPrice | SensaiComponentCardsSpacer | SensaiComponentTextAccordion | SensaiComponentTextPrice | SensaiComponentTextSimpleText;

export type SensaiDisclaimer = {
  __typename?: 'SENSAIDisclaimer';
  article?: Maybe<Array<Maybe<SensaiArticle>>>;
  content: Scalars['String']['output'];
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteTypeName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiDisclaimerFieldSelector = {
  article?: InputMaybe<SensaiArticleFieldSelector>;
  content?: InputMaybe<FieldSelectorEnum>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiDisclaimerFilterInput = {
  article?: InputMaybe<SensaiArticleFilterListInput>;
  content?: InputMaybe<StringQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiDisclaimerSortInput = {
  article?: InputMaybe<SensaiArticleSortInput>;
  content?: InputMaybe<SortOrderEnum>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export enum Sensaienum_Button_Type {
  Link = 'link',
  LinkArrow = 'linkArrow',
  LinkArrowEmphasis = 'linkArrowEmphasis',
  Primary = 'primary',
  PrimaryOutline = 'primaryOutline',
  Secondary = 'secondary',
  SecondaryOutline = 'secondaryOutline',
  White = 'white'
}

export type Sensaienum_Button_TypeQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Button_Type>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Button_Type>>>;
  ne?: InputMaybe<Sensaienum_Button_Type>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Button_Type>>>;
};

export enum Sensaienum_Componentcardscardstyle_Style {
  Dark = 'dark',
  Light = 'light'
}

export enum Sensaienum_Componentcardslinkout_Imagelocation {
  Bottom = 'bottom',
  Top = 'top'
}

export enum Sensaienum_Componentfeaturefeaturestyle_Style {
  Dark = 'dark',
  Light = 'light'
}

export enum Sensaienum_Componentfeatureimpact_Imagelocation {
  BottomBorder = 'BottomBorder',
  BottomInside = 'BottomInside',
  BottomOutside = 'BottomOutside',
  TopBorder = 'TopBorder',
  TopInside = 'TopInside',
  TopOutside = 'TopOutside'
}

export enum Sensaienum_Componentindividualbuttondef_Type {
  CardArrow = 'cardArrow',
  Link = 'link',
  LinkArrow = 'linkArrow',
  LinkArrowEmphasis = 'linkArrowEmphasis',
  Primary = 'primary',
  PrimaryOutline = 'primaryOutline',
  Secondary = 'secondary',
  SecondaryOutline = 'secondaryOutline',
  White = 'white'
}

export enum Sensaienum_Componentindividualcard_Align {
  Center = 'center',
  Left = 'left'
}

export enum Sensaienum_Componentindividualcard_Iconname {
  Angledoubledown = 'angledoubledown',
  Angledoubleup = 'angledoubleup',
  Arrowcircledown = 'arrowcircledown',
  Assistivelisteningsystems = 'assistivelisteningsystems',
  Box = 'box',
  Brain = 'brain',
  Caretdown = 'caretdown',
  Chargingstation = 'chargingstation',
  Chartline = 'chartline',
  Check = 'check',
  Checkcircle = 'checkcircle',
  Chevrondown = 'chevrondown',
  Chevronleft = 'chevronleft',
  Chevronright = 'chevronright',
  Chevronup = 'chevronup',
  Clock = 'clock',
  Coffee = 'coffee',
  Compressarrowsalt = 'compressarrowsalt',
  Crutch = 'crutch',
  Draftingcompass = 'draftingcompass',
  Envelope = 'envelope',
  Exclamationtriangle = 'exclamationtriangle',
  Facebookf = 'facebookf',
  Headphones = 'headphones',
  Heartbeat = 'heartbeat',
  Instagram = 'instagram',
  Key = 'key',
  Linkedinin = 'linkedinin',
  Lock = 'lock',
  Mapmarkeralt = 'mapmarkeralt',
  Minus = 'minus',
  Pallet = 'pallet',
  Phone = 'phone',
  Plus = 'plus',
  Projectdiagram = 'projectdiagram',
  Rocket = 'rocket',
  Stopwatch = 'stopwatch',
  Times = 'times',
  Tools = 'tools',
  Trash = 'trash',
  User = 'user',
  Usercircle = 'usercircle',
  Userlock = 'userlock',
  Wrench = 'wrench'
}

export enum Sensaienum_Componentindividualcard_Icontype {
  Brand = 'Brand',
  Solid = 'Solid'
}

export enum Sensaienum_Componentindividualheading_Align {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Sensaienum_Componentindividualheading_AlignQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualheading_Align>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualheading_Align>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualheading_Align>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualheading_Align>>>;
};

export enum Sensaienum_Componentindividualheading_Colour {
  Black = 'black',
  Gradient = 'gradient',
  White = 'white'
}

export type Sensaienum_Componentindividualheading_ColourQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualheading_Colour>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualheading_Colour>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualheading_Colour>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualheading_Colour>>>;
};

export enum Sensaienum_Componentindividualiconlink_Iconname {
  Angledoubledown = 'angledoubledown',
  Angledoubleup = 'angledoubleup',
  Arrowcircledown = 'arrowcircledown',
  Assistivelisteningsystems = 'assistivelisteningsystems',
  Box = 'box',
  Brain = 'brain',
  Caretdown = 'caretdown',
  Chargingstation = 'chargingstation',
  Chartline = 'chartline',
  Check = 'check',
  Checkcircle = 'checkcircle',
  Chevrondown = 'chevrondown',
  Chevronleft = 'chevronleft',
  Chevronright = 'chevronright',
  Chevronup = 'chevronup',
  Clock = 'clock',
  Coffee = 'coffee',
  Compressarrowsalt = 'compressarrowsalt',
  Crutch = 'crutch',
  Draftingcompass = 'draftingcompass',
  Envelope = 'envelope',
  Exclamationtriangle = 'exclamationtriangle',
  Facebookf = 'facebookf',
  Headphones = 'headphones',
  Heartbeat = 'heartbeat',
  Instagram = 'instagram',
  Key = 'key',
  Linkedinin = 'linkedinin',
  Lock = 'lock',
  Mapmarkeralt = 'mapmarkeralt',
  Minus = 'minus',
  Pallet = 'pallet',
  Phone = 'phone',
  Plus = 'plus',
  Projectdiagram = 'projectdiagram',
  Rocket = 'rocket',
  Stopwatch = 'stopwatch',
  Times = 'times',
  Tools = 'tools',
  Trash = 'trash',
  User = 'user',
  Usercircle = 'usercircle',
  Userlock = 'userlock',
  Wrench = 'wrench'
}

export type Sensaienum_Componentindividualiconlink_IconnameQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualiconlink_Iconname>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlink_Iconname>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualiconlink_Iconname>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlink_Iconname>>>;
};

export enum Sensaienum_Componentindividualiconlink_Icontype {
  Brand = 'Brand',
  Solid = 'Solid'
}

export type Sensaienum_Componentindividualiconlink_IcontypeQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualiconlink_Icontype>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlink_Icontype>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualiconlink_Icontype>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlink_Icontype>>>;
};

export enum Sensaienum_Componentindividualiconlist_Iconname {
  Angledoubledown = 'angledoubledown',
  Angledoubleup = 'angledoubleup',
  Arrowcircledown = 'arrowcircledown',
  Assistivelisteningsystems = 'assistivelisteningsystems',
  Box = 'box',
  Brain = 'brain',
  Caretdown = 'caretdown',
  Chargingstation = 'chargingstation',
  Chartline = 'chartline',
  Check = 'check',
  Checkcircle = 'checkcircle',
  Chevrondown = 'chevrondown',
  Chevronleft = 'chevronleft',
  Chevronright = 'chevronright',
  Chevronup = 'chevronup',
  Clock = 'clock',
  Coffee = 'coffee',
  Compressarrowsalt = 'compressarrowsalt',
  Crutch = 'crutch',
  Draftingcompass = 'draftingcompass',
  Envelope = 'envelope',
  Exclamationtriangle = 'exclamationtriangle',
  Facebookf = 'facebookf',
  Headphones = 'headphones',
  Heartbeat = 'heartbeat',
  Instagram = 'instagram',
  Key = 'key',
  Linkedinin = 'linkedinin',
  Lock = 'lock',
  Mapmarkeralt = 'mapmarkeralt',
  Minus = 'minus',
  Pallet = 'pallet',
  Phone = 'phone',
  Plus = 'plus',
  Projectdiagram = 'projectdiagram',
  Rocket = 'rocket',
  Stopwatch = 'stopwatch',
  Times = 'times',
  Tools = 'tools',
  Trash = 'trash',
  User = 'user',
  Usercircle = 'usercircle',
  Userlock = 'userlock',
  Wrench = 'wrench'
}

export type Sensaienum_Componentindividualiconlist_IconnameQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualiconlist_Iconname>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlist_Iconname>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualiconlist_Iconname>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlist_Iconname>>>;
};

export enum Sensaienum_Componentindividualiconlist_Icontype {
  Brand = 'Brand',
  Solid = 'Solid'
}

export type Sensaienum_Componentindividualiconlist_IcontypeQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualiconlist_Icontype>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlist_Icontype>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualiconlist_Icontype>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualiconlist_Icontype>>>;
};

export enum Sensaienum_Componentindividualinlinemedia_Align {
  Left = 'left',
  Right = 'right'
}

export type Sensaienum_Componentindividualinlinemedia_AlignQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualinlinemedia_Align>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualinlinemedia_Align>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualinlinemedia_Align>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualinlinemedia_Align>>>;
};

export enum Sensaienum_Componentindividualinlinemedia_Width {
  Full = 'full',
  Half = 'half',
  OneThird = 'oneThird',
  TwoThirds = 'twoThirds'
}

export type Sensaienum_Componentindividualinlinemedia_WidthQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualinlinemedia_Width>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualinlinemedia_Width>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualinlinemedia_Width>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualinlinemedia_Width>>>;
};

export enum Sensaienum_Componentindividualmembership_Type {
  FreeAccount = 'freeAccount',
  FreeApp = 'freeApp',
  Product = 'product'
}

export type Sensaienum_Componentindividualmembership_TypeQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualmembership_Type>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualmembership_Type>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualmembership_Type>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualmembership_Type>>>;
};

export enum Sensaienum_Componentindividualspeccard_Strikethrough {
  GradientLine = 'gradientLine',
  None = 'none',
  RedLine = 'redLine'
}

export enum Sensaienum_Componentindividualtablecell_Content {
  Check = 'check',
  Empty = 'empty',
  Question = 'question',
  TextOnly = 'textOnly',
  X = 'x'
}

export type Sensaienum_Componentindividualtablecell_ContentQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentindividualtablecell_Content>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualtablecell_Content>>>;
  ne?: InputMaybe<Sensaienum_Componentindividualtablecell_Content>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentindividualtablecell_Content>>>;
};

export enum Sensaienum_Componentothersectioninfo_Backgroundcolor {
  DarkBlue = 'darkBlue',
  GradientLightGrey = 'gradientLightGrey',
  GradientPurple = 'gradientPurple',
  GradientTeal = 'gradientTeal',
  GradientTealPurple = 'gradientTealPurple',
  LightGrey = 'lightGrey',
  Purple = 'purple',
  Teal = 'teal',
  White = 'white'
}

export type Sensaienum_Componentothersectioninfo_BackgroundcolorQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentothersectioninfo_Backgroundcolor>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Backgroundcolor>>>;
  ne?: InputMaybe<Sensaienum_Componentothersectioninfo_Backgroundcolor>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Backgroundcolor>>>;
};

export enum Sensaienum_Componentothersectioninfo_Divider {
  BottomGradientLine = 'bottomGradientLine',
  BottomLine = 'bottomLine',
  None = 'none',
  TopGradientLine = 'topGradientLine',
  TopLine = 'topLine'
}

export type Sensaienum_Componentothersectioninfo_DividerQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentothersectioninfo_Divider>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Divider>>>;
  ne?: InputMaybe<Sensaienum_Componentothersectioninfo_Divider>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Divider>>>;
};

export enum Sensaienum_Componentothersectioninfo_Subtitlecolor {
  Blue = 'blue',
  Gradient = 'gradient',
  GradientGrey = 'gradientGrey',
  GradientPurple = 'gradientPurple',
  GradientRed = 'gradientRed',
  GradientTeal = 'gradientTeal',
  Pink = 'pink'
}

export type Sensaienum_Componentothersectioninfo_SubtitlecolorQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentothersectioninfo_Subtitlecolor>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Subtitlecolor>>>;
  ne?: InputMaybe<Sensaienum_Componentothersectioninfo_Subtitlecolor>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Subtitlecolor>>>;
};

export enum Sensaienum_Componentothersectioninfo_Titlealign {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Sensaienum_Componentothersectioninfo_TitlealignQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentothersectioninfo_Titlealign>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Titlealign>>>;
  ne?: InputMaybe<Sensaienum_Componentothersectioninfo_Titlealign>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Titlealign>>>;
};

export enum Sensaienum_Componentothersectioninfo_Titlecolor {
  Blue = 'blue',
  Gradient = 'gradient',
  GradientGrey = 'gradientGrey',
  GradientPurple = 'gradientPurple',
  GradientRed = 'gradientRed',
  GradientTeal = 'gradientTeal',
  Pink = 'pink'
}

export type Sensaienum_Componentothersectioninfo_TitlecolorQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentothersectioninfo_Titlecolor>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Titlecolor>>>;
  ne?: InputMaybe<Sensaienum_Componentothersectioninfo_Titlecolor>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentothersectioninfo_Titlecolor>>>;
};

export enum Sensaienum_Componenttexttextstyle_Textalign {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export enum Sensaienum_Componenttexttextstyle_Titlelevel {
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4'
}

export enum Sensaienum_Componentzonescarouselzone_Backgroundcolor {
  LightGrey = 'lightGrey',
  White = 'white'
}

export enum Sensaienum_Componentzonesheaderzone_Alignheader {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export enum Sensaienum_Componentzonesheaderzone_Titlecolor {
  Blue = 'blue',
  Gradient = 'gradient',
  GradientGrey = 'gradientGrey',
  GradientPurple = 'gradientPurple',
  GradientRed = 'gradientRed',
  GradientTeal = 'gradientTeal',
  Pink = 'pink'
}

export enum Sensaienum_Componentzonesherozone_Contentalign {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Sensaienum_Componentzonesherozone_ContentalignQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentzonesherozone_Contentalign>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonesherozone_Contentalign>>>;
  ne?: InputMaybe<Sensaienum_Componentzonesherozone_Contentalign>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonesherozone_Contentalign>>>;
};

export enum Sensaienum_Componentzonesherozone_Displaytype {
  FullScreen = 'FullScreen',
  RoundedContainer = 'RoundedContainer'
}

export type Sensaienum_Componentzonesherozone_DisplaytypeQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentzonesherozone_Displaytype>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonesherozone_Displaytype>>>;
  ne?: InputMaybe<Sensaienum_Componentzonesherozone_Displaytype>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonesherozone_Displaytype>>>;
};

export enum Sensaienum_Componentzonesprivacyandtermszone_Policytype {
  PrivacyPolicy = 'privacyPolicy',
  TermsOfService = 'termsOfService'
}

export enum Sensaienum_Componentzonessimplecontentzone_Align {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export enum Sensaienum_Componentzonessimplecontentzone_Alignbuttons {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Sensaienum_Componentzonessimplecontentzone_AlignbuttonsQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentzonessimplecontentzone_Alignbuttons>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonessimplecontentzone_Alignbuttons>>>;
  ne?: InputMaybe<Sensaienum_Componentzonessimplecontentzone_Alignbuttons>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonessimplecontentzone_Alignbuttons>>>;
};

export type Sensaienum_Componentzonessimplecontentzone_AlignQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Componentzonessimplecontentzone_Align>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonessimplecontentzone_Align>>>;
  ne?: InputMaybe<Sensaienum_Componentzonessimplecontentzone_Align>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Componentzonessimplecontentzone_Align>>>;
};

export enum Sensaienum_Contentsections_Backgroundcolor {
  DarkBlue = 'darkBlue',
  LightGrey = 'lightGrey',
  White = 'white'
}

export enum Sensaienum_Contentsections_Verticalalignment {
  Center = 'center',
  Top = 'top'
}

export enum Sensaienum_Footer_Backgroundcolor {
  DarkBlue = 'darkBlue',
  GradientLightGrey = 'gradientLightGrey',
  GradientPurple = 'gradientPurple',
  GradientTeal = 'gradientTeal',
  GradientTealPurple = 'gradientTealPurple',
  LightGrey = 'lightGrey',
  Purple = 'purple',
  Teal = 'teal',
  White = 'white'
}

export type Sensaienum_Footer_BackgroundcolorQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Footer_Backgroundcolor>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Footer_Backgroundcolor>>>;
  ne?: InputMaybe<Sensaienum_Footer_Backgroundcolor>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Footer_Backgroundcolor>>>;
};

export enum Sensaienum_Landingpages_Layout {
  FooterOnly = 'footerOnly',
  HeaderOnly = 'headerOnly',
  NoHeaderOrFooter = 'noHeaderOrFooter',
  Normal = 'normal'
}

export type Sensaienum_Landingpages_LayoutQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Landingpages_Layout>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Landingpages_Layout>>>;
  ne?: InputMaybe<Sensaienum_Landingpages_Layout>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Landingpages_Layout>>>;
};

export enum Sensaienum_Landingpages_Persona {
  Awakening = 'awakening',
  None = 'none',
  Performance = 'performance',
  Recovery = 'recovery'
}

export type Sensaienum_Landingpages_PersonaQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Landingpages_Persona>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Landingpages_Persona>>>;
  ne?: InputMaybe<Sensaienum_Landingpages_Persona>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Landingpages_Persona>>>;
};

export enum Sensaienum_Navigation_Location {
  Footer = 'footer',
  Header = 'header'
}

export type Sensaienum_Navigation_LocationQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Navigation_Location>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Navigation_Location>>>;
  ne?: InputMaybe<Sensaienum_Navigation_Location>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Navigation_Location>>>;
};

export enum Sensaienum_Postpurchasecontent_Align {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Sensaienum_Postpurchasecontent_AlignQueryOperatorInput = {
  eq?: InputMaybe<Sensaienum_Postpurchasecontent_Align>;
  in?: InputMaybe<Array<InputMaybe<Sensaienum_Postpurchasecontent_Align>>>;
  ne?: InputMaybe<Sensaienum_Postpurchasecontent_Align>;
  nin?: InputMaybe<Array<InputMaybe<Sensaienum_Postpurchasecontent_Align>>>;
};

export type SensaiEmailConfirmation = Node & {
  __typename?: 'SENSAIEmailConfirmation';
  children: Array<Node>;
  confirmationLandingPage?: Maybe<SensaiLandingPages>;
  confirmationPage?: Maybe<SensaiPage>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiEmailConfirmationConnection = {
  __typename?: 'SENSAIEmailConfirmationConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiEmailConfirmationEdge>;
  group: Array<SensaiEmailConfirmationGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiEmailConfirmation>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiEmailConfirmationConnectionDistinctArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};


export type SensaiEmailConfirmationConnectionGroupArgs = {
  field: SensaiEmailConfirmationFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiEmailConfirmationConnectionMaxArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};


export type SensaiEmailConfirmationConnectionMinArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};


export type SensaiEmailConfirmationConnectionSumArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};

export type SensaiEmailConfirmationEdge = {
  __typename?: 'SENSAIEmailConfirmationEdge';
  next?: Maybe<SensaiEmailConfirmation>;
  node: SensaiEmailConfirmation;
  previous?: Maybe<SensaiEmailConfirmation>;
};

export type SensaiEmailConfirmationFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  confirmationLandingPage?: InputMaybe<SensaiLandingPagesFieldSelector>;
  confirmationPage?: InputMaybe<SensaiPageFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiEmailConfirmationFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  confirmationLandingPage?: InputMaybe<SensaiLandingPagesFilterInput>;
  confirmationPage?: InputMaybe<SensaiPageFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiEmailConfirmationGroupConnection = {
  __typename?: 'SENSAIEmailConfirmationGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiEmailConfirmationEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiEmailConfirmationGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiEmailConfirmation>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiEmailConfirmationGroupConnectionDistinctArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};


export type SensaiEmailConfirmationGroupConnectionGroupArgs = {
  field: SensaiEmailConfirmationFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiEmailConfirmationGroupConnectionMaxArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};


export type SensaiEmailConfirmationGroupConnectionMinArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};


export type SensaiEmailConfirmationGroupConnectionSumArgs = {
  field: SensaiEmailConfirmationFieldSelector;
};

export type SensaiEmailConfirmationSortInput = {
  children?: InputMaybe<NodeSortInput>;
  confirmationLandingPage?: InputMaybe<SensaiLandingPagesSortInput>;
  confirmationPage?: InputMaybe<SensaiPageSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiFeatureSections = {
  __typename?: 'SENSAIFeatureSections';
  backgroundImage?: Maybe<SensaiUploadFile>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteTypeName: Scalars['String']['output'];
  sectionID?: Maybe<Scalars['String']['output']>;
  sections: Array<Maybe<SensaiFeatureSectionsSectionsDynamicZone>>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiFeatureSectionsSectionsDynamicZone = SensaiComponentFeatureAccordion | SensaiComponentFeatureBasic | SensaiComponentFeatureImpact | SensaiComponentFeatureQuote;

export type SensaiFooter = Node & {
  __typename?: 'SENSAIFooter';
  activeCampaignListId?: Maybe<Scalars['String']['output']>;
  activeCampaignTagId?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Sensaienum_Footer_Backgroundcolor>;
  children: Array<Node>;
  contactList?: Maybe<Array<Maybe<SensaiComponentIndividualIconList>>>;
  contactTitle?: Maybe<Scalars['String']['output']>;
  copyrightText?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['JSON']['output'];
  footerForm?: Maybe<SensaiComponentZonesFormZone>;
  formSnippet?: Maybe<Scalars['String']['output']>;
  freshDeskId?: Maybe<Scalars['String']['output']>;
  freshDeskTestId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  navTitle?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  socialLinks?: Maybe<Array<Maybe<SensaiComponentIndividualIconLink>>>;
  textLinks?: Maybe<Array<Maybe<SensaiComponentIndividualLink>>>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiFooterConnection = {
  __typename?: 'SENSAIFooterConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiFooterEdge>;
  group: Array<SensaiFooterGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiFooter>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiFooterConnectionDistinctArgs = {
  field: SensaiFooterFieldSelector;
};


export type SensaiFooterConnectionGroupArgs = {
  field: SensaiFooterFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiFooterConnectionMaxArgs = {
  field: SensaiFooterFieldSelector;
};


export type SensaiFooterConnectionMinArgs = {
  field: SensaiFooterFieldSelector;
};


export type SensaiFooterConnectionSumArgs = {
  field: SensaiFooterFieldSelector;
};

export type SensaiFooterEdge = {
  __typename?: 'SENSAIFooterEdge';
  next?: Maybe<SensaiFooter>;
  node: SensaiFooter;
  previous?: Maybe<SensaiFooter>;
};

export type SensaiFooterFieldSelector = {
  activeCampaignListId?: InputMaybe<FieldSelectorEnum>;
  activeCampaignTagId?: InputMaybe<FieldSelectorEnum>;
  backgroundColor?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  contactList?: InputMaybe<SensaiComponentIndividualIconListFieldSelector>;
  contactTitle?: InputMaybe<FieldSelectorEnum>;
  copyrightText?: InputMaybe<FieldSelectorEnum>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  footerForm?: InputMaybe<SensaiComponentZonesFormZoneFieldSelector>;
  formSnippet?: InputMaybe<FieldSelectorEnum>;
  freshDeskId?: InputMaybe<FieldSelectorEnum>;
  freshDeskTestId?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  navTitle?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  socialLinks?: InputMaybe<SensaiComponentIndividualIconLinkFieldSelector>;
  textLinks?: InputMaybe<SensaiComponentIndividualLinkFieldSelector>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiFooterFilterInput = {
  activeCampaignListId?: InputMaybe<StringQueryOperatorInput>;
  activeCampaignTagId?: InputMaybe<StringQueryOperatorInput>;
  backgroundColor?: InputMaybe<Sensaienum_Footer_BackgroundcolorQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  contactList?: InputMaybe<SensaiComponentIndividualIconListFilterListInput>;
  contactTitle?: InputMaybe<StringQueryOperatorInput>;
  copyrightText?: InputMaybe<StringQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  footerForm?: InputMaybe<SensaiComponentZonesFormZoneFilterInput>;
  formSnippet?: InputMaybe<StringQueryOperatorInput>;
  freshDeskId?: InputMaybe<StringQueryOperatorInput>;
  freshDeskTestId?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  navTitle?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  socialLinks?: InputMaybe<SensaiComponentIndividualIconLinkFilterListInput>;
  textLinks?: InputMaybe<SensaiComponentIndividualLinkFilterListInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiFooterGroupConnection = {
  __typename?: 'SENSAIFooterGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiFooterEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiFooterGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiFooter>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiFooterGroupConnectionDistinctArgs = {
  field: SensaiFooterFieldSelector;
};


export type SensaiFooterGroupConnectionGroupArgs = {
  field: SensaiFooterFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiFooterGroupConnectionMaxArgs = {
  field: SensaiFooterFieldSelector;
};


export type SensaiFooterGroupConnectionMinArgs = {
  field: SensaiFooterFieldSelector;
};


export type SensaiFooterGroupConnectionSumArgs = {
  field: SensaiFooterFieldSelector;
};

export type SensaiFooterSortInput = {
  activeCampaignListId?: InputMaybe<SortOrderEnum>;
  activeCampaignTagId?: InputMaybe<SortOrderEnum>;
  backgroundColor?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  contactList?: InputMaybe<SensaiComponentIndividualIconListSortInput>;
  contactTitle?: InputMaybe<SortOrderEnum>;
  copyrightText?: InputMaybe<SortOrderEnum>;
  created_at?: InputMaybe<SortOrderEnum>;
  footerForm?: InputMaybe<SensaiComponentZonesFormZoneSortInput>;
  formSnippet?: InputMaybe<SortOrderEnum>;
  freshDeskId?: InputMaybe<SortOrderEnum>;
  freshDeskTestId?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  navTitle?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  socialLinks?: InputMaybe<SensaiComponentIndividualIconLinkSortInput>;
  textLinks?: InputMaybe<SensaiComponentIndividualLinkSortInput>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiFreshChatWidget = Node & {
  __typename?: 'SENSAIFreshChatWidget';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  freshChatToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  openOnLoad?: Maybe<Scalars['Boolean']['output']>;
  pages?: Maybe<Array<Maybe<SensaiPage>>>;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiFreshChatWidgetConnection = {
  __typename?: 'SENSAIFreshChatWidgetConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiFreshChatWidgetEdge>;
  group: Array<SensaiFreshChatWidgetGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiFreshChatWidget>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiFreshChatWidgetConnectionDistinctArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};


export type SensaiFreshChatWidgetConnectionGroupArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiFreshChatWidgetConnectionMaxArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};


export type SensaiFreshChatWidgetConnectionMinArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};


export type SensaiFreshChatWidgetConnectionSumArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};

export type SensaiFreshChatWidgetEdge = {
  __typename?: 'SENSAIFreshChatWidgetEdge';
  next?: Maybe<SensaiFreshChatWidget>;
  node: SensaiFreshChatWidget;
  previous?: Maybe<SensaiFreshChatWidget>;
};

export type SensaiFreshChatWidgetFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  freshChatToken?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  openOnLoad?: InputMaybe<FieldSelectorEnum>;
  pages?: InputMaybe<SensaiPageFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiFreshChatWidgetFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  freshChatToken?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  openOnLoad?: InputMaybe<BooleanQueryOperatorInput>;
  pages?: InputMaybe<SensaiPageFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiFreshChatWidgetGroupConnection = {
  __typename?: 'SENSAIFreshChatWidgetGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiFreshChatWidgetEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiFreshChatWidgetGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiFreshChatWidget>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiFreshChatWidgetGroupConnectionDistinctArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};


export type SensaiFreshChatWidgetGroupConnectionGroupArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiFreshChatWidgetGroupConnectionMaxArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};


export type SensaiFreshChatWidgetGroupConnectionMinArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};


export type SensaiFreshChatWidgetGroupConnectionSumArgs = {
  field: SensaiFreshChatWidgetFieldSelector;
};

export type SensaiFreshChatWidgetSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  freshChatToken?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  openOnLoad?: InputMaybe<SortOrderEnum>;
  pages?: InputMaybe<SensaiPageSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiFreshDeskWidget = Node & {
  __typename?: 'SENSAIFreshDeskWidget';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  freshDeskId?: Maybe<Scalars['String']['output']>;
  freshDeskTestId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  openOnLoad?: Maybe<Scalars['Boolean']['output']>;
  pages?: Maybe<Array<Maybe<SensaiPage>>>;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiFreshDeskWidgetConnection = {
  __typename?: 'SENSAIFreshDeskWidgetConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiFreshDeskWidgetEdge>;
  group: Array<SensaiFreshDeskWidgetGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiFreshDeskWidget>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiFreshDeskWidgetConnectionDistinctArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};


export type SensaiFreshDeskWidgetConnectionGroupArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiFreshDeskWidgetConnectionMaxArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};


export type SensaiFreshDeskWidgetConnectionMinArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};


export type SensaiFreshDeskWidgetConnectionSumArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};

export type SensaiFreshDeskWidgetEdge = {
  __typename?: 'SENSAIFreshDeskWidgetEdge';
  next?: Maybe<SensaiFreshDeskWidget>;
  node: SensaiFreshDeskWidget;
  previous?: Maybe<SensaiFreshDeskWidget>;
};

export type SensaiFreshDeskWidgetFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  freshDeskId?: InputMaybe<FieldSelectorEnum>;
  freshDeskTestId?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  openOnLoad?: InputMaybe<FieldSelectorEnum>;
  pages?: InputMaybe<SensaiPageFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiFreshDeskWidgetFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  freshDeskId?: InputMaybe<StringQueryOperatorInput>;
  freshDeskTestId?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  openOnLoad?: InputMaybe<BooleanQueryOperatorInput>;
  pages?: InputMaybe<SensaiPageFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiFreshDeskWidgetGroupConnection = {
  __typename?: 'SENSAIFreshDeskWidgetGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiFreshDeskWidgetEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiFreshDeskWidgetGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiFreshDeskWidget>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiFreshDeskWidgetGroupConnectionDistinctArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};


export type SensaiFreshDeskWidgetGroupConnectionGroupArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiFreshDeskWidgetGroupConnectionMaxArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};


export type SensaiFreshDeskWidgetGroupConnectionMinArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};


export type SensaiFreshDeskWidgetGroupConnectionSumArgs = {
  field: SensaiFreshDeskWidgetFieldSelector;
};

export type SensaiFreshDeskWidgetSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  freshDeskId?: InputMaybe<SortOrderEnum>;
  freshDeskTestId?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  openOnLoad?: InputMaybe<SortOrderEnum>;
  pages?: InputMaybe<SensaiPageSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiGifts = Node & {
  __typename?: 'SENSAIGifts';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  giftCartFormDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  redeemContentBottom?: Maybe<SensaiComponentZonesSimpleContentZone>;
  redeemContentTop?: Maybe<SensaiComponentZonesSimpleContentZone>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiGiftsConnection = {
  __typename?: 'SENSAIGiftsConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiGiftsEdge>;
  group: Array<SensaiGiftsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiGifts>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiGiftsConnectionDistinctArgs = {
  field: SensaiGiftsFieldSelector;
};


export type SensaiGiftsConnectionGroupArgs = {
  field: SensaiGiftsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiGiftsConnectionMaxArgs = {
  field: SensaiGiftsFieldSelector;
};


export type SensaiGiftsConnectionMinArgs = {
  field: SensaiGiftsFieldSelector;
};


export type SensaiGiftsConnectionSumArgs = {
  field: SensaiGiftsFieldSelector;
};

export type SensaiGiftsEdge = {
  __typename?: 'SENSAIGiftsEdge';
  next?: Maybe<SensaiGifts>;
  node: SensaiGifts;
  previous?: Maybe<SensaiGifts>;
};

export type SensaiGiftsFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  giftCartFormDescription?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  redeemContentBottom?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  redeemContentTop?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiGiftsFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  giftCartFormDescription?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  redeemContentBottom?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  redeemContentTop?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiGiftsGroupConnection = {
  __typename?: 'SENSAIGiftsGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiGiftsEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiGiftsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiGifts>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiGiftsGroupConnectionDistinctArgs = {
  field: SensaiGiftsFieldSelector;
};


export type SensaiGiftsGroupConnectionGroupArgs = {
  field: SensaiGiftsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiGiftsGroupConnectionMaxArgs = {
  field: SensaiGiftsFieldSelector;
};


export type SensaiGiftsGroupConnectionMinArgs = {
  field: SensaiGiftsFieldSelector;
};


export type SensaiGiftsGroupConnectionSumArgs = {
  field: SensaiGiftsFieldSelector;
};

export type SensaiGiftsSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  giftCartFormDescription?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  redeemContentBottom?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  redeemContentTop?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiLandingPages = Node & {
  __typename?: 'SENSAILandingPages';
  additionalSections?: Maybe<Array<Maybe<SensaiLandingPagesAdditionalSectionsDynamicZone>>>;
  children: Array<Node>;
  couponCode?: Maybe<Scalars['String']['output']>;
  couponExpiryDays?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['JSON']['output'];
  hero?: Maybe<SensaiComponentZonesHeroZone>;
  id: Scalars['ID']['output'];
  internal: Internal;
  landingPageSectionPosition?: Maybe<Scalars['Int']['output']>;
  landing_page?: Maybe<SensaiLandingPages>;
  layout: Sensaienum_Landingpages_Layout;
  parent?: Maybe<Node>;
  persona: Sensaienum_Landingpages_Persona;
  previewOnly: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  seo?: Maybe<SensaiComponentOtherSeo>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiLandingPagesAdditionalSectionsDynamicZone = SensaiComponentZonesCardZone | SensaiComponentZonesCarouselZone | SensaiComponentZonesContentZone | SensaiComponentZonesEmailConfirmZone | SensaiComponentZonesFeatureZone | SensaiComponentZonesFormZone | SensaiComponentZonesHeaderZone | SensaiComponentZonesHeroZone | SensaiComponentZonesInteractiveFeaturesZone | SensaiComponentZonesMembershipZone | SensaiComponentZonesPrivacyAndTermsZone | SensaiComponentZonesSimpleContentZone | SensaiComponentZonesSpecZone | SensaiComponentZonesTableZone | SensaiComponentZonesTestimonialZone;

export type SensaiLandingPagesConnection = {
  __typename?: 'SENSAILandingPagesConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiLandingPagesEdge>;
  group: Array<SensaiLandingPagesGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiLandingPages>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiLandingPagesConnectionDistinctArgs = {
  field: SensaiLandingPagesFieldSelector;
};


export type SensaiLandingPagesConnectionGroupArgs = {
  field: SensaiLandingPagesFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiLandingPagesConnectionMaxArgs = {
  field: SensaiLandingPagesFieldSelector;
};


export type SensaiLandingPagesConnectionMinArgs = {
  field: SensaiLandingPagesFieldSelector;
};


export type SensaiLandingPagesConnectionSumArgs = {
  field: SensaiLandingPagesFieldSelector;
};

export type SensaiLandingPagesEdge = {
  __typename?: 'SENSAILandingPagesEdge';
  next?: Maybe<SensaiLandingPages>;
  node: SensaiLandingPages;
  previous?: Maybe<SensaiLandingPages>;
};

export type SensaiLandingPagesFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  couponCode?: InputMaybe<FieldSelectorEnum>;
  couponExpiryDays?: InputMaybe<FieldSelectorEnum>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  hero?: InputMaybe<SensaiComponentZonesHeroZoneFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  landingPageSectionPosition?: InputMaybe<FieldSelectorEnum>;
  landing_page?: InputMaybe<SensaiLandingPagesFieldSelector>;
  layout?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  persona?: InputMaybe<FieldSelectorEnum>;
  previewOnly?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoFieldSelector>;
  slug?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiLandingPagesFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  couponCode?: InputMaybe<StringQueryOperatorInput>;
  couponExpiryDays?: InputMaybe<IntQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  hero?: InputMaybe<SensaiComponentZonesHeroZoneFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  landingPageSectionPosition?: InputMaybe<IntQueryOperatorInput>;
  landing_page?: InputMaybe<SensaiLandingPagesFilterInput>;
  layout?: InputMaybe<Sensaienum_Landingpages_LayoutQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  persona?: InputMaybe<Sensaienum_Landingpages_PersonaQueryOperatorInput>;
  previewOnly?: InputMaybe<BooleanQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiLandingPagesGroupConnection = {
  __typename?: 'SENSAILandingPagesGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiLandingPagesEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiLandingPagesGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiLandingPages>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiLandingPagesGroupConnectionDistinctArgs = {
  field: SensaiLandingPagesFieldSelector;
};


export type SensaiLandingPagesGroupConnectionGroupArgs = {
  field: SensaiLandingPagesFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiLandingPagesGroupConnectionMaxArgs = {
  field: SensaiLandingPagesFieldSelector;
};


export type SensaiLandingPagesGroupConnectionMinArgs = {
  field: SensaiLandingPagesFieldSelector;
};


export type SensaiLandingPagesGroupConnectionSumArgs = {
  field: SensaiLandingPagesFieldSelector;
};

export type SensaiLandingPagesSortInput = {
  children?: InputMaybe<NodeSortInput>;
  couponCode?: InputMaybe<SortOrderEnum>;
  couponExpiryDays?: InputMaybe<SortOrderEnum>;
  created_at?: InputMaybe<SortOrderEnum>;
  hero?: InputMaybe<SensaiComponentZonesHeroZoneSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  landingPageSectionPosition?: InputMaybe<SortOrderEnum>;
  landing_page?: InputMaybe<SensaiLandingPagesSortInput>;
  layout?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  persona?: InputMaybe<SortOrderEnum>;
  previewOnly?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoSortInput>;
  slug?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiMemberships = Node & {
  __typename?: 'SENSAIMemberships';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  hideProContractPriceSlider?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  mandatoryMembershipCartDescription?: Maybe<Scalars['String']['output']>;
  memberships?: Maybe<SensaiComponentZonesMembershipZone>;
  parent?: Maybe<Node>;
  proContractAcceptText: Scalars['String']['output'];
  proContractDetailedTerms: Scalars['String']['output'];
  proContractSubtitle: Scalars['String']['output'];
  proContractTitle: Scalars['String']['output'];
  promoDetailsText?: Maybe<Scalars['String']['output']>;
  promoDetailsTitle?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiMembershipsConnection = {
  __typename?: 'SENSAIMembershipsConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiMembershipsEdge>;
  group: Array<SensaiMembershipsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiMemberships>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiMembershipsConnectionDistinctArgs = {
  field: SensaiMembershipsFieldSelector;
};


export type SensaiMembershipsConnectionGroupArgs = {
  field: SensaiMembershipsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiMembershipsConnectionMaxArgs = {
  field: SensaiMembershipsFieldSelector;
};


export type SensaiMembershipsConnectionMinArgs = {
  field: SensaiMembershipsFieldSelector;
};


export type SensaiMembershipsConnectionSumArgs = {
  field: SensaiMembershipsFieldSelector;
};

export type SensaiMembershipsEdge = {
  __typename?: 'SENSAIMembershipsEdge';
  next?: Maybe<SensaiMemberships>;
  node: SensaiMemberships;
  previous?: Maybe<SensaiMemberships>;
};

export type SensaiMembershipsFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  hideProContractPriceSlider?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  mandatoryMembershipCartDescription?: InputMaybe<FieldSelectorEnum>;
  memberships?: InputMaybe<SensaiComponentZonesMembershipZoneFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  proContractAcceptText?: InputMaybe<FieldSelectorEnum>;
  proContractDetailedTerms?: InputMaybe<FieldSelectorEnum>;
  proContractSubtitle?: InputMaybe<FieldSelectorEnum>;
  proContractTitle?: InputMaybe<FieldSelectorEnum>;
  promoDetailsText?: InputMaybe<FieldSelectorEnum>;
  promoDetailsTitle?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiMembershipsFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  hideProContractPriceSlider?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mandatoryMembershipCartDescription?: InputMaybe<StringQueryOperatorInput>;
  memberships?: InputMaybe<SensaiComponentZonesMembershipZoneFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  proContractAcceptText?: InputMaybe<StringQueryOperatorInput>;
  proContractDetailedTerms?: InputMaybe<StringQueryOperatorInput>;
  proContractSubtitle?: InputMaybe<StringQueryOperatorInput>;
  proContractTitle?: InputMaybe<StringQueryOperatorInput>;
  promoDetailsText?: InputMaybe<StringQueryOperatorInput>;
  promoDetailsTitle?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiMembershipsGroupConnection = {
  __typename?: 'SENSAIMembershipsGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiMembershipsEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiMembershipsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiMemberships>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiMembershipsGroupConnectionDistinctArgs = {
  field: SensaiMembershipsFieldSelector;
};


export type SensaiMembershipsGroupConnectionGroupArgs = {
  field: SensaiMembershipsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiMembershipsGroupConnectionMaxArgs = {
  field: SensaiMembershipsFieldSelector;
};


export type SensaiMembershipsGroupConnectionMinArgs = {
  field: SensaiMembershipsFieldSelector;
};


export type SensaiMembershipsGroupConnectionSumArgs = {
  field: SensaiMembershipsFieldSelector;
};

export type SensaiMembershipsSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  hideProContractPriceSlider?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  mandatoryMembershipCartDescription?: InputMaybe<SortOrderEnum>;
  memberships?: InputMaybe<SensaiComponentZonesMembershipZoneSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  proContractAcceptText?: InputMaybe<SortOrderEnum>;
  proContractDetailedTerms?: InputMaybe<SortOrderEnum>;
  proContractSubtitle?: InputMaybe<SortOrderEnum>;
  proContractTitle?: InputMaybe<SortOrderEnum>;
  promoDetailsText?: InputMaybe<SortOrderEnum>;
  promoDetailsTitle?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiNavigation = Node & {
  __typename?: 'SENSAINavigation';
  button?: Maybe<SensaiButton>;
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  location?: Maybe<Sensaienum_Navigation_Location>;
  pages: Array<Maybe<SensaiNavigationPagesDynamicZone>>;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiNavigationConnection = {
  __typename?: 'SENSAINavigationConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiNavigationEdge>;
  group: Array<SensaiNavigationGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiNavigation>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiNavigationConnectionDistinctArgs = {
  field: SensaiNavigationFieldSelector;
};


export type SensaiNavigationConnectionGroupArgs = {
  field: SensaiNavigationFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiNavigationConnectionMaxArgs = {
  field: SensaiNavigationFieldSelector;
};


export type SensaiNavigationConnectionMinArgs = {
  field: SensaiNavigationFieldSelector;
};


export type SensaiNavigationConnectionSumArgs = {
  field: SensaiNavigationFieldSelector;
};

export type SensaiNavigationEdge = {
  __typename?: 'SENSAINavigationEdge';
  next?: Maybe<SensaiNavigation>;
  node: SensaiNavigation;
  previous?: Maybe<SensaiNavigation>;
};

export type SensaiNavigationFieldSelector = {
  button?: InputMaybe<SensaiButtonFieldSelector>;
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  location?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiNavigationFilterInput = {
  button?: InputMaybe<SensaiButtonFilterInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  location?: InputMaybe<Sensaienum_Navigation_LocationQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiNavigationGroupConnection = {
  __typename?: 'SENSAINavigationGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiNavigationEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiNavigationGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiNavigation>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiNavigationGroupConnectionDistinctArgs = {
  field: SensaiNavigationFieldSelector;
};


export type SensaiNavigationGroupConnectionGroupArgs = {
  field: SensaiNavigationFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiNavigationGroupConnectionMaxArgs = {
  field: SensaiNavigationFieldSelector;
};


export type SensaiNavigationGroupConnectionMinArgs = {
  field: SensaiNavigationFieldSelector;
};


export type SensaiNavigationGroupConnectionSumArgs = {
  field: SensaiNavigationFieldSelector;
};

export type SensaiNavigationPagesDynamicZone = SensaiComponentNavigationHyperlink | SensaiComponentNavigationMainNav;

export type SensaiNavigationSortInput = {
  button?: InputMaybe<SensaiButtonSortInput>;
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  location?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiNotFound = Node & {
  __typename?: 'SENSAINotFound';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  notFoundContent?: Maybe<SensaiComponentZonesSimpleContentZone>;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  subtext?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiNotFoundConnection = {
  __typename?: 'SENSAINotFoundConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiNotFoundEdge>;
  group: Array<SensaiNotFoundGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiNotFound>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiNotFoundConnectionDistinctArgs = {
  field: SensaiNotFoundFieldSelector;
};


export type SensaiNotFoundConnectionGroupArgs = {
  field: SensaiNotFoundFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiNotFoundConnectionMaxArgs = {
  field: SensaiNotFoundFieldSelector;
};


export type SensaiNotFoundConnectionMinArgs = {
  field: SensaiNotFoundFieldSelector;
};


export type SensaiNotFoundConnectionSumArgs = {
  field: SensaiNotFoundFieldSelector;
};

export type SensaiNotFoundEdge = {
  __typename?: 'SENSAINotFoundEdge';
  next?: Maybe<SensaiNotFound>;
  node: SensaiNotFound;
  previous?: Maybe<SensaiNotFound>;
};

export type SensaiNotFoundFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  notFoundContent?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  subtext?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiNotFoundFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  notFoundContent?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  subtext?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiNotFoundGroupConnection = {
  __typename?: 'SENSAINotFoundGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiNotFoundEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiNotFoundGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiNotFound>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiNotFoundGroupConnectionDistinctArgs = {
  field: SensaiNotFoundFieldSelector;
};


export type SensaiNotFoundGroupConnectionGroupArgs = {
  field: SensaiNotFoundFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiNotFoundGroupConnectionMaxArgs = {
  field: SensaiNotFoundFieldSelector;
};


export type SensaiNotFoundGroupConnectionMinArgs = {
  field: SensaiNotFoundFieldSelector;
};


export type SensaiNotFoundGroupConnectionSumArgs = {
  field: SensaiNotFoundFieldSelector;
};

export type SensaiNotFoundSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  notFoundContent?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  subtext?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiPage = Node & {
  __typename?: 'SENSAIPage';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  duplicateUrls?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  pages?: Maybe<Array<Maybe<SensaiPage>>>;
  parent?: Maybe<Node>;
  previewOnly: Scalars['Boolean']['output'];
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteParent?: Maybe<SensaiPage>;
  remoteTypeName: Scalars['String']['output'];
  sections?: Maybe<Array<Maybe<SensaiPageSectionsDynamicZone>>>;
  seo?: Maybe<SensaiComponentOtherSeo>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  trackProductView?: Maybe<SensaiProduct>;
  updateSlug?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiPageConnection = {
  __typename?: 'SENSAIPageConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiPageEdge>;
  group: Array<SensaiPageGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiPage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiPageConnectionDistinctArgs = {
  field: SensaiPageFieldSelector;
};


export type SensaiPageConnectionGroupArgs = {
  field: SensaiPageFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiPageConnectionMaxArgs = {
  field: SensaiPageFieldSelector;
};


export type SensaiPageConnectionMinArgs = {
  field: SensaiPageFieldSelector;
};


export type SensaiPageConnectionSumArgs = {
  field: SensaiPageFieldSelector;
};

export type SensaiPageEdge = {
  __typename?: 'SENSAIPageEdge';
  next?: Maybe<SensaiPage>;
  node: SensaiPage;
  previous?: Maybe<SensaiPage>;
};

export type SensaiPageFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  duplicateUrls?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  pages?: InputMaybe<SensaiPageFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  previewOnly?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteParent?: InputMaybe<SensaiPageFieldSelector>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoFieldSelector>;
  slug?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  trackProductView?: InputMaybe<SensaiProductFieldSelector>;
  updateSlug?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiPageFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  duplicateUrls?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  pages?: InputMaybe<SensaiPageFilterListInput>;
  parent?: InputMaybe<NodeFilterInput>;
  previewOnly?: InputMaybe<BooleanQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteParent?: InputMaybe<SensaiPageFilterInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  trackProductView?: InputMaybe<SensaiProductFilterInput>;
  updateSlug?: InputMaybe<BooleanQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiPageFilterListInput = {
  elemMatch?: InputMaybe<SensaiPageFilterInput>;
};

export type SensaiPageGroupConnection = {
  __typename?: 'SENSAIPageGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiPageEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiPageGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiPage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiPageGroupConnectionDistinctArgs = {
  field: SensaiPageFieldSelector;
};


export type SensaiPageGroupConnectionGroupArgs = {
  field: SensaiPageFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiPageGroupConnectionMaxArgs = {
  field: SensaiPageFieldSelector;
};


export type SensaiPageGroupConnectionMinArgs = {
  field: SensaiPageFieldSelector;
};


export type SensaiPageGroupConnectionSumArgs = {
  field: SensaiPageFieldSelector;
};

export type SensaiPageSectionsDynamicZone = SensaiComponentZonesCardZone | SensaiComponentZonesCarouselZone | SensaiComponentZonesContentZone | SensaiComponentZonesEmailConfirmZone | SensaiComponentZonesFeatureZone | SensaiComponentZonesFormZone | SensaiComponentZonesHeaderZone | SensaiComponentZonesHeroZone | SensaiComponentZonesInteractiveFeaturesZone | SensaiComponentZonesMembershipZone | SensaiComponentZonesPrivacyAndTermsZone | SensaiComponentZonesSimpleContentZone | SensaiComponentZonesSpecZone | SensaiComponentZonesTableZone | SensaiComponentZonesTestimonialZone;

export type SensaiPageSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  duplicateUrls?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  pages?: InputMaybe<SensaiPageSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  previewOnly?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteParent?: InputMaybe<SensaiPageSortInput>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoSortInput>;
  slug?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  trackProductView?: InputMaybe<SensaiProductSortInput>;
  updateSlug?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiPaymentSuccess = Node & {
  __typename?: 'SENSAIPaymentSuccess';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteFields?: Maybe<SensaiComponentZonesSimpleContentZone>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiPaymentSuccessConnection = {
  __typename?: 'SENSAIPaymentSuccessConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiPaymentSuccessEdge>;
  group: Array<SensaiPaymentSuccessGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiPaymentSuccess>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiPaymentSuccessConnectionDistinctArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};


export type SensaiPaymentSuccessConnectionGroupArgs = {
  field: SensaiPaymentSuccessFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiPaymentSuccessConnectionMaxArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};


export type SensaiPaymentSuccessConnectionMinArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};


export type SensaiPaymentSuccessConnectionSumArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};

export type SensaiPaymentSuccessEdge = {
  __typename?: 'SENSAIPaymentSuccessEdge';
  next?: Maybe<SensaiPaymentSuccess>;
  node: SensaiPaymentSuccess;
  previous?: Maybe<SensaiPaymentSuccess>;
};

export type SensaiPaymentSuccessFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiPaymentSuccessFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiPaymentSuccessGroupConnection = {
  __typename?: 'SENSAIPaymentSuccessGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiPaymentSuccessEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiPaymentSuccessGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiPaymentSuccess>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiPaymentSuccessGroupConnectionDistinctArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};


export type SensaiPaymentSuccessGroupConnectionGroupArgs = {
  field: SensaiPaymentSuccessFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiPaymentSuccessGroupConnectionMaxArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};


export type SensaiPaymentSuccessGroupConnectionMinArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};


export type SensaiPaymentSuccessGroupConnectionSumArgs = {
  field: SensaiPaymentSuccessFieldSelector;
};

export type SensaiPaymentSuccessSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiPostPurchaseContent = {
  __typename?: 'SENSAIPostPurchaseContent';
  align?: Maybe<Sensaienum_Postpurchasecontent_Align>;
  backgroundImage?: Maybe<SensaiUploadFile>;
  buttons?: Maybe<Array<Maybe<SensaiComponentIndividualButton>>>;
  content?: Maybe<Scalars['String']['output']>;
  core?: Maybe<SensaiComponentOtherSectionInfo>;
  created_at: Scalars['JSON']['output'];
  featuredImage?: Maybe<SensaiUploadFile>;
  featuredVideo?: Maybe<SensaiComponentIndividualVideo>;
  id: Scalars['ID']['output'];
  inlineMedia?: Maybe<Array<Maybe<SensaiComponentIndividualInlineMedia>>>;
  largeFormat?: Maybe<Scalars['Boolean']['output']>;
  maxWidth?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiPostPurchaseContentFieldSelector = {
  align?: InputMaybe<FieldSelectorEnum>;
  backgroundImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  buttons?: InputMaybe<SensaiComponentIndividualButtonFieldSelector>;
  content?: InputMaybe<FieldSelectorEnum>;
  core?: InputMaybe<SensaiComponentOtherSectionInfoFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  featuredImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  inlineMedia?: InputMaybe<SensaiComponentIndividualInlineMediaFieldSelector>;
  largeFormat?: InputMaybe<FieldSelectorEnum>;
  maxWidth?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiPostPurchaseContentFilterInput = {
  align?: InputMaybe<Sensaienum_Postpurchasecontent_AlignQueryOperatorInput>;
  backgroundImage?: InputMaybe<SensaiUploadFileFilterInput>;
  buttons?: InputMaybe<SensaiComponentIndividualButtonFilterListInput>;
  content?: InputMaybe<StringQueryOperatorInput>;
  core?: InputMaybe<SensaiComponentOtherSectionInfoFilterInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  featuredImage?: InputMaybe<SensaiUploadFileFilterInput>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoFilterInput>;
  id?: InputMaybe<IdQueryOperatorInput>;
  inlineMedia?: InputMaybe<SensaiComponentIndividualInlineMediaFilterListInput>;
  largeFormat?: InputMaybe<BooleanQueryOperatorInput>;
  maxWidth?: InputMaybe<IntQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiPostPurchaseContentSortInput = {
  align?: InputMaybe<SortOrderEnum>;
  backgroundImage?: InputMaybe<SensaiUploadFileSortInput>;
  buttons?: InputMaybe<SensaiComponentIndividualButtonSortInput>;
  content?: InputMaybe<SortOrderEnum>;
  core?: InputMaybe<SensaiComponentOtherSectionInfoSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  featuredImage?: InputMaybe<SensaiUploadFileSortInput>;
  featuredVideo?: InputMaybe<SensaiComponentIndividualVideoSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  inlineMedia?: InputMaybe<SensaiComponentIndividualInlineMediaSortInput>;
  largeFormat?: InputMaybe<SortOrderEnum>;
  maxWidth?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiPrivacyAndTerms = Node & {
  __typename?: 'SENSAIPrivacyAndTerms';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  termsOfService?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiPrivacyAndTermsConnection = {
  __typename?: 'SENSAIPrivacyAndTermsConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiPrivacyAndTermsEdge>;
  group: Array<SensaiPrivacyAndTermsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiPrivacyAndTerms>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiPrivacyAndTermsConnectionDistinctArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};


export type SensaiPrivacyAndTermsConnectionGroupArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiPrivacyAndTermsConnectionMaxArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};


export type SensaiPrivacyAndTermsConnectionMinArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};


export type SensaiPrivacyAndTermsConnectionSumArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};

export type SensaiPrivacyAndTermsEdge = {
  __typename?: 'SENSAIPrivacyAndTermsEdge';
  next?: Maybe<SensaiPrivacyAndTerms>;
  node: SensaiPrivacyAndTerms;
  previous?: Maybe<SensaiPrivacyAndTerms>;
};

export type SensaiPrivacyAndTermsFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  privacyPolicy?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  termsOfService?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiPrivacyAndTermsFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  privacyPolicy?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  termsOfService?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiPrivacyAndTermsGroupConnection = {
  __typename?: 'SENSAIPrivacyAndTermsGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiPrivacyAndTermsEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiPrivacyAndTermsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiPrivacyAndTerms>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiPrivacyAndTermsGroupConnectionDistinctArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};


export type SensaiPrivacyAndTermsGroupConnectionGroupArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiPrivacyAndTermsGroupConnectionMaxArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};


export type SensaiPrivacyAndTermsGroupConnectionMinArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};


export type SensaiPrivacyAndTermsGroupConnectionSumArgs = {
  field: SensaiPrivacyAndTermsFieldSelector;
};

export type SensaiPrivacyAndTermsSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  privacyPolicy?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  termsOfService?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiProduct = Node & {
  __typename?: 'SENSAIProduct';
  CAD_Discount: Scalars['Int']['output'];
  USD_Discount: Scalars['Int']['output'];
  canUsOnly?: Maybe<Scalars['Boolean']['output']>;
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  description?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<SensaiUploadFile>;
  gallery?: Maybe<Array<Maybe<SensaiUploadFile>>>;
  id: Scalars['ID']['output'];
  indexStorePage?: Maybe<Scalars['Boolean']['output']>;
  internal: Internal;
  isPro?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  noCoupons?: Maybe<Scalars['Boolean']['output']>;
  outOfStock?: Maybe<Scalars['Boolean']['output']>;
  parent?: Maybe<Node>;
  postPurchaseContent?: Maybe<SensaiPostPurchaseContent>;
  productBundles?: Maybe<Array<Maybe<SensaiComponentIndividualRelatedProduct>>>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  relatedProductPriceLink?: Maybe<Scalars['String']['output']>;
  relatedProducts?: Maybe<Array<Maybe<SensaiProduct>>>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  sections?: Maybe<Array<Maybe<SensaiProductSectionsDynamicZone>>>;
  seo?: Maybe<SensaiComponentOtherSeo>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  stripeId: Scalars['String']['output'];
  stripeTestId?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiProductConnection = {
  __typename?: 'SENSAIProductConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiProductEdge>;
  group: Array<SensaiProductGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiProduct>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiProductConnectionDistinctArgs = {
  field: SensaiProductFieldSelector;
};


export type SensaiProductConnectionGroupArgs = {
  field: SensaiProductFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiProductConnectionMaxArgs = {
  field: SensaiProductFieldSelector;
};


export type SensaiProductConnectionMinArgs = {
  field: SensaiProductFieldSelector;
};


export type SensaiProductConnectionSumArgs = {
  field: SensaiProductFieldSelector;
};

export type SensaiProductEdge = {
  __typename?: 'SENSAIProductEdge';
  next?: Maybe<SensaiProduct>;
  node: SensaiProduct;
  previous?: Maybe<SensaiProduct>;
};

export type SensaiProductFieldSelector = {
  CAD_Discount?: InputMaybe<FieldSelectorEnum>;
  USD_Discount?: InputMaybe<FieldSelectorEnum>;
  canUsOnly?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  featuredImage?: InputMaybe<SensaiUploadFileFieldSelector>;
  gallery?: InputMaybe<SensaiUploadFileFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  indexStorePage?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  isPro?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  noCoupons?: InputMaybe<FieldSelectorEnum>;
  outOfStock?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  postPurchaseContent?: InputMaybe<SensaiPostPurchaseContentFieldSelector>;
  productBundles?: InputMaybe<SensaiComponentIndividualRelatedProductFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  relatedProductPriceLink?: InputMaybe<FieldSelectorEnum>;
  relatedProducts?: InputMaybe<SensaiProductFieldSelector>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoFieldSelector>;
  shortDescription?: InputMaybe<FieldSelectorEnum>;
  slug?: InputMaybe<FieldSelectorEnum>;
  stripeId?: InputMaybe<FieldSelectorEnum>;
  stripeTestId?: InputMaybe<FieldSelectorEnum>;
  subHeading?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiProductFilterInput = {
  CAD_Discount?: InputMaybe<IntQueryOperatorInput>;
  USD_Discount?: InputMaybe<IntQueryOperatorInput>;
  canUsOnly?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  featuredImage?: InputMaybe<SensaiUploadFileFilterInput>;
  gallery?: InputMaybe<SensaiUploadFileFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  indexStorePage?: InputMaybe<BooleanQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  isPro?: InputMaybe<BooleanQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  noCoupons?: InputMaybe<BooleanQueryOperatorInput>;
  outOfStock?: InputMaybe<BooleanQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  postPurchaseContent?: InputMaybe<SensaiPostPurchaseContentFilterInput>;
  productBundles?: InputMaybe<SensaiComponentIndividualRelatedProductFilterListInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  relatedProductPriceLink?: InputMaybe<StringQueryOperatorInput>;
  relatedProducts?: InputMaybe<SensaiProductFilterListInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  seo?: InputMaybe<SensaiComponentOtherSeoFilterInput>;
  shortDescription?: InputMaybe<StringQueryOperatorInput>;
  slug?: InputMaybe<StringQueryOperatorInput>;
  stripeId?: InputMaybe<StringQueryOperatorInput>;
  stripeTestId?: InputMaybe<StringQueryOperatorInput>;
  subHeading?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiProductFilterListInput = {
  elemMatch?: InputMaybe<SensaiProductFilterInput>;
};

export type SensaiProductGroupConnection = {
  __typename?: 'SENSAIProductGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiProductEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiProductGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiProduct>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiProductGroupConnectionDistinctArgs = {
  field: SensaiProductFieldSelector;
};


export type SensaiProductGroupConnectionGroupArgs = {
  field: SensaiProductFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiProductGroupConnectionMaxArgs = {
  field: SensaiProductFieldSelector;
};


export type SensaiProductGroupConnectionMinArgs = {
  field: SensaiProductFieldSelector;
};


export type SensaiProductGroupConnectionSumArgs = {
  field: SensaiProductFieldSelector;
};

export type SensaiProductSectionsDynamicZone = SensaiComponentZonesCardZone | SensaiComponentZonesCarouselZone | SensaiComponentZonesContentZone | SensaiComponentZonesEmailConfirmZone | SensaiComponentZonesFeatureZone | SensaiComponentZonesFormZone | SensaiComponentZonesHeaderZone | SensaiComponentZonesHeroZone | SensaiComponentZonesInteractiveFeaturesZone | SensaiComponentZonesMembershipZone | SensaiComponentZonesPrivacyAndTermsZone | SensaiComponentZonesSimpleContentZone | SensaiComponentZonesSpecZone | SensaiComponentZonesTableZone | SensaiComponentZonesTestimonialZone;

export type SensaiProductSortInput = {
  CAD_Discount?: InputMaybe<SortOrderEnum>;
  USD_Discount?: InputMaybe<SortOrderEnum>;
  canUsOnly?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  featuredImage?: InputMaybe<SensaiUploadFileSortInput>;
  gallery?: InputMaybe<SensaiUploadFileSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  indexStorePage?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  isPro?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  noCoupons?: InputMaybe<SortOrderEnum>;
  outOfStock?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  postPurchaseContent?: InputMaybe<SensaiPostPurchaseContentSortInput>;
  productBundles?: InputMaybe<SensaiComponentIndividualRelatedProductSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  relatedProductPriceLink?: InputMaybe<SortOrderEnum>;
  relatedProducts?: InputMaybe<SensaiProductSortInput>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  seo?: InputMaybe<SensaiComponentOtherSeoSortInput>;
  shortDescription?: InputMaybe<SortOrderEnum>;
  slug?: InputMaybe<SortOrderEnum>;
  stripeId?: InputMaybe<SortOrderEnum>;
  stripeTestId?: InputMaybe<SortOrderEnum>;
  subHeading?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiSiteConfig = Node & {
  __typename?: 'SENSAISiteConfig';
  checkoutCreateAccountMessage?: Maybe<Scalars['String']['output']>;
  checkoutNewsletterMessage?: Maybe<Scalars['String']['output']>;
  children: Array<Node>;
  cookieBanner?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['JSON']['output'];
  enableAffirmCanada?: Maybe<Scalars['Boolean']['output']>;
  enableAffirmMessaging?: Maybe<Scalars['Boolean']['output']>;
  enableAffirmUS?: Maybe<Scalars['Boolean']['output']>;
  enableBilling?: Maybe<Scalars['Boolean']['output']>;
  enableCoupons?: Maybe<Scalars['Boolean']['output']>;
  enableFrontRow?: Maybe<Scalars['Boolean']['output']>;
  enableGifts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  logo?: Maybe<SensaiUploadFile>;
  logoOnDark?: Maybe<SensaiUploadFile>;
  noMarketingMessage?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  payWithAffirmButtonText?: Maybe<Scalars['String']['output']>;
  payWithAffirmMessage?: Maybe<Scalars['String']['output']>;
  proAffiliateLinkedMsg?: Maybe<Scalars['String']['output']>;
  proAffiliateMsg?: Maybe<Scalars['String']['output']>;
  proAffiliateTitle?: Maybe<Scalars['String']['output']>;
  proContinueCheckoutButton?: Maybe<SensaiButton>;
  proContinueCheckoutMsg?: Maybe<Scalars['String']['output']>;
  proContinueCheckoutTitle?: Maybe<Scalars['String']['output']>;
  proSignupAccountMsg?: Maybe<Scalars['String']['output']>;
  proSignupAccountTitle?: Maybe<Scalars['String']['output']>;
  proSignupImg?: Maybe<SensaiUploadFile>;
  proSignupLoginTitle?: Maybe<Scalars['String']['output']>;
  proSignupOrgMsg?: Maybe<Scalars['String']['output']>;
  proSignupOrgTitle?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  toggleCheckoutAffirmText?: Maybe<Scalars['String']['output']>;
  toggleCheckoutCardText?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiSiteConfigConnection = {
  __typename?: 'SENSAISiteConfigConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiSiteConfigEdge>;
  group: Array<SensaiSiteConfigGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiSiteConfig>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiSiteConfigConnectionDistinctArgs = {
  field: SensaiSiteConfigFieldSelector;
};


export type SensaiSiteConfigConnectionGroupArgs = {
  field: SensaiSiteConfigFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiSiteConfigConnectionMaxArgs = {
  field: SensaiSiteConfigFieldSelector;
};


export type SensaiSiteConfigConnectionMinArgs = {
  field: SensaiSiteConfigFieldSelector;
};


export type SensaiSiteConfigConnectionSumArgs = {
  field: SensaiSiteConfigFieldSelector;
};

export type SensaiSiteConfigEdge = {
  __typename?: 'SENSAISiteConfigEdge';
  next?: Maybe<SensaiSiteConfig>;
  node: SensaiSiteConfig;
  previous?: Maybe<SensaiSiteConfig>;
};

export type SensaiSiteConfigFieldSelector = {
  checkoutCreateAccountMessage?: InputMaybe<FieldSelectorEnum>;
  checkoutNewsletterMessage?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  cookieBanner?: InputMaybe<FieldSelectorEnum>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  enableAffirmCanada?: InputMaybe<FieldSelectorEnum>;
  enableAffirmMessaging?: InputMaybe<FieldSelectorEnum>;
  enableAffirmUS?: InputMaybe<FieldSelectorEnum>;
  enableBilling?: InputMaybe<FieldSelectorEnum>;
  enableCoupons?: InputMaybe<FieldSelectorEnum>;
  enableFrontRow?: InputMaybe<FieldSelectorEnum>;
  enableGifts?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  logo?: InputMaybe<SensaiUploadFileFieldSelector>;
  logoOnDark?: InputMaybe<SensaiUploadFileFieldSelector>;
  noMarketingMessage?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  payWithAffirmButtonText?: InputMaybe<FieldSelectorEnum>;
  payWithAffirmMessage?: InputMaybe<FieldSelectorEnum>;
  proAffiliateLinkedMsg?: InputMaybe<FieldSelectorEnum>;
  proAffiliateMsg?: InputMaybe<FieldSelectorEnum>;
  proAffiliateTitle?: InputMaybe<FieldSelectorEnum>;
  proContinueCheckoutButton?: InputMaybe<SensaiButtonFieldSelector>;
  proContinueCheckoutMsg?: InputMaybe<FieldSelectorEnum>;
  proContinueCheckoutTitle?: InputMaybe<FieldSelectorEnum>;
  proSignupAccountMsg?: InputMaybe<FieldSelectorEnum>;
  proSignupAccountTitle?: InputMaybe<FieldSelectorEnum>;
  proSignupImg?: InputMaybe<SensaiUploadFileFieldSelector>;
  proSignupLoginTitle?: InputMaybe<FieldSelectorEnum>;
  proSignupOrgMsg?: InputMaybe<FieldSelectorEnum>;
  proSignupOrgTitle?: InputMaybe<FieldSelectorEnum>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  toggleCheckoutAffirmText?: InputMaybe<FieldSelectorEnum>;
  toggleCheckoutCardText?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiSiteConfigFilterInput = {
  checkoutCreateAccountMessage?: InputMaybe<StringQueryOperatorInput>;
  checkoutNewsletterMessage?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  cookieBanner?: InputMaybe<StringQueryOperatorInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  enableAffirmCanada?: InputMaybe<BooleanQueryOperatorInput>;
  enableAffirmMessaging?: InputMaybe<BooleanQueryOperatorInput>;
  enableAffirmUS?: InputMaybe<BooleanQueryOperatorInput>;
  enableBilling?: InputMaybe<BooleanQueryOperatorInput>;
  enableCoupons?: InputMaybe<BooleanQueryOperatorInput>;
  enableFrontRow?: InputMaybe<BooleanQueryOperatorInput>;
  enableGifts?: InputMaybe<BooleanQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  logo?: InputMaybe<SensaiUploadFileFilterInput>;
  logoOnDark?: InputMaybe<SensaiUploadFileFilterInput>;
  noMarketingMessage?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  payWithAffirmButtonText?: InputMaybe<StringQueryOperatorInput>;
  payWithAffirmMessage?: InputMaybe<StringQueryOperatorInput>;
  proAffiliateLinkedMsg?: InputMaybe<StringQueryOperatorInput>;
  proAffiliateMsg?: InputMaybe<StringQueryOperatorInput>;
  proAffiliateTitle?: InputMaybe<StringQueryOperatorInput>;
  proContinueCheckoutButton?: InputMaybe<SensaiButtonFilterInput>;
  proContinueCheckoutMsg?: InputMaybe<StringQueryOperatorInput>;
  proContinueCheckoutTitle?: InputMaybe<StringQueryOperatorInput>;
  proSignupAccountMsg?: InputMaybe<StringQueryOperatorInput>;
  proSignupAccountTitle?: InputMaybe<StringQueryOperatorInput>;
  proSignupImg?: InputMaybe<SensaiUploadFileFilterInput>;
  proSignupLoginTitle?: InputMaybe<StringQueryOperatorInput>;
  proSignupOrgMsg?: InputMaybe<StringQueryOperatorInput>;
  proSignupOrgTitle?: InputMaybe<StringQueryOperatorInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  toggleCheckoutAffirmText?: InputMaybe<StringQueryOperatorInput>;
  toggleCheckoutCardText?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiSiteConfigGroupConnection = {
  __typename?: 'SENSAISiteConfigGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiSiteConfigEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiSiteConfigGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiSiteConfig>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiSiteConfigGroupConnectionDistinctArgs = {
  field: SensaiSiteConfigFieldSelector;
};


export type SensaiSiteConfigGroupConnectionGroupArgs = {
  field: SensaiSiteConfigFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiSiteConfigGroupConnectionMaxArgs = {
  field: SensaiSiteConfigFieldSelector;
};


export type SensaiSiteConfigGroupConnectionMinArgs = {
  field: SensaiSiteConfigFieldSelector;
};


export type SensaiSiteConfigGroupConnectionSumArgs = {
  field: SensaiSiteConfigFieldSelector;
};

export type SensaiSiteConfigSortInput = {
  checkoutCreateAccountMessage?: InputMaybe<SortOrderEnum>;
  checkoutNewsletterMessage?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  cookieBanner?: InputMaybe<SortOrderEnum>;
  created_at?: InputMaybe<SortOrderEnum>;
  enableAffirmCanada?: InputMaybe<SortOrderEnum>;
  enableAffirmMessaging?: InputMaybe<SortOrderEnum>;
  enableAffirmUS?: InputMaybe<SortOrderEnum>;
  enableBilling?: InputMaybe<SortOrderEnum>;
  enableCoupons?: InputMaybe<SortOrderEnum>;
  enableFrontRow?: InputMaybe<SortOrderEnum>;
  enableGifts?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  logo?: InputMaybe<SensaiUploadFileSortInput>;
  logoOnDark?: InputMaybe<SensaiUploadFileSortInput>;
  noMarketingMessage?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  payWithAffirmButtonText?: InputMaybe<SortOrderEnum>;
  payWithAffirmMessage?: InputMaybe<SortOrderEnum>;
  proAffiliateLinkedMsg?: InputMaybe<SortOrderEnum>;
  proAffiliateMsg?: InputMaybe<SortOrderEnum>;
  proAffiliateTitle?: InputMaybe<SortOrderEnum>;
  proContinueCheckoutButton?: InputMaybe<SensaiButtonSortInput>;
  proContinueCheckoutMsg?: InputMaybe<SortOrderEnum>;
  proContinueCheckoutTitle?: InputMaybe<SortOrderEnum>;
  proSignupAccountMsg?: InputMaybe<SortOrderEnum>;
  proSignupAccountTitle?: InputMaybe<SortOrderEnum>;
  proSignupImg?: InputMaybe<SensaiUploadFileSortInput>;
  proSignupLoginTitle?: InputMaybe<SortOrderEnum>;
  proSignupOrgMsg?: InputMaybe<SortOrderEnum>;
  proSignupOrgTitle?: InputMaybe<SortOrderEnum>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  toggleCheckoutAffirmText?: InputMaybe<SortOrderEnum>;
  toggleCheckoutCardText?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiSubscriptionSuccess = Node & {
  __typename?: 'SENSAISubscriptionSuccess';
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteFields?: Maybe<SensaiComponentZonesSimpleContentZone>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiSubscriptionSuccessConnection = {
  __typename?: 'SENSAISubscriptionSuccessConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiSubscriptionSuccessEdge>;
  group: Array<SensaiSubscriptionSuccessGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiSubscriptionSuccess>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiSubscriptionSuccessConnectionDistinctArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};


export type SensaiSubscriptionSuccessConnectionGroupArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiSubscriptionSuccessConnectionMaxArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};


export type SensaiSubscriptionSuccessConnectionMinArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};


export type SensaiSubscriptionSuccessConnectionSumArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};

export type SensaiSubscriptionSuccessEdge = {
  __typename?: 'SENSAISubscriptionSuccessEdge';
  next?: Maybe<SensaiSubscriptionSuccess>;
  node: SensaiSubscriptionSuccess;
  previous?: Maybe<SensaiSubscriptionSuccess>;
};

export type SensaiSubscriptionSuccessFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneFieldSelector>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiSubscriptionSuccessFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiSubscriptionSuccessGroupConnection = {
  __typename?: 'SENSAISubscriptionSuccessGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiSubscriptionSuccessEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiSubscriptionSuccessGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiSubscriptionSuccess>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiSubscriptionSuccessGroupConnectionDistinctArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};


export type SensaiSubscriptionSuccessGroupConnectionGroupArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiSubscriptionSuccessGroupConnectionMaxArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};


export type SensaiSubscriptionSuccessGroupConnectionMinArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};


export type SensaiSubscriptionSuccessGroupConnectionSumArgs = {
  field: SensaiSubscriptionSuccessFieldSelector;
};

export type SensaiSubscriptionSuccessSortInput = {
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteFields?: InputMaybe<SensaiComponentZonesSimpleContentZoneSortInput>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiTables = Node & {
  __typename?: 'SENSAITables';
  children: Array<Node>;
  columns?: Maybe<Array<Maybe<SensaiComponentIndividualTableColumn>>>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  published_at?: Maybe<Scalars['JSON']['output']>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  rows?: Maybe<Array<Maybe<SensaiComponentIndividualTableRow>>>;
  showTitle?: Maybe<Scalars['Boolean']['output']>;
  updated_at: Scalars['JSON']['output'];
};

export type SensaiTablesConnection = {
  __typename?: 'SENSAITablesConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiTablesEdge>;
  group: Array<SensaiTablesGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiTables>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiTablesConnectionDistinctArgs = {
  field: SensaiTablesFieldSelector;
};


export type SensaiTablesConnectionGroupArgs = {
  field: SensaiTablesFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiTablesConnectionMaxArgs = {
  field: SensaiTablesFieldSelector;
};


export type SensaiTablesConnectionMinArgs = {
  field: SensaiTablesFieldSelector;
};


export type SensaiTablesConnectionSumArgs = {
  field: SensaiTablesFieldSelector;
};

export type SensaiTablesEdge = {
  __typename?: 'SENSAITablesEdge';
  next?: Maybe<SensaiTables>;
  node: SensaiTables;
  previous?: Maybe<SensaiTables>;
};

export type SensaiTablesFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  columns?: InputMaybe<SensaiComponentIndividualTableColumnFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  published_at?: InputMaybe<FieldSelectorEnum>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  rows?: InputMaybe<SensaiComponentIndividualTableRowFieldSelector>;
  showTitle?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiTablesFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  columns?: InputMaybe<SensaiComponentIndividualTableColumnFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  published_at?: InputMaybe<JsonQueryOperatorInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  rows?: InputMaybe<SensaiComponentIndividualTableRowFilterListInput>;
  showTitle?: InputMaybe<BooleanQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiTablesGroupConnection = {
  __typename?: 'SENSAITablesGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiTablesEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiTablesGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiTables>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiTablesGroupConnectionDistinctArgs = {
  field: SensaiTablesFieldSelector;
};


export type SensaiTablesGroupConnectionGroupArgs = {
  field: SensaiTablesFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiTablesGroupConnectionMaxArgs = {
  field: SensaiTablesFieldSelector;
};


export type SensaiTablesGroupConnectionMinArgs = {
  field: SensaiTablesFieldSelector;
};


export type SensaiTablesGroupConnectionSumArgs = {
  field: SensaiTablesFieldSelector;
};

export type SensaiTablesSortInput = {
  children?: InputMaybe<NodeSortInput>;
  columns?: InputMaybe<SensaiComponentIndividualTableColumnSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  published_at?: InputMaybe<SortOrderEnum>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  rows?: InputMaybe<SensaiComponentIndividualTableRowSortInput>;
  showTitle?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiTestimonials = Node & {
  __typename?: 'SENSAITestimonials';
  children: Array<Node>;
  columns?: Maybe<Array<Maybe<SensaiComponentIndividualTestimonial>>>;
  created_at: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  remoteId: Scalars['ID']['output'];
  remoteTypeName: Scalars['String']['output'];
  updated_at: Scalars['JSON']['output'];
};

export type SensaiTestimonialsConnection = {
  __typename?: 'SENSAITestimonialsConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiTestimonialsEdge>;
  group: Array<SensaiTestimonialsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiTestimonials>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiTestimonialsConnectionDistinctArgs = {
  field: SensaiTestimonialsFieldSelector;
};


export type SensaiTestimonialsConnectionGroupArgs = {
  field: SensaiTestimonialsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiTestimonialsConnectionMaxArgs = {
  field: SensaiTestimonialsFieldSelector;
};


export type SensaiTestimonialsConnectionMinArgs = {
  field: SensaiTestimonialsFieldSelector;
};


export type SensaiTestimonialsConnectionSumArgs = {
  field: SensaiTestimonialsFieldSelector;
};

export type SensaiTestimonialsEdge = {
  __typename?: 'SENSAITestimonialsEdge';
  next?: Maybe<SensaiTestimonials>;
  node: SensaiTestimonials;
  previous?: Maybe<SensaiTestimonials>;
};

export type SensaiTestimonialsFieldSelector = {
  children?: InputMaybe<NodeFieldSelector>;
  columns?: InputMaybe<SensaiComponentIndividualTestimonialFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  remoteId?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiTestimonialsFilterInput = {
  children?: InputMaybe<NodeFilterListInput>;
  columns?: InputMaybe<SensaiComponentIndividualTestimonialFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  remoteId?: InputMaybe<IdQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
};

export type SensaiTestimonialsGroupConnection = {
  __typename?: 'SENSAITestimonialsGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiTestimonialsEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiTestimonialsGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiTestimonials>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiTestimonialsGroupConnectionDistinctArgs = {
  field: SensaiTestimonialsFieldSelector;
};


export type SensaiTestimonialsGroupConnectionGroupArgs = {
  field: SensaiTestimonialsFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiTestimonialsGroupConnectionMaxArgs = {
  field: SensaiTestimonialsFieldSelector;
};


export type SensaiTestimonialsGroupConnectionMinArgs = {
  field: SensaiTestimonialsFieldSelector;
};


export type SensaiTestimonialsGroupConnectionSumArgs = {
  field: SensaiTestimonialsFieldSelector;
};

export type SensaiTestimonialsSortInput = {
  children?: InputMaybe<NodeSortInput>;
  columns?: InputMaybe<SensaiComponentIndividualTestimonialSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  remoteId?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SensaiUploadFile = Node & {
  __typename?: 'SENSAIUploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  children: Array<Node>;
  created_at: Scalars['JSON']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  imageFile?: Maybe<File>;
  internal: Internal;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Node>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  remoteTypeName: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  updated_at: Scalars['JSON']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type SensaiUploadFileConnection = {
  __typename?: 'SENSAIUploadFileConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiUploadFileEdge>;
  group: Array<SensaiUploadFileGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiUploadFile>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiUploadFileConnectionDistinctArgs = {
  field: SensaiUploadFileFieldSelector;
};


export type SensaiUploadFileConnectionGroupArgs = {
  field: SensaiUploadFileFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiUploadFileConnectionMaxArgs = {
  field: SensaiUploadFileFieldSelector;
};


export type SensaiUploadFileConnectionMinArgs = {
  field: SensaiUploadFileFieldSelector;
};


export type SensaiUploadFileConnectionSumArgs = {
  field: SensaiUploadFileFieldSelector;
};

export type SensaiUploadFileEdge = {
  __typename?: 'SENSAIUploadFileEdge';
  next?: Maybe<SensaiUploadFile>;
  node: SensaiUploadFile;
  previous?: Maybe<SensaiUploadFile>;
};

export type SensaiUploadFileFieldSelector = {
  alternativeText?: InputMaybe<FieldSelectorEnum>;
  caption?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  created_at?: InputMaybe<FieldSelectorEnum>;
  created_by?: InputMaybe<FieldSelectorEnum>;
  ext?: InputMaybe<FieldSelectorEnum>;
  formats?: InputMaybe<FieldSelectorEnum>;
  hash?: InputMaybe<FieldSelectorEnum>;
  height?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  imageFile?: InputMaybe<FileFieldSelector>;
  internal?: InputMaybe<InternalFieldSelector>;
  mime?: InputMaybe<FieldSelectorEnum>;
  name?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  previewUrl?: InputMaybe<FieldSelectorEnum>;
  provider?: InputMaybe<FieldSelectorEnum>;
  provider_metadata?: InputMaybe<FieldSelectorEnum>;
  remoteTypeName?: InputMaybe<FieldSelectorEnum>;
  size?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
  updated_by?: InputMaybe<FieldSelectorEnum>;
  url?: InputMaybe<FieldSelectorEnum>;
  width?: InputMaybe<FieldSelectorEnum>;
};

export type SensaiUploadFileFilterInput = {
  alternativeText?: InputMaybe<StringQueryOperatorInput>;
  caption?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created_at?: InputMaybe<JsonQueryOperatorInput>;
  created_by?: InputMaybe<StringQueryOperatorInput>;
  ext?: InputMaybe<StringQueryOperatorInput>;
  formats?: InputMaybe<JsonQueryOperatorInput>;
  hash?: InputMaybe<StringQueryOperatorInput>;
  height?: InputMaybe<IntQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  imageFile?: InputMaybe<FileFilterInput>;
  internal?: InputMaybe<InternalFilterInput>;
  mime?: InputMaybe<StringQueryOperatorInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  previewUrl?: InputMaybe<StringQueryOperatorInput>;
  provider?: InputMaybe<StringQueryOperatorInput>;
  provider_metadata?: InputMaybe<JsonQueryOperatorInput>;
  remoteTypeName?: InputMaybe<StringQueryOperatorInput>;
  size?: InputMaybe<FloatQueryOperatorInput>;
  updated_at?: InputMaybe<JsonQueryOperatorInput>;
  updated_by?: InputMaybe<StringQueryOperatorInput>;
  url?: InputMaybe<StringQueryOperatorInput>;
  width?: InputMaybe<IntQueryOperatorInput>;
};

export type SensaiUploadFileFilterListInput = {
  elemMatch?: InputMaybe<SensaiUploadFileFilterInput>;
};

export type SensaiUploadFileGroupConnection = {
  __typename?: 'SENSAIUploadFileGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SensaiUploadFileEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SensaiUploadFileGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SensaiUploadFile>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SensaiUploadFileGroupConnectionDistinctArgs = {
  field: SensaiUploadFileFieldSelector;
};


export type SensaiUploadFileGroupConnectionGroupArgs = {
  field: SensaiUploadFileFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SensaiUploadFileGroupConnectionMaxArgs = {
  field: SensaiUploadFileFieldSelector;
};


export type SensaiUploadFileGroupConnectionMinArgs = {
  field: SensaiUploadFileFieldSelector;
};


export type SensaiUploadFileGroupConnectionSumArgs = {
  field: SensaiUploadFileFieldSelector;
};

export type SensaiUploadFileSortInput = {
  alternativeText?: InputMaybe<SortOrderEnum>;
  caption?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  created_at?: InputMaybe<SortOrderEnum>;
  created_by?: InputMaybe<SortOrderEnum>;
  ext?: InputMaybe<SortOrderEnum>;
  formats?: InputMaybe<SortOrderEnum>;
  hash?: InputMaybe<SortOrderEnum>;
  height?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  imageFile?: InputMaybe<FileSortInput>;
  internal?: InputMaybe<InternalSortInput>;
  mime?: InputMaybe<SortOrderEnum>;
  name?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  previewUrl?: InputMaybe<SortOrderEnum>;
  provider?: InputMaybe<SortOrderEnum>;
  provider_metadata?: InputMaybe<SortOrderEnum>;
  remoteTypeName?: InputMaybe<SortOrderEnum>;
  size?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
  updated_by?: InputMaybe<SortOrderEnum>;
  url?: InputMaybe<SortOrderEnum>;
  width?: InputMaybe<SortOrderEnum>;
};

export type Site = Node & {
  __typename?: 'Site';
  adapter?: Maybe<SiteAdapter>;
  buildTime?: Maybe<Scalars['Date']['output']>;
  children: Array<Node>;
  graphqlTypegen?: Maybe<Scalars['Boolean']['output']>;
  host?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  jsxRuntime?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  pathPrefix?: Maybe<Scalars['String']['output']>;
  polyfill?: Maybe<Scalars['Boolean']['output']>;
  port?: Maybe<Scalars['Int']['output']>;
  siteMetadata?: Maybe<SiteSiteMetadata>;
  trailingSlash?: Maybe<Scalars['String']['output']>;
};


export type SiteBuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SiteAdapter = {
  __typename?: 'SiteAdapter';
  name?: Maybe<Scalars['String']['output']>;
};

export type SiteAdapterFieldSelector = {
  name?: InputMaybe<FieldSelectorEnum>;
};

export type SiteAdapterFilterInput = {
  name?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteAdapterSortInput = {
  name?: InputMaybe<SortOrderEnum>;
};

export type SiteBuildMetadata = Node & {
  __typename?: 'SiteBuildMetadata';
  buildTime?: Maybe<Scalars['Date']['output']>;
  children: Array<Node>;
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
};


export type SiteBuildMetadataBuildTimeArgs = {
  difference?: InputMaybe<Scalars['String']['input']>;
  formatString?: InputMaybe<Scalars['String']['input']>;
  fromNow?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
};

export type SiteBuildMetadataConnection = {
  __typename?: 'SiteBuildMetadataConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SiteBuildMetadataEdge>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SiteBuildMetadataConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionGroupArgs = {
  field: SiteBuildMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteBuildMetadataConnectionMaxArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionMinArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataConnectionSumArgs = {
  field: SiteBuildMetadataFieldSelector;
};

export type SiteBuildMetadataEdge = {
  __typename?: 'SiteBuildMetadataEdge';
  next?: Maybe<SiteBuildMetadata>;
  node: SiteBuildMetadata;
  previous?: Maybe<SiteBuildMetadata>;
};

export type SiteBuildMetadataFieldSelector = {
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
};

export type SiteBuildMetadataFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
};

export type SiteBuildMetadataGroupConnection = {
  __typename?: 'SiteBuildMetadataGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SiteBuildMetadataEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SiteBuildMetadataGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SiteBuildMetadata>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SiteBuildMetadataGroupConnectionDistinctArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionGroupArgs = {
  field: SiteBuildMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteBuildMetadataGroupConnectionMaxArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionMinArgs = {
  field: SiteBuildMetadataFieldSelector;
};


export type SiteBuildMetadataGroupConnectionSumArgs = {
  field: SiteBuildMetadataFieldSelector;
};

export type SiteBuildMetadataSortInput = {
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
};

export type SiteConnection = {
  __typename?: 'SiteConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SiteEdge>;
  group: Array<SiteGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SiteConnectionDistinctArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionGroupArgs = {
  field: SiteFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteConnectionMaxArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionMinArgs = {
  field: SiteFieldSelector;
};


export type SiteConnectionSumArgs = {
  field: SiteFieldSelector;
};

export type SiteEdge = {
  __typename?: 'SiteEdge';
  next?: Maybe<Site>;
  node: Site;
  previous?: Maybe<Site>;
};

export type SiteFieldSelector = {
  adapter?: InputMaybe<SiteAdapterFieldSelector>;
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  graphqlTypegen?: InputMaybe<FieldSelectorEnum>;
  host?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  jsxRuntime?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pathPrefix?: InputMaybe<FieldSelectorEnum>;
  polyfill?: InputMaybe<FieldSelectorEnum>;
  port?: InputMaybe<FieldSelectorEnum>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFieldSelector>;
  trailingSlash?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFilterInput = {
  adapter?: InputMaybe<SiteAdapterFilterInput>;
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  graphqlTypegen?: InputMaybe<BooleanQueryOperatorInput>;
  host?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  jsxRuntime?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pathPrefix?: InputMaybe<StringQueryOperatorInput>;
  polyfill?: InputMaybe<BooleanQueryOperatorInput>;
  port?: InputMaybe<IntQueryOperatorInput>;
  siteMetadata?: InputMaybe<SiteSiteMetadataFilterInput>;
  trailingSlash?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunction = Node & {
  __typename?: 'SiteFunction';
  absoluteCompiledFilePath: Scalars['String']['output'];
  children: Array<Node>;
  functionRoute: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  internal: Internal;
  matchPath?: Maybe<Scalars['String']['output']>;
  originalAbsoluteFilePath: Scalars['String']['output'];
  originalRelativeFilePath: Scalars['String']['output'];
  parent?: Maybe<Node>;
  pluginName: Scalars['String']['output'];
  relativeCompiledFilePath: Scalars['String']['output'];
};

export type SiteFunctionConnection = {
  __typename?: 'SiteFunctionConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SiteFunctionEdge>;
  group: Array<SiteFunctionGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SiteFunctionConnectionDistinctArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionGroupArgs = {
  field: SiteFunctionFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteFunctionConnectionMaxArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionMinArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionConnectionSumArgs = {
  field: SiteFunctionFieldSelector;
};

export type SiteFunctionEdge = {
  __typename?: 'SiteFunctionEdge';
  next?: Maybe<SiteFunction>;
  node: SiteFunction;
  previous?: Maybe<SiteFunction>;
};

export type SiteFunctionFieldSelector = {
  absoluteCompiledFilePath?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  functionRoute?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  matchPath?: InputMaybe<FieldSelectorEnum>;
  originalAbsoluteFilePath?: InputMaybe<FieldSelectorEnum>;
  originalRelativeFilePath?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pluginName?: InputMaybe<FieldSelectorEnum>;
  relativeCompiledFilePath?: InputMaybe<FieldSelectorEnum>;
};

export type SiteFunctionFilterInput = {
  absoluteCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  functionRoute?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  originalAbsoluteFilePath?: InputMaybe<StringQueryOperatorInput>;
  originalRelativeFilePath?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginName?: InputMaybe<StringQueryOperatorInput>;
  relativeCompiledFilePath?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteFunctionGroupConnection = {
  __typename?: 'SiteFunctionGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SiteFunctionEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SiteFunctionGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SiteFunction>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SiteFunctionGroupConnectionDistinctArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionGroupArgs = {
  field: SiteFunctionFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteFunctionGroupConnectionMaxArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionMinArgs = {
  field: SiteFunctionFieldSelector;
};


export type SiteFunctionGroupConnectionSumArgs = {
  field: SiteFunctionFieldSelector;
};

export type SiteFunctionSortInput = {
  absoluteCompiledFilePath?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  functionRoute?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  matchPath?: InputMaybe<SortOrderEnum>;
  originalAbsoluteFilePath?: InputMaybe<SortOrderEnum>;
  originalRelativeFilePath?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pluginName?: InputMaybe<SortOrderEnum>;
  relativeCompiledFilePath?: InputMaybe<SortOrderEnum>;
};

export type SiteGroupConnection = {
  __typename?: 'SiteGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SiteEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SiteGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<Site>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SiteGroupConnectionDistinctArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionGroupArgs = {
  field: SiteFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SiteGroupConnectionMaxArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionMinArgs = {
  field: SiteFieldSelector;
};


export type SiteGroupConnectionSumArgs = {
  field: SiteFieldSelector;
};

export type SitePage = Node & {
  __typename?: 'SitePage';
  buildTime?: Maybe<Scalars['Date']['output']>;
  children: Array<Node>;
  component: Scalars['String']['output'];
  componentChunkName: Scalars['String']['output'];
  context?: Maybe<SitePageContext>;
  id: Scalars['ID']['output'];
  internal: Internal;
  internalComponentName: Scalars['String']['output'];
  matchPath?: Maybe<Scalars['String']['output']>;
  pageContext?: Maybe<Scalars['JSON']['output']>;
  parent?: Maybe<Node>;
  path?: Maybe<Scalars['String']['output']>;
  pluginCreator?: Maybe<SitePlugin>;
};

export type SitePageConnection = {
  __typename?: 'SitePageConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SitePageEdge>;
  group: Array<SitePageGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SitePageConnectionDistinctArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionGroupArgs = {
  field: SitePageFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SitePageConnectionMaxArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionMinArgs = {
  field: SitePageFieldSelector;
};


export type SitePageConnectionSumArgs = {
  field: SitePageFieldSelector;
};

export type SitePageContext = {
  __typename?: 'SitePageContext';
  isLandingPage?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['Date']['output']>;
};

export type SitePageContextFieldSelector = {
  isLandingPage?: InputMaybe<FieldSelectorEnum>;
  updated_at?: InputMaybe<FieldSelectorEnum>;
};

export type SitePageContextFilterInput = {
  isLandingPage?: InputMaybe<BooleanQueryOperatorInput>;
  updated_at?: InputMaybe<DateQueryOperatorInput>;
};

export type SitePageContextSortInput = {
  isLandingPage?: InputMaybe<SortOrderEnum>;
  updated_at?: InputMaybe<SortOrderEnum>;
};

export type SitePageEdge = {
  __typename?: 'SitePageEdge';
  next?: Maybe<SitePage>;
  node: SitePage;
  previous?: Maybe<SitePage>;
};

export type SitePageFieldSelector = {
  buildTime?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  component?: InputMaybe<FieldSelectorEnum>;
  componentChunkName?: InputMaybe<FieldSelectorEnum>;
  context?: InputMaybe<SitePageContextFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  internalComponentName?: InputMaybe<FieldSelectorEnum>;
  matchPath?: InputMaybe<FieldSelectorEnum>;
  pageContext?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  path?: InputMaybe<FieldSelectorEnum>;
  pluginCreator?: InputMaybe<SitePluginFieldSelector>;
};

export type SitePageFilterInput = {
  buildTime?: InputMaybe<DateQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  component?: InputMaybe<StringQueryOperatorInput>;
  componentChunkName?: InputMaybe<StringQueryOperatorInput>;
  context?: InputMaybe<SitePageContextFilterInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  internalComponentName?: InputMaybe<StringQueryOperatorInput>;
  matchPath?: InputMaybe<StringQueryOperatorInput>;
  pageContext?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  path?: InputMaybe<StringQueryOperatorInput>;
  pluginCreator?: InputMaybe<SitePluginFilterInput>;
};

export type SitePageGroupConnection = {
  __typename?: 'SitePageGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SitePageEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SitePageGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SitePage>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SitePageGroupConnectionDistinctArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionGroupArgs = {
  field: SitePageFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SitePageGroupConnectionMaxArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionMinArgs = {
  field: SitePageFieldSelector;
};


export type SitePageGroupConnectionSumArgs = {
  field: SitePageFieldSelector;
};

export type SitePageSortInput = {
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  component?: InputMaybe<SortOrderEnum>;
  componentChunkName?: InputMaybe<SortOrderEnum>;
  context?: InputMaybe<SitePageContextSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  internalComponentName?: InputMaybe<SortOrderEnum>;
  matchPath?: InputMaybe<SortOrderEnum>;
  pageContext?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  path?: InputMaybe<SortOrderEnum>;
  pluginCreator?: InputMaybe<SitePluginSortInput>;
};

export type SitePlugin = Node & {
  __typename?: 'SitePlugin';
  browserAPIs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  children: Array<Node>;
  id: Scalars['ID']['output'];
  internal: Internal;
  name?: Maybe<Scalars['String']['output']>;
  nodeAPIs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  packageJson?: Maybe<Scalars['JSON']['output']>;
  parent?: Maybe<Node>;
  pluginFilepath?: Maybe<Scalars['String']['output']>;
  pluginOptions?: Maybe<Scalars['JSON']['output']>;
  resolve?: Maybe<Scalars['String']['output']>;
  ssrAPIs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  version?: Maybe<Scalars['String']['output']>;
};

export type SitePluginConnection = {
  __typename?: 'SitePluginConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SitePluginEdge>;
  group: Array<SitePluginGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SitePluginConnectionDistinctArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionGroupArgs = {
  field: SitePluginFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SitePluginConnectionMaxArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionMinArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginConnectionSumArgs = {
  field: SitePluginFieldSelector;
};

export type SitePluginEdge = {
  __typename?: 'SitePluginEdge';
  next?: Maybe<SitePlugin>;
  node: SitePlugin;
  previous?: Maybe<SitePlugin>;
};

export type SitePluginFieldSelector = {
  browserAPIs?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  nodeAPIs?: InputMaybe<FieldSelectorEnum>;
  packageJson?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  pluginFilepath?: InputMaybe<FieldSelectorEnum>;
  pluginOptions?: InputMaybe<FieldSelectorEnum>;
  resolve?: InputMaybe<FieldSelectorEnum>;
  ssrAPIs?: InputMaybe<FieldSelectorEnum>;
  version?: InputMaybe<FieldSelectorEnum>;
};

export type SitePluginFilterInput = {
  browserAPIs?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  nodeAPIs?: InputMaybe<StringQueryOperatorInput>;
  packageJson?: InputMaybe<JsonQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  pluginFilepath?: InputMaybe<StringQueryOperatorInput>;
  pluginOptions?: InputMaybe<JsonQueryOperatorInput>;
  resolve?: InputMaybe<StringQueryOperatorInput>;
  ssrAPIs?: InputMaybe<StringQueryOperatorInput>;
  version?: InputMaybe<StringQueryOperatorInput>;
};

export type SitePluginGroupConnection = {
  __typename?: 'SitePluginGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<SitePluginEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<SitePluginGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<SitePlugin>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type SitePluginGroupConnectionDistinctArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionGroupArgs = {
  field: SitePluginFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type SitePluginGroupConnectionMaxArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionMinArgs = {
  field: SitePluginFieldSelector;
};


export type SitePluginGroupConnectionSumArgs = {
  field: SitePluginFieldSelector;
};

export type SitePluginSortInput = {
  browserAPIs?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  nodeAPIs?: InputMaybe<SortOrderEnum>;
  packageJson?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pluginFilepath?: InputMaybe<SortOrderEnum>;
  pluginOptions?: InputMaybe<SortOrderEnum>;
  resolve?: InputMaybe<SortOrderEnum>;
  ssrAPIs?: InputMaybe<SortOrderEnum>;
  version?: InputMaybe<SortOrderEnum>;
};

export type SiteSiteMetadata = {
  __typename?: 'SiteSiteMetadata';
  author?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  serverUrl?: Maybe<Scalars['String']['output']>;
  siteUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleTemplate?: Maybe<Scalars['String']['output']>;
};

export type SiteSiteMetadataFieldSelector = {
  author?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  image?: InputMaybe<FieldSelectorEnum>;
  serverUrl?: InputMaybe<FieldSelectorEnum>;
  siteUrl?: InputMaybe<FieldSelectorEnum>;
  title?: InputMaybe<FieldSelectorEnum>;
  titleTemplate?: InputMaybe<FieldSelectorEnum>;
};

export type SiteSiteMetadataFilterInput = {
  author?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  image?: InputMaybe<StringQueryOperatorInput>;
  serverUrl?: InputMaybe<StringQueryOperatorInput>;
  siteUrl?: InputMaybe<StringQueryOperatorInput>;
  title?: InputMaybe<StringQueryOperatorInput>;
  titleTemplate?: InputMaybe<StringQueryOperatorInput>;
};

export type SiteSiteMetadataSortInput = {
  author?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  image?: InputMaybe<SortOrderEnum>;
  serverUrl?: InputMaybe<SortOrderEnum>;
  siteUrl?: InputMaybe<SortOrderEnum>;
  title?: InputMaybe<SortOrderEnum>;
  titleTemplate?: InputMaybe<SortOrderEnum>;
};

export type SiteSortInput = {
  adapter?: InputMaybe<SiteAdapterSortInput>;
  buildTime?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  graphqlTypegen?: InputMaybe<SortOrderEnum>;
  host?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  jsxRuntime?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  pathPrefix?: InputMaybe<SortOrderEnum>;
  polyfill?: InputMaybe<SortOrderEnum>;
  port?: InputMaybe<SortOrderEnum>;
  siteMetadata?: InputMaybe<SiteSiteMetadataSortInput>;
  trailingSlash?: InputMaybe<SortOrderEnum>;
};

export enum SortOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringQueryOperatorInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  glob?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type StripePrice = Node & {
  __typename?: 'StripePrice';
  active?: Maybe<Scalars['Boolean']['output']>;
  billing_scheme?: Maybe<Scalars['String']['output']>;
  children: Array<Node>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internal: Internal;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  product?: Maybe<StripePriceProduct>;
  recurring?: Maybe<StripePriceRecurring>;
  tax_behavior?: Maybe<Scalars['String']['output']>;
  tiers?: Maybe<Array<Maybe<StripePriceTiers>>>;
  tiers_mode?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
};

export type StripePriceConnection = {
  __typename?: 'StripePriceConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<StripePriceEdge>;
  group: Array<StripePriceGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<StripePrice>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type StripePriceConnectionDistinctArgs = {
  field: StripePriceFieldSelector;
};


export type StripePriceConnectionGroupArgs = {
  field: StripePriceFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StripePriceConnectionMaxArgs = {
  field: StripePriceFieldSelector;
};


export type StripePriceConnectionMinArgs = {
  field: StripePriceFieldSelector;
};


export type StripePriceConnectionSumArgs = {
  field: StripePriceFieldSelector;
};

export type StripePriceEdge = {
  __typename?: 'StripePriceEdge';
  next?: Maybe<StripePrice>;
  node: StripePrice;
  previous?: Maybe<StripePrice>;
};

export type StripePriceFieldSelector = {
  active?: InputMaybe<FieldSelectorEnum>;
  billing_scheme?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  created?: InputMaybe<FieldSelectorEnum>;
  currency?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  livemode?: InputMaybe<FieldSelectorEnum>;
  nickname?: InputMaybe<FieldSelectorEnum>;
  object?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  product?: InputMaybe<StripePriceProductFieldSelector>;
  recurring?: InputMaybe<StripePriceRecurringFieldSelector>;
  tax_behavior?: InputMaybe<FieldSelectorEnum>;
  tiers?: InputMaybe<StripePriceTiersFieldSelector>;
  tiers_mode?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
  unit_amount?: InputMaybe<FieldSelectorEnum>;
  unit_amount_decimal?: InputMaybe<FieldSelectorEnum>;
};

export type StripePriceFilterInput = {
  active?: InputMaybe<BooleanQueryOperatorInput>;
  billing_scheme?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created?: InputMaybe<IntQueryOperatorInput>;
  currency?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  livemode?: InputMaybe<BooleanQueryOperatorInput>;
  nickname?: InputMaybe<StringQueryOperatorInput>;
  object?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  product?: InputMaybe<StripePriceProductFilterInput>;
  recurring?: InputMaybe<StripePriceRecurringFilterInput>;
  tax_behavior?: InputMaybe<StringQueryOperatorInput>;
  tiers?: InputMaybe<StripePriceTiersFilterListInput>;
  tiers_mode?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  unit_amount?: InputMaybe<IntQueryOperatorInput>;
  unit_amount_decimal?: InputMaybe<StringQueryOperatorInput>;
};

export type StripePriceGroupConnection = {
  __typename?: 'StripePriceGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<StripePriceEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<StripePriceGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<StripePrice>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type StripePriceGroupConnectionDistinctArgs = {
  field: StripePriceFieldSelector;
};


export type StripePriceGroupConnectionGroupArgs = {
  field: StripePriceFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StripePriceGroupConnectionMaxArgs = {
  field: StripePriceFieldSelector;
};


export type StripePriceGroupConnectionMinArgs = {
  field: StripePriceFieldSelector;
};


export type StripePriceGroupConnectionSumArgs = {
  field: StripePriceFieldSelector;
};

export type StripePriceProduct = {
  __typename?: 'StripePriceProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  default_price?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<StripePriceProductMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type StripePriceProductFieldSelector = {
  active?: InputMaybe<FieldSelectorEnum>;
  created?: InputMaybe<FieldSelectorEnum>;
  default_price?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  images?: InputMaybe<FieldSelectorEnum>;
  livemode?: InputMaybe<FieldSelectorEnum>;
  metadata?: InputMaybe<StripePriceProductMetadataFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  object?: InputMaybe<FieldSelectorEnum>;
  type?: InputMaybe<FieldSelectorEnum>;
  updated?: InputMaybe<FieldSelectorEnum>;
};

export type StripePriceProductFilterInput = {
  active?: InputMaybe<BooleanQueryOperatorInput>;
  created?: InputMaybe<IntQueryOperatorInput>;
  default_price?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  images?: InputMaybe<StringQueryOperatorInput>;
  livemode?: InputMaybe<BooleanQueryOperatorInput>;
  metadata?: InputMaybe<StripePriceProductMetadataFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  object?: InputMaybe<StringQueryOperatorInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  updated?: InputMaybe<IntQueryOperatorInput>;
};

export type StripePriceProductMetadata = Node & {
  __typename?: 'StripePriceProductMetadata';
  NUM_PERIOD_NO_LIMIT?: Maybe<Scalars['String']['output']>;
  NUM_PERIOD_UPFRONT?: Maybe<Scalars['String']['output']>;
  NUM_PER_PERIOD_INCLUDED?: Maybe<Scalars['String']['output']>;
  SKU?: Maybe<Scalars['String']['output']>;
  accountRequired?: Maybe<Scalars['String']['output']>;
  avataxCode?: Maybe<Scalars['String']['output']>;
  bladeSKU?: Maybe<Scalars['String']['output']>;
  children: Array<Node>;
  id: Scalars['ID']['output'];
  internal: Internal;
  parent?: Maybe<Node>;
  shippingPercent?: Maybe<Scalars['String']['output']>;
  shippingRequired?: Maybe<Scalars['String']['output']>;
  trial_days?: Maybe<Scalars['String']['output']>;
};

export type StripePriceProductMetadataConnection = {
  __typename?: 'StripePriceProductMetadataConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<StripePriceProductMetadataEdge>;
  group: Array<StripePriceProductMetadataGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<StripePriceProductMetadata>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type StripePriceProductMetadataConnectionDistinctArgs = {
  field: StripePriceProductMetadataFieldSelector;
};


export type StripePriceProductMetadataConnectionGroupArgs = {
  field: StripePriceProductMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StripePriceProductMetadataConnectionMaxArgs = {
  field: StripePriceProductMetadataFieldSelector;
};


export type StripePriceProductMetadataConnectionMinArgs = {
  field: StripePriceProductMetadataFieldSelector;
};


export type StripePriceProductMetadataConnectionSumArgs = {
  field: StripePriceProductMetadataFieldSelector;
};

export type StripePriceProductMetadataEdge = {
  __typename?: 'StripePriceProductMetadataEdge';
  next?: Maybe<StripePriceProductMetadata>;
  node: StripePriceProductMetadata;
  previous?: Maybe<StripePriceProductMetadata>;
};

export type StripePriceProductMetadataFieldSelector = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<FieldSelectorEnum>;
  NUM_PERIOD_UPFRONT?: InputMaybe<FieldSelectorEnum>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<FieldSelectorEnum>;
  SKU?: InputMaybe<FieldSelectorEnum>;
  accountRequired?: InputMaybe<FieldSelectorEnum>;
  avataxCode?: InputMaybe<FieldSelectorEnum>;
  bladeSKU?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  id?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  parent?: InputMaybe<NodeFieldSelector>;
  shippingPercent?: InputMaybe<FieldSelectorEnum>;
  shippingRequired?: InputMaybe<FieldSelectorEnum>;
  trial_days?: InputMaybe<FieldSelectorEnum>;
};

export type StripePriceProductMetadataFilterInput = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<StringQueryOperatorInput>;
  NUM_PERIOD_UPFRONT?: InputMaybe<StringQueryOperatorInput>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<StringQueryOperatorInput>;
  SKU?: InputMaybe<StringQueryOperatorInput>;
  accountRequired?: InputMaybe<StringQueryOperatorInput>;
  avataxCode?: InputMaybe<StringQueryOperatorInput>;
  bladeSKU?: InputMaybe<StringQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  parent?: InputMaybe<NodeFilterInput>;
  shippingPercent?: InputMaybe<StringQueryOperatorInput>;
  shippingRequired?: InputMaybe<StringQueryOperatorInput>;
  trial_days?: InputMaybe<StringQueryOperatorInput>;
};

export type StripePriceProductMetadataGroupConnection = {
  __typename?: 'StripePriceProductMetadataGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<StripePriceProductMetadataEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<StripePriceProductMetadataGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<StripePriceProductMetadata>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type StripePriceProductMetadataGroupConnectionDistinctArgs = {
  field: StripePriceProductMetadataFieldSelector;
};


export type StripePriceProductMetadataGroupConnectionGroupArgs = {
  field: StripePriceProductMetadataFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StripePriceProductMetadataGroupConnectionMaxArgs = {
  field: StripePriceProductMetadataFieldSelector;
};


export type StripePriceProductMetadataGroupConnectionMinArgs = {
  field: StripePriceProductMetadataFieldSelector;
};


export type StripePriceProductMetadataGroupConnectionSumArgs = {
  field: StripePriceProductMetadataFieldSelector;
};

export type StripePriceProductMetadataSortInput = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<SortOrderEnum>;
  NUM_PERIOD_UPFRONT?: InputMaybe<SortOrderEnum>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<SortOrderEnum>;
  SKU?: InputMaybe<SortOrderEnum>;
  accountRequired?: InputMaybe<SortOrderEnum>;
  avataxCode?: InputMaybe<SortOrderEnum>;
  bladeSKU?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  parent?: InputMaybe<NodeSortInput>;
  shippingPercent?: InputMaybe<SortOrderEnum>;
  shippingRequired?: InputMaybe<SortOrderEnum>;
  trial_days?: InputMaybe<SortOrderEnum>;
};

export type StripePriceProductSortInput = {
  active?: InputMaybe<SortOrderEnum>;
  created?: InputMaybe<SortOrderEnum>;
  default_price?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  images?: InputMaybe<SortOrderEnum>;
  livemode?: InputMaybe<SortOrderEnum>;
  metadata?: InputMaybe<StripePriceProductMetadataSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  object?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
  updated?: InputMaybe<SortOrderEnum>;
};

export type StripePriceRecurring = {
  __typename?: 'StripePriceRecurring';
  interval?: Maybe<Scalars['String']['output']>;
  interval_count?: Maybe<Scalars['Int']['output']>;
  meter?: Maybe<Scalars['String']['output']>;
  usage_type?: Maybe<Scalars['String']['output']>;
};

export type StripePriceRecurringFieldSelector = {
  interval?: InputMaybe<FieldSelectorEnum>;
  interval_count?: InputMaybe<FieldSelectorEnum>;
  meter?: InputMaybe<FieldSelectorEnum>;
  usage_type?: InputMaybe<FieldSelectorEnum>;
};

export type StripePriceRecurringFilterInput = {
  interval?: InputMaybe<StringQueryOperatorInput>;
  interval_count?: InputMaybe<IntQueryOperatorInput>;
  meter?: InputMaybe<StringQueryOperatorInput>;
  usage_type?: InputMaybe<StringQueryOperatorInput>;
};

export type StripePriceRecurringSortInput = {
  interval?: InputMaybe<SortOrderEnum>;
  interval_count?: InputMaybe<SortOrderEnum>;
  meter?: InputMaybe<SortOrderEnum>;
  usage_type?: InputMaybe<SortOrderEnum>;
};

export type StripePriceSortInput = {
  active?: InputMaybe<SortOrderEnum>;
  billing_scheme?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  created?: InputMaybe<SortOrderEnum>;
  currency?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  livemode?: InputMaybe<SortOrderEnum>;
  nickname?: InputMaybe<SortOrderEnum>;
  object?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  product?: InputMaybe<StripePriceProductSortInput>;
  recurring?: InputMaybe<StripePriceRecurringSortInput>;
  tax_behavior?: InputMaybe<SortOrderEnum>;
  tiers?: InputMaybe<StripePriceTiersSortInput>;
  tiers_mode?: InputMaybe<SortOrderEnum>;
  type?: InputMaybe<SortOrderEnum>;
  unit_amount?: InputMaybe<SortOrderEnum>;
  unit_amount_decimal?: InputMaybe<SortOrderEnum>;
};

export type StripePriceTiers = {
  __typename?: 'StripePriceTiers';
  unit_amount?: Maybe<Scalars['Int']['output']>;
  unit_amount_decimal?: Maybe<Scalars['String']['output']>;
  up_to?: Maybe<Scalars['Int']['output']>;
};

export type StripePriceTiersFieldSelector = {
  unit_amount?: InputMaybe<FieldSelectorEnum>;
  unit_amount_decimal?: InputMaybe<FieldSelectorEnum>;
  up_to?: InputMaybe<FieldSelectorEnum>;
};

export type StripePriceTiersFilterInput = {
  unit_amount?: InputMaybe<IntQueryOperatorInput>;
  unit_amount_decimal?: InputMaybe<StringQueryOperatorInput>;
  up_to?: InputMaybe<IntQueryOperatorInput>;
};

export type StripePriceTiersFilterListInput = {
  elemMatch?: InputMaybe<StripePriceTiersFilterInput>;
};

export type StripePriceTiersSortInput = {
  unit_amount?: InputMaybe<SortOrderEnum>;
  unit_amount_decimal?: InputMaybe<SortOrderEnum>;
  up_to?: InputMaybe<SortOrderEnum>;
};

export type StripeProduct = Node & {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  children: Array<Node>;
  created?: Maybe<Scalars['Int']['output']>;
  default_price?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  internal: Internal;
  livemode?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<StripeProductMetadata>;
  name?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Node>;
  type?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type StripeProductConnection = {
  __typename?: 'StripeProductConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<StripeProductEdge>;
  group: Array<StripeProductGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<StripeProduct>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type StripeProductConnectionDistinctArgs = {
  field: StripeProductFieldSelector;
};


export type StripeProductConnectionGroupArgs = {
  field: StripeProductFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StripeProductConnectionMaxArgs = {
  field: StripeProductFieldSelector;
};


export type StripeProductConnectionMinArgs = {
  field: StripeProductFieldSelector;
};


export type StripeProductConnectionSumArgs = {
  field: StripeProductFieldSelector;
};

export type StripeProductEdge = {
  __typename?: 'StripeProductEdge';
  next?: Maybe<StripeProduct>;
  node: StripeProduct;
  previous?: Maybe<StripeProduct>;
};

export type StripeProductFieldSelector = {
  active?: InputMaybe<FieldSelectorEnum>;
  children?: InputMaybe<NodeFieldSelector>;
  created?: InputMaybe<FieldSelectorEnum>;
  default_price?: InputMaybe<FieldSelectorEnum>;
  description?: InputMaybe<FieldSelectorEnum>;
  id?: InputMaybe<FieldSelectorEnum>;
  images?: InputMaybe<FieldSelectorEnum>;
  internal?: InputMaybe<InternalFieldSelector>;
  livemode?: InputMaybe<FieldSelectorEnum>;
  metadata?: InputMaybe<StripeProductMetadataFieldSelector>;
  name?: InputMaybe<FieldSelectorEnum>;
  object?: InputMaybe<FieldSelectorEnum>;
  parent?: InputMaybe<NodeFieldSelector>;
  type?: InputMaybe<FieldSelectorEnum>;
  updated?: InputMaybe<FieldSelectorEnum>;
};

export type StripeProductFilterInput = {
  active?: InputMaybe<BooleanQueryOperatorInput>;
  children?: InputMaybe<NodeFilterListInput>;
  created?: InputMaybe<IntQueryOperatorInput>;
  default_price?: InputMaybe<StringQueryOperatorInput>;
  description?: InputMaybe<StringQueryOperatorInput>;
  id?: InputMaybe<StringQueryOperatorInput>;
  images?: InputMaybe<StringQueryOperatorInput>;
  internal?: InputMaybe<InternalFilterInput>;
  livemode?: InputMaybe<BooleanQueryOperatorInput>;
  metadata?: InputMaybe<StripeProductMetadataFilterInput>;
  name?: InputMaybe<StringQueryOperatorInput>;
  object?: InputMaybe<StringQueryOperatorInput>;
  parent?: InputMaybe<NodeFilterInput>;
  type?: InputMaybe<StringQueryOperatorInput>;
  updated?: InputMaybe<IntQueryOperatorInput>;
};

export type StripeProductGroupConnection = {
  __typename?: 'StripeProductGroupConnection';
  distinct: Array<Scalars['String']['output']>;
  edges: Array<StripeProductEdge>;
  field: Scalars['String']['output'];
  fieldValue?: Maybe<Scalars['String']['output']>;
  group: Array<StripeProductGroupConnection>;
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  nodes: Array<StripeProduct>;
  pageInfo: PageInfo;
  sum?: Maybe<Scalars['Float']['output']>;
  totalCount: Scalars['Int']['output'];
};


export type StripeProductGroupConnectionDistinctArgs = {
  field: StripeProductFieldSelector;
};


export type StripeProductGroupConnectionGroupArgs = {
  field: StripeProductFieldSelector;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type StripeProductGroupConnectionMaxArgs = {
  field: StripeProductFieldSelector;
};


export type StripeProductGroupConnectionMinArgs = {
  field: StripeProductFieldSelector;
};


export type StripeProductGroupConnectionSumArgs = {
  field: StripeProductFieldSelector;
};

export type StripeProductMetadata = {
  __typename?: 'StripeProductMetadata';
  NUM_PERIOD_NO_LIMIT?: Maybe<Scalars['String']['output']>;
  NUM_PERIOD_UPFRONT?: Maybe<Scalars['String']['output']>;
  NUM_PER_PERIOD_INCLUDED?: Maybe<Scalars['String']['output']>;
  SKU?: Maybe<Scalars['String']['output']>;
  accountRequired?: Maybe<Scalars['String']['output']>;
  avataxCode?: Maybe<Scalars['String']['output']>;
  bladeSKU?: Maybe<Scalars['String']['output']>;
  shippingPercent?: Maybe<Scalars['String']['output']>;
  shippingRequired?: Maybe<Scalars['String']['output']>;
  trial_days?: Maybe<Scalars['String']['output']>;
};

export type StripeProductMetadataFieldSelector = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<FieldSelectorEnum>;
  NUM_PERIOD_UPFRONT?: InputMaybe<FieldSelectorEnum>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<FieldSelectorEnum>;
  SKU?: InputMaybe<FieldSelectorEnum>;
  accountRequired?: InputMaybe<FieldSelectorEnum>;
  avataxCode?: InputMaybe<FieldSelectorEnum>;
  bladeSKU?: InputMaybe<FieldSelectorEnum>;
  shippingPercent?: InputMaybe<FieldSelectorEnum>;
  shippingRequired?: InputMaybe<FieldSelectorEnum>;
  trial_days?: InputMaybe<FieldSelectorEnum>;
};

export type StripeProductMetadataFilterInput = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<StringQueryOperatorInput>;
  NUM_PERIOD_UPFRONT?: InputMaybe<StringQueryOperatorInput>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<StringQueryOperatorInput>;
  SKU?: InputMaybe<StringQueryOperatorInput>;
  accountRequired?: InputMaybe<StringQueryOperatorInput>;
  avataxCode?: InputMaybe<StringQueryOperatorInput>;
  bladeSKU?: InputMaybe<StringQueryOperatorInput>;
  shippingPercent?: InputMaybe<StringQueryOperatorInput>;
  shippingRequired?: InputMaybe<StringQueryOperatorInput>;
  trial_days?: InputMaybe<StringQueryOperatorInput>;
};

export type StripeProductMetadataSortInput = {
  NUM_PERIOD_NO_LIMIT?: InputMaybe<SortOrderEnum>;
  NUM_PERIOD_UPFRONT?: InputMaybe<SortOrderEnum>;
  NUM_PER_PERIOD_INCLUDED?: InputMaybe<SortOrderEnum>;
  SKU?: InputMaybe<SortOrderEnum>;
  accountRequired?: InputMaybe<SortOrderEnum>;
  avataxCode?: InputMaybe<SortOrderEnum>;
  bladeSKU?: InputMaybe<SortOrderEnum>;
  shippingPercent?: InputMaybe<SortOrderEnum>;
  shippingRequired?: InputMaybe<SortOrderEnum>;
  trial_days?: InputMaybe<SortOrderEnum>;
};

export type StripeProductSortInput = {
  active?: InputMaybe<SortOrderEnum>;
  children?: InputMaybe<NodeSortInput>;
  created?: InputMaybe<SortOrderEnum>;
  default_price?: InputMaybe<SortOrderEnum>;
  description?: InputMaybe<SortOrderEnum>;
  id?: InputMaybe<SortOrderEnum>;
  images?: InputMaybe<SortOrderEnum>;
  internal?: InputMaybe<InternalSortInput>;
  livemode?: InputMaybe<SortOrderEnum>;
  metadata?: InputMaybe<StripeProductMetadataSortInput>;
  name?: InputMaybe<SortOrderEnum>;
  object?: InputMaybe<SortOrderEnum>;
  parent?: InputMaybe<NodeSortInput>;
  type?: InputMaybe<SortOrderEnum>;
  updated?: InputMaybe<SortOrderEnum>;
};

export type TransformOptions = {
  cropFocus?: InputMaybe<ImageCropFocus>;
  duotone?: InputMaybe<DuotoneGradient>;
  fit?: InputMaybe<ImageFit>;
  grayscale?: InputMaybe<Scalars['Boolean']['input']>;
  rotate?: InputMaybe<Scalars['Int']['input']>;
  trim?: InputMaybe<Scalars['Float']['input']>;
};

export type WebPOptions = {
  quality?: InputMaybe<Scalars['Int']['input']>;
};
